"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
exports.messages = {
    "basic_health|ab0": {
        id: "basic_health|ab0",
        defaultMessage: "ABO vércsoport fenotípus"
    },
    "basic_health|ab0_0": {
        id: "basic_health|ab0_0",
        defaultMessage: "0"
    },
    "basic_health|ab0_a": {
        id: "basic_health|ab0_a",
        defaultMessage: "A"
    },
    "basic_health|ab0_ab": {
        id: "basic_health|ab0_ab",
        defaultMessage: "AB"
    },
    "basic_health|ab0_avar": {
        id: "basic_health|ab0_avar",
        defaultMessage: "A variant"
    },
    "basic_health|ab0_b": {
        id: "basic_health|ab0_b",
        defaultMessage: "B"
    },
    "basic_health|ab0_bvar": {
        id: "basic_health|ab0_bvar",
        defaultMessage: "B variant"
    },
    "basic_health|acei": {
        id: "basic_health|acei",
        defaultMessage: "Angiotenzin-konvertáló enzim gátló hatásmechanizmusú anyag"
    },
    "basic_health|adrenalin_or_noradrenalin": {
        id: "basic_health|adrenalin_or_noradrenalin",
        defaultMessage: "Adrenalin vagy noradrenalin"
    },
    "basic_health|allopurinol": {
        id: "basic_health|allopurinol",
        defaultMessage: "Allopurinol (hatóanyag)"
    },
    "basic_health|anamnestic_alcohol_abuse": {
        id: "basic_health|anamnestic_alcohol_abuse",
        defaultMessage: "Anamnézisben szereplő alkoholfüggőség"
    },
    "basic_health|antiarrhythmic_agent": {
        id: "basic_health|antiarrhythmic_agent",
        defaultMessage: "Antiaritmiás szer (hatóanyag)"
    },
    "basic_health|antibiotic": {
        id: "basic_health|antibiotic",
        defaultMessage: "Antibiotikus kezelés (eljárás)"
    },
    "basic_health|anticoagulant": {
        id: "basic_health|anticoagulant",
        defaultMessage: "Antikoaguláns (hatóanyag)"
    },
    "basic_health|arb": {
        id: "basic_health|arb",
        defaultMessage: "Angiotenzin II receptor antagonista hatásmechanizmusú anyag"
    },
    "basic_health|arni": {
        id: "basic_health|arni",
        defaultMessage: "Csak sacubitril és valsartan tartalmú készítmény (gyógyszer)"
    },
    "basic_health|bbl": {
        id: "basic_health|bbl",
        defaultMessage: "Béta adrenerg receptor antagonista hatásmechanizmusú anyag"
    },
    "basic_health|bmi": {
        id: "basic_health|bmi",
        defaultMessage: "Testtömegindex (megfigyelhető entitás)"
    },
    "basic_health|bsa": {
        id: "basic_health|bsa",
        defaultMessage: "Testfelület (testszerkezet)"
    },
    "basic_health|comment_for_blood_group": {
        id: "basic_health|comment_for_blood_group",
        defaultMessage: "comment for blood group"
    },
    "basic_health|current_alcohol_abuse": {
        id: "basic_health|current_alcohol_abuse",
        defaultMessage: "Jelenlegi alkoholfüggőség"
    },
    "basic_health|current_alcohol_use": {
        id: "basic_health|current_alcohol_use",
        defaultMessage: "Jelenlegi alkoholfogyasztás"
    },
    "basic_health|description_of_patient_condition": {
        id: "basic_health|description_of_patient_condition",
        defaultMessage: "Állapotváltozás leírása"
    },
    "basic_health|digitalis": {
        id: "basic_health|digitalis",
        defaultMessage: "Digitálisz (hatóanyag)"
    },
    "basic_health|diuretic": {
        id: "basic_health|diuretic",
        defaultMessage: "Vízhajtó (hatóanyag)"
    },
    "basic_health|dobutamine": {
        id: "basic_health|dobutamine",
        defaultMessage: "Dobutamin (hatóanyag)"
    },
    "basic_health|dopamine": {
        id: "basic_health|dopamine",
        defaultMessage: "Dopamin (hatóanyag)"
    },
    "basic_health|ecg_procedure": {
        id: "basic_health|ecg_procedure",
        defaultMessage: "EKG eljárás"
    },
    "basic_health|fvs": {
        id: "basic_health|fvs",
        defaultMessage: "Fehérvérsejt szám (eljárás)"
    },
    "basic_health|ggt": {
        id: "basic_health|ggt",
        defaultMessage: "Gamma glutamil transzferáz mérés (eljárás)"
    },
    "basic_health|got": {
        id: "basic_health|got",
        defaultMessage: "Aszpartát aminotranszferáz mérés (eljárás)"
    },
    "basic_health|gpt": {
        id: "basic_health|gpt",
        defaultMessage: "Alanin aminotranszferáz mérés (eljárás)"
    },
    "basic_health|haemoglobin": {
        id: "basic_health|haemoglobin",
        defaultMessage: "Hemoglobin koncentráció"
    },
    "basic_health|heart_failure_medical_therapy": {
        id: "basic_health|heart_failure_medical_therapy",
        defaultMessage: "Szívelégtelenség kezelés (eljárás)"
    },
    "basic_health|heart_failure_medical_therapy_other_medicine": {
        id: "basic_health|heart_failure_medical_therapy_other_medicine",
        defaultMessage: "heart failure medical therapy other medicine"
    },
    "basic_health|height": {
        id: "basic_health|height",
        defaultMessage: "Testmagasság mérés (megfigyelhető entitás)"
    },
    "basic_health|ivabradine": {
        id: "basic_health|ivabradine",
        defaultMessage: "Ivabradin (hatóanyag)"
    },
    "basic_health|lab_bloodcount": {
        id: "basic_health|lab_bloodcount",
        defaultMessage: "lab bloodcount"
    },
    "basic_health|lab_diab": {
        id: "basic_health|lab_diab",
        defaultMessage: "lab diab"
    },
    "basic_health|lab_hepat": {
        id: "basic_health|lab_hepat",
        defaultMessage: "lab hepat"
    },
    "basic_health|levosimendan": {
        id: "basic_health|levosimendan",
        defaultMessage: "Levosimendan (hatóanyag)"
    },
    "basic_health|mental_health_review": {
        id: "basic_health|mental_health_review",
        defaultMessage: "Mentálhigiénés felmérés (eljárás)"
    },
    "basic_health|mra": {
        id: "basic_health|mra",
        defaultMessage: "Aldoszteron receptor antagonista hatásmechanizmusú anyag"
    },
    "basic_health|patient_condition": {
        id: "basic_health|patient_condition",
        defaultMessage: "patient_condition"
    },
    "basic_health|patient_condition_report": {
        id: "basic_health|patient_condition_report",
        defaultMessage: "Állapotváltozás jelentés"
    },
    "basic_health|patient_statement_of_consent": {
        id: "basic_health|patient_statement_of_consent",
        defaultMessage: "Aláírt beleegyező nyilatkozat"
    },
    "basic_health|patient_status": {
        id: "basic_health|patient_status",
        defaultMessage: "patient_status"
    },
    "basic_health|pde_inhibitor": {
        id: "basic_health|pde_inhibitor",
        defaultMessage: "PDE inhibitor"
    },
    "basic_health|rh": {
        id: "basic_health|rh",
        defaultMessage: "Rh vércsoport tipizálás"
    },
    "basic_health|rh_negative": {
        id: "basic_health|rh_negative",
        defaultMessage: "Rh negatív"
    },
    "basic_health|rh_positive": {
        id: "basic_health|rh_positive",
        defaultMessage: "RH pozitív"
    },
    "basic_health|serum_glucose": {
        id: "basic_health|serum_glucose",
        defaultMessage: "Glükóz mérés, vér (eljárás)"
    },
    "basic_health|signed_statement_of_consent": {
        id: "basic_health|signed_statement_of_consent",
        defaultMessage: "Páciens beleegyező nyilatkozat"
    },
    "basic_health|smoking": {
        id: "basic_health|smoking",
        defaultMessage: "Dohányzási szokások felmérése (lelet)"
    },
    "basic_health|social_worker_review": {
        id: "basic_health|social_worker_review",
        defaultMessage: "Szociális munkás vizsgálata (lelet)"
    },
    "basic_health|statin": {
        id: "basic_health|statin",
        defaultMessage: "Sztatin terápia"
    },
    "basic_health|summary_of_alcohol_use": {
        id: "basic_health|summary_of_alcohol_use",
        defaultMessage: "Alkoholfogyasztás összefoglalása"
    },
    "basic_health|trombocyta_aggregation_inhibitor": {
        id: "basic_health|trombocyta_aggregation_inhibitor",
        defaultMessage: "Trombocyta aggregáció gátló hatásmechanizmusú anyag"
    },
    "basic_health|weight": {
        id: "basic_health|weight",
        defaultMessage: "Mért testsúly (megfigyelhető entitás)"
    },
    "fyrms|action": {
        id: "fyrms|action",
        defaultMessage: "Cselekmény"
    },
    "fyrms|unstructured_field": {
        id: "fyrms|unstructured_field",
        defaultMessage: "Strukturálatlan mező"
    },
    "htx|6mwt": {
        id: "htx|6mwt",
        defaultMessage: "6 perces járás teszt (eljárás)"
    },
    "htx|BNP": {
        id: "htx|BNP",
        defaultMessage: "BNP"
    },
    "htx|NT-proBNP": {
        id: "htx|NT-proBNP",
        defaultMessage: "NT-proBNP"
    },
    "htx|TAPSE": {
        id: "htx|TAPSE",
        defaultMessage: "TAPSE"
    },
    "htx|ab0": {
        id: "htx|ab0",
        defaultMessage: "ABO vércsoport fenotípus"
    },
    "htx|abdominal_ultrasound_result": {
        id: "htx|abdominal_ultrasound_result",
        defaultMessage: "Hasi ultrahang"
    },
    "htx|abi_result": {
        id: "htx|abi_result",
        defaultMessage: "Boka-kar index eredmény"
    },
    "htx|able_to_6MWT": {
        id: "htx|able_to_6MWT",
        defaultMessage: "Képes 6MWT elvégzésére"
    },
    "htx|able_to_spiroergometry": {
        id: "htx|able_to_spiroergometry",
        defaultMessage: "Képes spiroergometriára"
    },
    "htx|acei": {
        id: "htx|acei",
        defaultMessage: "Angiotenzin-konvertáló enzim gátló hatásmechanizmusú anyag"
    },
    "htx|achieved_max_capacity": {
        id: "htx|achieved_max_capacity",
        defaultMessage: "Légzési kvóciens (megfigyelhető entitás)"
    },
    "htx|adrenalin_or_noradrenalin": {
        id: "htx|adrenalin_or_noradrenalin",
        defaultMessage: "Adrenalin vagy noradrenalin"
    },
    "htx|alkaline_phosphatase": {
        id: "htx|alkaline_phosphatase",
        defaultMessage: "Alkalikus foszfatáz"
    },
    "htx|allopurinol": {
        id: "htx|allopurinol",
        defaultMessage: "Allopurinol (hatóanyag)"
    },
    "htx|anamnestic_alcohol_abuse": {
        id: "htx|anamnestic_alcohol_abuse",
        defaultMessage: "Anamnézisben szereplő alkoholfüggőség"
    },
    "htx|antiarrhythmic_agent": {
        id: "htx|antiarrhythmic_agent",
        defaultMessage: "Antiaritmiás szer (hatóanyag)"
    },
    "htx|antibiotic": {
        id: "htx|antibiotic",
        defaultMessage: "Antibiotikus kezelés (eljárás)"
    },
    "htx|anticoagulant": {
        id: "htx|anticoagulant",
        defaultMessage: "Antikoaguláns (hatóanyag)"
    },
    "htx|aortic_insufficiency": {
        id: "htx|aortic_insufficiency",
        defaultMessage: "Aorta billentyű regurgitáció (rendellenesség)"
    },
    "htx|aortic_root_size": {
        id: "htx|aortic_root_size",
        defaultMessage: "Aorta gyök"
    },
    "htx|aortic_valve_gradient": {
        id: "htx|aortic_valve_gradient",
        defaultMessage: "Aorta billentyű ventrikuloarteriális gradiens (megfigyelhető entitás)"
    },
    "htx|arb": {
        id: "htx|arb",
        defaultMessage: "Angiotenzin II receptor antagonista hatásmechanizmusú anyag"
    },
    "htx|arni": {
        id: "htx|arni",
        defaultMessage: "Csak sacubitril és valsartan tartalmú készítmény (gyógyszer)"
    },
    "htx|artoa_ascendens_size": {
        id: "htx|artoa_ascendens_size",
        defaultMessage: "Felszálló aorta szerkezet (testszerkezet)"
    },
    "htx|bbl": {
        id: "htx|bbl",
        defaultMessage: "Béta adrenerg receptor antagonista hatásmechanizmusú anyag"
    },
    "htx|beta_blocker_during_spiroergometry": {
        id: "htx|beta_blocker_during_spiroergometry",
        defaultMessage: "Béta blokkoló spiroergometria alatt"
    },
    "htx|bilirubin_direct": {
        id: "htx|bilirubin_direct",
        defaultMessage: "Bilirubin, direkt mérés (eljárás)"
    },
    "htx|bilirubin_total": {
        id: "htx|bilirubin_total",
        defaultMessage: "Bilirubin (össz)"
    },
    "htx|bmi": {
        id: "htx|bmi",
        defaultMessage: "Testtömegindex (megfigyelhető entitás)"
    },
    "htx|bsa": {
        id: "htx|bsa",
        defaultMessage: "Testfelület (testszerkezet)"
    },
    "htx|cardiac_index_post_vasodilatation": {
        id: "htx|cardiac_index_post_vasodilatation",
        defaultMessage: "Szívindex (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|cardiac_output_post_vasodilatation": {
        id: "htx|cardiac_output_post_vasodilatation",
        defaultMessage: "Szívteljesítmény (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|cartois_doppler_result": {
        id: "htx|cartois_doppler_result",
        defaultMessage: "Cartois doppler result"
    },
    "htx|cct_summary": {
        id: "htx|cct_summary",
        defaultMessage: "cCt summary"
    },
    "htx|central_venous_pressure_post_vasodilatation": {
        id: "htx|central_venous_pressure_post_vasodilatation",
        defaultMessage: "Központi vénás nyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|chest_ct_result": {
        id: "htx|chest_ct_result",
        defaultMessage: "Mellkas CT"
    },
    "htx|chest_x_ray_result": {
        id: "htx|chest_x_ray_result",
        defaultMessage: "Mellkas röntgen"
    },
    "htx|ci": {
        id: "htx|ci",
        defaultMessage: "Szívindex (megfigyelhető entitás)"
    },
    "htx|cmri_summary": {
        id: "htx|cmri_summary",
        defaultMessage: "cMri summary"
    },
    "htx|cmv": {
        id: "htx|cmv",
        defaultMessage: "Cytomegalovirus szerológiai teszt (eljárás)"
    },
    "htx|cmv_igg": {
        id: "htx|cmv_igg",
        defaultMessage: "Cytomegalovirus immunoglobulin G antitest mérés (eljárás)"
    },
    "htx|co": {
        id: "htx|co",
        defaultMessage: "Szívteljesítmény (megfigyelhető entitás)"
    },
    "htx|colonoscopy_result": {
        id: "htx|colonoscopy_result",
        defaultMessage: "Colonoscopia eredmény"
    },
    "htx|combined_transplant": {
        id: "htx|combined_transplant",
        defaultMessage: "combined_transplant"
    },
    "htx|comment_for_blood_group": {
        id: "htx|comment_for_blood_group",
        defaultMessage: "comment for blood group"
    },
    "htx|coombs_direct": {
        id: "htx|coombs_direct",
        defaultMessage: "Coombs direkt"
    },
    "htx|coombs_indirect": {
        id: "htx|coombs_indirect",
        defaultMessage: "Coombs indirekt"
    },
    "htx|coronarography_summary": {
        id: "htx|coronarography_summary",
        defaultMessage: "coronarography summary"
    },
    "htx|covid_vaccination": {
        id: "htx|covid_vaccination",
        defaultMessage: "Covid oltás"
    },
    "htx|cpet_summary": {
        id: "htx|cpet_summary",
        defaultMessage: "cPet summary"
    },
    "htx|creatinine": {
        id: "htx|creatinine",
        defaultMessage: "Kreatinin"
    },
    "htx|crp": {
        id: "htx|crp",
        defaultMessage: "CRP"
    },
    "htx|current_alcohol_abuse": {
        id: "htx|current_alcohol_abuse",
        defaultMessage: "Jelenlegi alkoholfüggőség"
    },
    "htx|current_alcohol_use": {
        id: "htx|current_alcohol_use",
        defaultMessage: "Jelenlegi alkoholfogyasztás"
    },
    "htx|cvp": {
        id: "htx|cvp",
        defaultMessage: "Központi vénás nyomás (megfigyelhető entitás)"
    },
    "htx|dental_screening_result": {
        id: "htx|dental_screening_result",
        defaultMessage: "Fogászat"
    },
    "htx|dermatology_result": {
        id: "htx|dermatology_result",
        defaultMessage: "Bőrgyógyászati szűrővizsgálat"
    },
    "htx|description_of_patient_condition": {
        id: "htx|description_of_patient_condition",
        defaultMessage: "Állapotváltozás leírása"
    },
    "htx|dexa_result": {
        id: "htx|dexa_result",
        defaultMessage: "dual energy X-ray photon absorptiometry result"
    },
    "htx|diastolic_blood_pressure": {
        id: "htx|diastolic_blood_pressure",
        defaultMessage: "Diasztolés vérnyomás (megfigyelhető entitás)"
    },
    "htx|diastolic_dysfunction": {
        id: "htx|diastolic_dysfunction",
        defaultMessage: "Diasztolés diszfunkció (lelet)"
    },
    "htx|digital_rectal_exam_result": {
        id: "htx|digital_rectal_exam_result",
        defaultMessage: "Digitális rektális vizsgálat eredmény"
    },
    "htx|digitalis": {
        id: "htx|digitalis",
        defaultMessage: "Digitálisz (hatóanyag)"
    },
    "htx|diuretic": {
        id: "htx|diuretic",
        defaultMessage: "Vízhajtó (hatóanyag)"
    },
    "htx|dobutamine": {
        id: "htx|dobutamine",
        defaultMessage: "Dobutamin (hatóanyag)"
    },
    "htx|dopamine": {
        id: "htx|dopamine",
        defaultMessage: "Dopamin (hatóanyag)"
    },
    "htx|ear_nose_throat": {
        id: "htx|ear_nose_throat",
        defaultMessage: "Fül-orr-gégészeti szakvizsgálat"
    },
    "htx|ebv_serology": {
        id: "htx|ebv_serology",
        defaultMessage: "Epstein-Barr vírus szerológiai teszt (eljárás)"
    },
    "htx|ebv_serology_igg": {
        id: "htx|ebv_serology_igg",
        defaultMessage: "Epstein-Barr vírus nukleáris immunoglobulin G mérés (eljárás)"
    },
    "htx|ecg_procedure": {
        id: "htx|ecg_procedure",
        defaultMessage: "EKG eljárás"
    },
    "htx|echocardiography": {
        id: "htx|echocardiography",
        defaultMessage: "Echokardiográfia (eljárás)"
    },
    "htx|echocardiography_summary": {
        id: "htx|echocardiography_summary",
        defaultMessage: "echocardiography summary"
    },
    "htx|edd": {
        id: "htx|edd",
        defaultMessage: "Bal kamrai üregméret (megfigyelhető entitás)"
    },
    "htx|ejection_fraction": {
        id: "htx|ejection_fraction",
        defaultMessage: "Bal kamrai ejekciós frakció (megfigyelhető entitás)"
    },
    "htx|estimated_right_ventricular_peak_systolic_pressure": {
        id: "htx|estimated_right_ventricular_peak_systolic_pressure",
        defaultMessage: "Becsült jobb kamrai csúcs szisztolés nyomás (megfigyelhető entitás)"
    },
    "htx|flu_shot": {
        id: "htx|flu_shot",
        defaultMessage: "Influenza oltás beadva (helyzet)"
    },
    "htx|fvs": {
        id: "htx|fvs",
        defaultMessage: "Fehérvérsejt szám"
    },
    "htx|gfr": {
        id: "htx|gfr",
        defaultMessage: "GFR"
    },
    "htx|ggt": {
        id: "htx|ggt",
        defaultMessage: "GGT"
    },
    "htx|got": {
        id: "htx|got",
        defaultMessage: "GOT"
    },
    "htx|gpt": {
        id: "htx|gpt",
        defaultMessage: "GPT"
    },
    "htx|gynecology_result": {
        id: "htx|gynecology_result",
        defaultMessage: "Nőgyógyászati szakvizsgálat"
    },
    "htx|haemoglobin": {
        id: "htx|haemoglobin",
        defaultMessage: "Hemoglobin"
    },
    "htx|hav_vaccination": {
        id: "htx|hav_vaccination",
        defaultMessage: "A hepatitis vírus oltás beadva (helyzet)"
    },
    "htx|hbc_ab_igg": {
        id: "htx|hbc_ab_igg",
        defaultMessage: "Hepatitis B core antitest mérés, immunoglobulin G típus (eljárás)"
    },
    "htx|hbc_ab_igm": {
        id: "htx|hbc_ab_igm",
        defaultMessage: "Hepatitis B core antitest mérés, immunoglobulin M típus (eljárás)"
    },
    "htx|hbs_ab": {
        id: "htx|hbs_ab",
        defaultMessage: "Hepatitis B felszíni antitest mérés (eljárás)"
    },
    "htx|hbs_ag": {
        id: "htx|hbs_ag",
        defaultMessage: "Hepatitis B felszíni antigén mérés (eljárás)"
    },
    "htx|hbv_status": {
        id: "htx|hbv_status",
        defaultMessage: "Hepatitis B vírus mérés (eljárás)"
    },
    "htx|hbv_vaccination": {
        id: "htx|hbv_vaccination",
        defaultMessage: "B hepatitis vírus oltás beadva (helyzet)"
    },
    "htx|heart_asist_system_therapy": {
        id: "htx|heart_asist_system_therapy",
        defaultMessage: "Szív assist rendszer beültetés (eljárás)"
    },
    "htx|heart_failure_etiology": {
        id: "htx|heart_failure_etiology",
        defaultMessage: "Szívelégtelenség etiológia"
    },
    "htx|heart_failure_medical_therapy": {
        id: "htx|heart_failure_medical_therapy",
        defaultMessage: "Gyógyszeres kezelés"
    },
    "htx|heart_failure_medical_therapy_other_medicine": {
        id: "htx|heart_failure_medical_therapy_other_medicine",
        defaultMessage: "heart failure medical therapy other medicine"
    },
    "htx|heart_rate": {
        id: "htx|heart_rate",
        defaultMessage: "Szívfrekvencia (megfigyelhető entitás)"
    },
    "htx|heart_rate_post_vasodilatation": {
        id: "htx|heart_rate_post_vasodilatation",
        defaultMessage: "Szívfrekvencia (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|height": {
        id: "htx|height",
        defaultMessage: "Testmagasság mérés (megfigyelhető entitás)"
    },
    "htx|hepa_c_virus_screening": {
        id: "htx|hepa_c_virus_screening",
        defaultMessage: "Hepatitis C vírus (organizmus) / Szűrő eljárás (eljárás)"
    },
    "htx|hgb_a1_c": {
        id: "htx|hgb_a1_c",
        defaultMessage: "Hemoglobin A1c mérés (eljárás)"
    },
    "htx|hiv_screening": {
        id: "htx|hiv_screening",
        defaultMessage: "Humán immundeficiencia vírus szűrés (eljárás)"
    },
    "htx|hospitalizations": {
        id: "htx|hospitalizations",
        defaultMessage: "Sürgősségi kórházi felvétel szívelégtelenség miatt (eljárás)"
    },
    "htx|hpv_vaccination": {
        id: "htx|hpv_vaccination",
        defaultMessage: "Humán papillóma vírus oltás beadva (helyzet)"
    },
    "htx|hr": {
        id: "htx|hr",
        defaultMessage: "Szívfrekvencia (megfigyelhető entitás)"
    },
    "htx|hsv1_serology": {
        id: "htx|hsv1_serology",
        defaultMessage: "Humán herpesvírus 1 antitest mérés (eljárás)"
    },
    "htx|hsv1_serology_igg": {
        id: "htx|hsv1_serology_igg",
        defaultMessage: "Herpes simplex immunoglobulin G szint mérés (eljárás)"
    },
    "htx|hsv2_serology": {
        id: "htx|hsv2_serology",
        defaultMessage: "Humán herpesvírus 2 antitest mérés (eljárás)"
    },
    "htx|hsv2_serology_igg": {
        id: "htx|hsv2_serology_igg",
        defaultMessage: "Herpes simplex immunoglobulin G szint mérés (eljárás)"
    },
    "htx|hyper_immunised": {
        id: "htx|hyper_immunised",
        defaultMessage: "hyper_immunised"
    },
    "htx|inr": {
        id: "htx|inr",
        defaultMessage: "INR"
    },
    "htx|ivabradine": {
        id: "htx|ivabradine",
        defaultMessage: "Ivabradin (hatóanyag)"
    },
    "htx|karbamid": {
        id: "htx|karbamid",
        defaultMessage: "Karbamid"
    },
    "htx|lab_bloodcount": {
        id: "htx|lab_bloodcount",
        defaultMessage: "lab bloodcount"
    },
    "htx|lab_diab": {
        id: "htx|lab_diab",
        defaultMessage: "lab diab"
    },
    "htx|lab_endocrin": {
        id: "htx|lab_endocrin",
        defaultMessage: "lab endocrin"
    },
    "htx|lab_hepat": {
        id: "htx|lab_hepat",
        defaultMessage: "lab hepat"
    },
    "htx|lab_inflamm": {
        id: "htx|lab_inflamm",
        defaultMessage: "lab inflamm"
    },
    "htx|lab_neph": {
        id: "htx|lab_neph",
        defaultMessage: "lab neph"
    },
    "htx|ldh": {
        id: "htx|ldh",
        defaultMessage: "Tejsav dehidrogenáz vér mérés (eljárás)"
    },
    "htx|left_atrial_diameter1": {
        id: "htx|left_atrial_diameter1",
        defaultMessage: "Bal pitvari átmérő1"
    },
    "htx|left_atrial_diameter2": {
        id: "htx|left_atrial_diameter2",
        defaultMessage: "Bal pitvari átmérő2"
    },
    "htx|levosimendan": {
        id: "htx|levosimendan",
        defaultMessage: "Levosimendan (hatóanyag)"
    },
    "htx|mammography_result": {
        id: "htx|mammography_result",
        defaultMessage: "Mammográfia eredmény"
    },
    "htx|mcs": {
        id: "htx|mcs",
        defaultMessage: "MCS"
    },
    "htx|medical_history_summary": {
        id: "htx|medical_history_summary",
        defaultMessage: "medical history summary"
    },
    "htx|meningococcus_vaccination": {
        id: "htx|meningococcus_vaccination",
        defaultMessage: "Meningococcus oltás beadva (helyzet)"
    },
    "htx|mental_health_review": {
        id: "htx|mental_health_review",
        defaultMessage: "Mentálhigiénés felmérés (eljárás)"
    },
    "htx|mitral_insufficiency": {
        id: "htx|mitral_insufficiency",
        defaultMessage: "Mitrális billentyű regurgitáció (rendellenesség)"
    },
    "htx|mpap": {
        id: "htx|mpap",
        defaultMessage: "Pulmonális artéria átlagnyomás (megfigyelhető entitás)"
    },
    "htx|mpcwp": {
        id: "htx|mpcwp",
        defaultMessage: "Pulmonális artéria éknyomás (megfigyelhető entitás)"
    },
    "htx|mra": {
        id: "htx|mra",
        defaultMessage: "Aldoszteron receptor antagonista hatásmechanizmusú anyag"
    },
    "htx|natrium": {
        id: "htx|natrium",
        defaultMessage: "Nátrium (Na)"
    },
    "htx|number_of_thoracotomies": {
        id: "htx|number_of_thoracotomies",
        defaultMessage: "Thoracotomiák száma"
    },
    "htx|nyha_stage": {
        id: "htx|nyha_stage",
        defaultMessage: "New York Heart Association Osztályozás osztály (megfigyelhető entitás)"
    },
    "htx|ophthalmologic_examination_result": {
        id: "htx|ophthalmologic_examination_result",
        defaultMessage: "Szemészeti vizsgálat eredmény"
    },
    "htx|pacemaker_therapy": {
        id: "htx|pacemaker_therapy",
        defaultMessage: "Szívritmusszabályozó beültetés (eljárás)"
    },
    "htx|papanicolaou": {
        id: "htx|papanicolaou",
        defaultMessage: "Hüvely mintavétel Papanicolaou kenethez (eljárás)"
    },
    "htx|papd": {
        id: "htx|papd",
        defaultMessage: "Pulmonális artéria diasztolés nyomás (megfigyelhető entitás)"
    },
    "htx|paps": {
        id: "htx|paps",
        defaultMessage: "Pulmonális artéria szisztolés nyomás (megfigyelhető entitás)"
    },
    "htx|patient_condition": {
        id: "htx|patient_condition",
        defaultMessage: "patient_condition"
    },
    "htx|patient_condition_report": {
        id: "htx|patient_condition_report",
        defaultMessage: "Állapotváltozás jelentés"
    },
    "htx|patient_et_id": {
        id: "htx|patient_et_id",
        defaultMessage: "ET azonosító"
    },
    "htx|patient_statement_of_consent": {
        id: "htx|patient_statement_of_consent",
        defaultMessage: "Aláírt beleegyező nyilatkozat"
    },
    "htx|patient_status": {
        id: "htx|patient_status",
        defaultMessage: "Páciens státusz"
    },
    "htx|pde_inhibitor": {
        id: "htx|pde_inhibitor",
        defaultMessage: "PDE inhibitor"
    },
    "htx|platelet_count": {
        id: "htx|platelet_count",
        defaultMessage: "Trombocyta szám"
    },
    "htx|pneumococus_vaccination": {
        id: "htx|pneumococus_vaccination",
        defaultMessage: "Pneumococcus oltás beadva (helyzet)"
    },
    "htx|posterior_wall_thickness": {
        id: "htx|posterior_wall_thickness",
        defaultMessage: "Hátsó fal vastagság"
    },
    "htx|potassium": {
        id: "htx|potassium",
        defaultMessage: "Kálium (K)"
    },
    "htx|pra_cdc": {
        id: "htx|pra_cdc",
        defaultMessage: "Szenzitizációs státusz - PRA CDC"
    },
    "htx|pra_luminex": {
        id: "htx|pra_luminex",
        defaultMessage: "Szenzitizációs státusz - PRA Luminex"
    },
    "htx|prealbumin": {
        id: "htx|prealbumin",
        defaultMessage: "Szérum prealbumin szint (eljárás)"
    },
    "htx|prostate_specific_antigen_result": {
        id: "htx|prostate_specific_antigen_result",
        defaultMessage: "Prosztata specifikus antigén eredmény"
    },
    "htx|proteinuria_result": {
        id: "htx|proteinuria_result",
        defaultMessage: "Proteinuria eredmény"
    },
    "htx|psa": {
        id: "htx|psa",
        defaultMessage: "PSA"
    },
    "htx|pseudocholinesterase": {
        id: "htx|pseudocholinesterase",
        defaultMessage: "Pseudocholinesterase mérés"
    },
    "htx|psychiatry_result": {
        id: "htx|psychiatry_result",
        defaultMessage: "Pszichiátriai eredmény"
    },
    "htx|pulmonary_artery_diastolic_pressure_post_vasodilatation": {
        id: "htx|pulmonary_artery_diastolic_pressure_post_vasodilatation",
        defaultMessage: "Pulmonális artéria diasztolés nyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|pulmonary_artery_mean_pressure_post_vasodilatation": {
        id: "htx|pulmonary_artery_mean_pressure_post_vasodilatation",
        defaultMessage: "Pulmonális artéria átlagnyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|pulmonary_artery_systolic_pressure_post_vasodilatation": {
        id: "htx|pulmonary_artery_systolic_pressure_post_vasodilatation",
        defaultMessage: "Pulmonális artéria szisztolés nyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|pulmonary_artery_wedge_pressure_post_vasodilatation": {
        id: "htx|pulmonary_artery_wedge_pressure_post_vasodilatation",
        defaultMessage: "Pulmonális artéria éknyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|pulmonary_valve_ventriculoarterial_gradient_post": {
        id: "htx|pulmonary_valve_ventriculoarterial_gradient_post",
        defaultMessage: "Pulmonális billentyű ventrikuloarteriális gradiens/Vazodilatáció után (minősítő érték)"
    },
    "htx|pulmonary_vascular_resistance_post_vasodilatation": {
        id: "htx|pulmonary_vascular_resistance_post_vasodilatation",
        defaultMessage: "Pulmonális vaszkuláris rezisztencia (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|pulmonology_result": {
        id: "htx|pulmonology_result",
        defaultMessage: "Pulmonológiai szakvizsgálat"
    },
    "htx|pvr": {
        id: "htx|pvr",
        defaultMessage: "Pulmonális vaszkuláris rezisztencia (megfigyelhető entitás)"
    },
    "htx|rh": {
        id: "htx|rh",
        defaultMessage: "Rh vércsoport tipizálás"
    },
    "htx|right_atrial_diameter1": {
        id: "htx|right_atrial_diameter1",
        defaultMessage: "Jobb pitvari átmérő1"
    },
    "htx|right_atrial_diameter2": {
        id: "htx|right_atrial_diameter2",
        defaultMessage: "Jobb pitvari átmérő2"
    },
    "htx|right_heart_catheterization": {
        id: "htx|right_heart_catheterization",
        defaultMessage: "Jobbszívfél-katéterezés"
    },
    "htx|right_ventricular_diastolic_pressure_post_vasodilatation": {
        id: "htx|right_ventricular_diastolic_pressure_post_vasodilatation",
        defaultMessage: "Jobb kamrai diasztolés nyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|right_ventricular_pressure_post_vasodilatation": {
        id: "htx|right_ventricular_pressure_post_vasodilatation",
        defaultMessage: "Jobb kamrai nyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|right_ventricular_systolic_pressure_post_vasodilatation": {
        id: "htx|right_ventricular_systolic_pressure_post_vasodilatation",
        defaultMessage: "Jobb kamrai szisztolés nyomás (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|rrs": {
        id: "htx|rrs",
        defaultMessage: "Kiindulási szisztolés vérnyomás (megfigyelhető entitás)"
    },
    "htx|rv_size": {
        id: "htx|rv_size",
        defaultMessage: "Jobb kamrai üregméret (megfigyelhető entitás)"
    },
    "htx|rvpd": {
        id: "htx|rvpd",
        defaultMessage: "Jobb kamrai diasztolés nyomás (megfigyelhető entitás)"
    },
    "htx|rvpm": {
        id: "htx|rvpm",
        defaultMessage: "Jobb kamrai nyomás (megfigyelhető entitás)"
    },
    "htx|rvps": {
        id: "htx|rvps",
        defaultMessage: "Jobb kamrai szisztolés nyomás (megfigyelhető entitás)"
    },
    "htx|seen_by_anesthetist": {
        id: "htx|seen_by_anesthetist",
        defaultMessage: "Aneszteziológiai konzílium"
    },
    "htx|seen_by_diabetologist": {
        id: "htx|seen_by_diabetologist",
        defaultMessage: "Diabetológiai konzílium"
    },
    "htx|seen_by_endocrinologist": {
        id: "htx|seen_by_endocrinologist",
        defaultMessage: "Endokrinológiai konzílium"
    },
    "htx|seen_by_gastroenterologist": {
        id: "htx|seen_by_gastroenterologist",
        defaultMessage: "Gasztroenterológiai konzílium"
    },
    "htx|seen_by_geneticist": {
        id: "htx|seen_by_geneticist",
        defaultMessage: "Genetikai konzílium"
    },
    "htx|seen_by_hematologist": {
        id: "htx|seen_by_hematologist",
        defaultMessage: "Hematológiai konzílium"
    },
    "htx|seen_by_hepatologist": {
        id: "htx|seen_by_hepatologist",
        defaultMessage: "Hepatológiai konzílium"
    },
    "htx|seen_by_immunologist": {
        id: "htx|seen_by_immunologist",
        defaultMessage: "Immunológiai konzílium"
    },
    "htx|seen_by_infectologist": {
        id: "htx|seen_by_infectologist",
        defaultMessage: "Infektológiai konzílium"
    },
    "htx|seen_by_nephrologist": {
        id: "htx|seen_by_nephrologist",
        defaultMessage: "Nefrológiai konzílium"
    },
    "htx|seen_by_neurologist": {
        id: "htx|seen_by_neurologist",
        defaultMessage: "Neurológiai konzílium"
    },
    "htx|seen_by_oncologist": {
        id: "htx|seen_by_oncologist",
        defaultMessage: "Onkológiai konzílium"
    },
    "htx|seen_by_radiologist": {
        id: "htx|seen_by_radiologist",
        defaultMessage: "Radiológiai konzílium"
    },
    "htx|seen_by_rheumatologist": {
        id: "htx|seen_by_rheumatologist",
        defaultMessage: "Reumatológiai konzílium"
    },
    "htx|seen_by_vascular_surgeon": {
        id: "htx|seen_by_vascular_surgeon",
        defaultMessage: "Érsebészeti konzílium"
    },
    "htx|septal_wall_thickness": {
        id: "htx|septal_wall_thickness",
        defaultMessage: "Szeptum falvastagság"
    },
    "htx|serum_albumin": {
        id: "htx|serum_albumin",
        defaultMessage: "Albumin"
    },
    "htx|serum_glucose": {
        id: "htx|serum_glucose",
        defaultMessage: "Vércukor"
    },
    "htx|signed_statement_of_consent": {
        id: "htx|signed_statement_of_consent",
        defaultMessage: "Páciens beleegyező nyilatkozat"
    },
    "htx|smoking": {
        id: "htx|smoking",
        defaultMessage: "Dohányzási szokások felmérése (lelet)"
    },
    "htx|social_worker_review": {
        id: "htx|social_worker_review",
        defaultMessage: "Szociális munkás vizsgálata (lelet)"
    },
    "htx|spect_summary": {
        id: "htx|spect_summary",
        defaultMessage: "spect summary"
    },
    "htx|spiro_fields": {
        id: "htx|spiro_fields",
        defaultMessage: "Kardiopulmonális terheléses teszt (eljárás)"
    },
    "htx|statin": {
        id: "htx|statin",
        defaultMessage: "Sztatin terápia"
    },
    "htx|stool_blood_result": {
        id: "htx|stool_blood_result",
        defaultMessage: "Széklet vér vizsgálat"
    },
    "htx|stool_culture_result": {
        id: "htx|stool_culture_result",
        defaultMessage: "Széklettenyésztés"
    },
    "htx|summary_of_alcohol_use": {
        id: "htx|summary_of_alcohol_use",
        defaultMessage: "Alkoholfogyasztás összefoglalója"
    },
    "htx|summary_of_thoracotomies": {
        id: "htx|summary_of_thoracotomies",
        defaultMessage: "Torakotómiák összefoglalója"
    },
    "htx|summary_report_by_cardiologist": {
        id: "htx|summary_report_by_cardiologist",
        defaultMessage: "summary report by cardiologist"
    },
    "htx|sv02": {
        id: "htx|sv02",
        defaultMessage: "Vénás oxigénszaturáció (megfigyelhető entitás)"
    },
    "htx|systolic_blood_pressure": {
        id: "htx|systolic_blood_pressure",
        defaultMessage: "Szisztolés vérnyomás (megfigyelhető entitás)"
    },
    "htx|systolic_blood_pressure_post_vasodilatation": {
        id: "htx|systolic_blood_pressure_post_vasodilatation",
        defaultMessage: "Systolic blood pressure (observable entity/Post vasodilatation (qualifier value)"
    },
    "htx|t3": {
        id: "htx|t3",
        defaultMessage: "Szérum T3 mérés (eljárás)"
    },
    "htx|t4": {
        id: "htx|t4",
        defaultMessage: "Szérum T4 mérés (eljárás)"
    },
    "htx|toxoplasma_serology": {
        id: "htx|toxoplasma_serology",
        defaultMessage: "Toxoplasma faj ellenanyag mérése (eljárás)"
    },
    "htx|toxoplasma_serology_igg": {
        id: "htx|toxoplasma_serology_igg",
        defaultMessage: "Toxoplasma immunoglobulin G szint (eljárás)"
    },
    "htx|tpg": {
        id: "htx|tpg",
        defaultMessage: "Pulmonális billentyű ventrikuloarteriális gradiens"
    },
    "htx|transplant_immun_concilium": {
        id: "htx|transplant_immun_concilium",
        defaultMessage: "Transzplantációs immunogenetikai konzílium"
    },
    "htx|treponema_pallidum_org_screening_procedure": {
        id: "htx|treponema_pallidum_org_screening_procedure",
        defaultMessage: "Treponema pallidum (organizmus)/Szűrővizsgálat (eljárás)"
    },
    "htx|tricuspid_insufficiency": {
        id: "htx|tricuspid_insufficiency",
        defaultMessage: "Tricuspidalis billentyű regurgitáció (rendellenesség)"
    },
    "htx|trombocyta_aggregation_inhibitor": {
        id: "htx|trombocyta_aggregation_inhibitor",
        defaultMessage: "Trombocyta aggregáció gátló hatásmechanizmusú anyag"
    },
    "htx|tsh": {
        id: "htx|tsh",
        defaultMessage: "Pajzsmirigy stimuláló hormon mérése (eljárás)"
    },
    "htx|urgency": {
        id: "htx|urgency",
        defaultMessage: "urgency"
    },
    "htx|urine_culture_result": {
        id: "htx|urine_culture_result",
        defaultMessage: "Vizelettenyésztés"
    },
    "htx|urine_sediment_result": {
        id: "htx|urine_sediment_result",
        defaultMessage: "Vizelet üledék eredmény"
    },
    "htx|urology_result": {
        id: "htx|urology_result",
        defaultMessage: "Urológiai szakvizsgálat"
    },
    "htx|varicella_serology": {
        id: "htx|varicella_serology",
        defaultMessage: "Varicella-zoster vírus ellenanyag mérése (eljárás)"
    },
    "htx|varicella_serology_igg": {
        id: "htx|varicella_serology_igg",
        defaultMessage: "Varicella-zoster vírus ellenanyag immunoglobulin G mérése (eljárás)"
    },
    "htx|vasoreactivity_test": {
        id: "htx|vasoreactivity_test",
        defaultMessage: "Vazoreaktivitási teszt"
    },
    "htx|venous_oxygen_saturation_post_vasodilatation": {
        id: "htx|venous_oxygen_saturation_post_vasodilatation",
        defaultMessage: "Vénás oxigénszaturáció (megfigyelhető entitás)/Vazodilatáció után (minősítő érték)"
    },
    "htx|vo2": {
        id: "htx|vo2",
        defaultMessage: "Szervezet oxigénfogyasztása (megfigyelhető entitás)"
    },
    "htx|waiting_list_start_date": {
        id: "htx|waiting_list_start_date",
        defaultMessage: "Várólistára kerülés dátuma"
    },
    "htx|weight": {
        id: "htx|weight",
        defaultMessage: "Testsúly"
    },
    "icd|C3800": {
        id: "icd|C3800",
        defaultMessage: "Szív rosszindulatú daganata"
    },
    "icd|D1510": {
        id: "icd|D1510",
        defaultMessage: "Szív jóindulatú daganata"
    },
    "icd|D8210": {
        id: "icd|D8210",
        defaultMessage: "Di George szindróma"
    },
    "icd|I2190": {
        id: "icd|I2190",
        defaultMessage: "Heveny szívizomelhalás, k.m.n."
    },
    "icd|I2530": {
        id: "icd|I2530",
        defaultMessage: "Szívaneurysma"
    },
    "icd|I2550": {
        id: "icd|I2550",
        defaultMessage: "Ischaemiás cardiomyopathia"
    },
    "icd|I2700": {
        id: "icd|I2700",
        defaultMessage: "Primer pulmonális hipertónia"
    },
    "icd|I2780": {
        id: "icd|I2780",
        defaultMessage: "Egyéb meghatározott tüdőszívbetegségek"
    },
    "icd|I2790": {
        id: "icd|I2790",
        defaultMessage: "Tüdőszívbetegség, k.m.n."
    },
    "icd|I2800": {
        id: "icd|I2800",
        defaultMessage: "Tüdőerek arteriovénás fistulája"
    },
    "icd|I2810": {
        id: "icd|I2810",
        defaultMessage: "Az arteria pulmonalis aneurysmája"
    },
    "icd|I3090": {
        id: "icd|I3090",
        defaultMessage: "Heveny szívburokgyulladás, k.m.n."
    },
    "icd|I3130": {
        id: "icd|I3130",
        defaultMessage: "Folyadék a szívburokban (nem gyulladásos)"
    },
    "icd|I3190": {
        id: "icd|I3190",
        defaultMessage: "A szívburok betegsége, k.m.n."
    },
    "icd|I3390": {
        id: "icd|I3390",
        defaultMessage: "Heveny szívbelhártya-gyulladás, k.m.n."
    },
    "icd|I3400": {
        id: "icd|I3400",
        defaultMessage: "A kéthegyű billentyű elégtelensége"
    },
    "icd|I3420": {
        id: "icd|I3420",
        defaultMessage: "Mitralis (billentyű) stenosis, nem rheumás"
    },
    "icd|I3500": {
        id: "icd|I3500",
        defaultMessage: "Az aorta billentyű szűkülete"
    },
    "icd|I3510": {
        id: "icd|I3510",
        defaultMessage: "Az aorta billentyű elégtelensége"
    },
    "icd|I3600": {
        id: "icd|I3600",
        defaultMessage: "A háromhegyű billentyű nem rheumás szűkülete"
    },
    "icd|I3610": {
        id: "icd|I3610",
        defaultMessage: "A háromhegyű billentyű nem rheumás elégtelensége"
    },
    "icd|I3700": {
        id: "icd|I3700",
        defaultMessage: "A pulmonalis billentyű szűkülete"
    },
    "icd|I3710": {
        id: "icd|I3710",
        defaultMessage: "A pulmonalis billentyű elégtelensége"
    },
    "icd|I4200": {
        id: "icd|I4200",
        defaultMessage: "Dilatativ cardiomyopathia"
    },
    "icd|I4210": {
        id: "icd|I4210",
        defaultMessage: "Hypertrophiás obstructiv cardiomyopathia"
    },
    "icd|I4220": {
        id: "icd|I4220",
        defaultMessage: "Egyéb hypertrophiás cardiomyopathia"
    },
    "icd|I4250": {
        id: "icd|I4250",
        defaultMessage: "Egyéb restrictiv cardiomyopathia"
    },
    "icd|I4270": {
        id: "icd|I4270",
        defaultMessage: "Gyógyszerek és egyéb külső tényezők okozta cardiomyopathia"
    },
    "icd|I4290": {
        id: "icd|I4290",
        defaultMessage: "Cardiomyopathia, k.m.n."
    },
    "icd|I5090": {
        id: "icd|I5090",
        defaultMessage: "Szívelégtelenség, k.m.n."
    },
    "icd|I5140": {
        id: "icd|I5140",
        defaultMessage: "Szívizomgyulladás, k.m.n."
    },
    "icd|I7100": {
        id: "icd|I7100",
        defaultMessage: "Az aorta (bármely részének) dissectiója"
    },
    "icd|I7190": {
        id: "icd|I7190",
        defaultMessage: "Aorta-aneurysma (k.m.n. lokalizációjú, repedés említése nélkül)"
    },
    "icd|J9000": {
        id: "icd|J9000",
        defaultMessage: "Mellüregi folyadékképződés, m.n.o."
    },
    "icd|J9390": {
        id: "icd|J9390",
        defaultMessage: "Pneumothorax, k.m.n."
    },
    "icd|J9400": {
        id: "icd|J9400",
        defaultMessage: "Chylosus folyadékgyülem"
    },
    "icd|J9850": {
        id: "icd|J9850",
        defaultMessage: "A mediastinum máshova nem osztályozott betegségei"
    },
    "icd|J9860": {
        id: "icd|J9860",
        defaultMessage: "A rekeszizom rendellenességei"
    },
    "icd|M3030": {
        id: "icd|M3030",
        defaultMessage: "Mucocután nyirokcsomó szindróma [Kawasaki]"
    },
    "icd|P2930": {
        id: "icd|P2930",
        defaultMessage: "Perzisztáló magzati keringés"
    },
    "icd|Q2000": {
        id: "icd|Q2000",
        defaultMessage: "Közös artériás törzs"
    },
    "icd|Q2010": {
        id: "icd|Q2010",
        defaultMessage: "Dupla kiáramlás jobb kamrából"
    },
    "icd|Q2020": {
        id: "icd|Q2020",
        defaultMessage: "Dupla kiáramlás bal kamrából"
    },
    "icd|Q2030": {
        id: "icd|Q2030",
        defaultMessage: "Diszkordáns ventrikuloarteriális kapcsolat"
    },
    "icd|Q2040": {
        id: "icd|Q2040",
        defaultMessage: "Dupla beáramlású kamra"
    },
    "icd|Q2050": {
        id: "icd|Q2050",
        defaultMessage: "Diszkordáns atrioventrikuláris kapcsolat"
    },
    "icd|Q2060": {
        id: "icd|Q2060",
        defaultMessage: "Pitvari fülcse izomerizmus"
    },
    "icd|Q2080": {
        id: "icd|Q2080",
        defaultMessage: "A szívkamrák és kapcsolatok egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2100": {
        id: "icd|Q2100",
        defaultMessage: "Kamrai sövényhiány"
    },
    "icd|Q2110": {
        id: "icd|Q2110",
        defaultMessage: "Pitvari sövényhiány"
    },
    "icd|Q2120": {
        id: "icd|Q2120",
        defaultMessage: "Atrioventrikuláris sövényhiány"
    },
    "icd|Q2130": {
        id: "icd|Q2130",
        defaultMessage: "Fallot tetralogia"
    },
    "icd|Q2140": {
        id: "icd|Q2140",
        defaultMessage: "Aortopulmonális sövényhiány"
    },
    "icd|Q2180": {
        id: "icd|Q2180",
        defaultMessage: "A szívsövények egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2200": {
        id: "icd|Q2200",
        defaultMessage: "Pulmonális billentyű atresia"
    },
    "icd|Q2210": {
        id: "icd|Q2210",
        defaultMessage: "Veleszületett pulmonális billentyű stenosis"
    },
    "icd|Q2220": {
        id: "icd|Q2220",
        defaultMessage: "Veleszületett pulmonális billentyű elégtelenség"
    },
    "icd|Q2230": {
        id: "icd|Q2230",
        defaultMessage: "A pulmonális billentyű egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2240": {
        id: "icd|Q2240",
        defaultMessage: "Veleszületett tricuspidalis stenosis"
    },
    "icd|Q2250": {
        id: "icd|Q2250",
        defaultMessage: "Ebstein anomália"
    },
    "icd|Q2260": {
        id: "icd|Q2260",
        defaultMessage: "Hypoplasticus jobb szív szindróma"
    },
    "icd|Q2280": {
        id: "icd|Q2280",
        defaultMessage: "A tricuspidalis billentyű egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2300": {
        id: "icd|Q2300",
        defaultMessage: "Az aorta billentyű veleszületett stenosis-a"
    },
    "icd|Q2310": {
        id: "icd|Q2310",
        defaultMessage: "Az aorta billentyű veleszületett elégtelensége"
    },
    "icd|Q2320": {
        id: "icd|Q2320",
        defaultMessage: "Veleszületett mitralis stenosis"
    },
    "icd|Q2330": {
        id: "icd|Q2330",
        defaultMessage: "Veleszületett mitralis elégtelenség"
    },
    "icd|Q2340": {
        id: "icd|Q2340",
        defaultMessage: "Hypoplasticus bal szív szindróma"
    },
    "icd|Q2380": {
        id: "icd|Q2380",
        defaultMessage: "Az aorta és mitralis billentyűk egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2400": {
        id: "icd|Q2400",
        defaultMessage: "Dextrocardia"
    },
    "icd|Q2420": {
        id: "icd|Q2420",
        defaultMessage: "Cor triatriatum"
    },
    "icd|Q2430": {
        id: "icd|Q2430",
        defaultMessage: "Pulmonális infundibularis stenosis"
    },
    "icd|Q2440": {
        id: "icd|Q2440",
        defaultMessage: "Veleszületett subaorticus stenosis"
    },
    "icd|Q2450": {
        id: "icd|Q2450",
        defaultMessage: "Koszorúserek fejlődési rendellenessége"
    },
    "icd|Q2480": {
        id: "icd|Q2480",
        defaultMessage: "A szív egyéb meghatározott veleszületett fejlődési rendellenességei"
    },
    "icd|Q2500": {
        id: "icd|Q2500",
        defaultMessage: "Nyitott ductus arteriosus"
    },
    "icd|Q2510": {
        id: "icd|Q2510",
        defaultMessage: "Aorta coarctatio"
    },
    "icd|Q2520": {
        id: "icd|Q2520",
        defaultMessage: "Aorta atresia"
    },
    "icd|Q2530": {
        id: "icd|Q2530",
        defaultMessage: "Aorta stenosis"
    },
    "icd|Q2540": {
        id: "icd|Q2540",
        defaultMessage: "Az aorta veleszületett fejlődési rendellenessége, k.m.n."
    },
    "icd|Q2560": {
        id: "icd|Q2560",
        defaultMessage: "Arteria pulmonalis stenosis"
    },
    "icd|Q2570": {
        id: "icd|Q2570",
        defaultMessage: "Az arteria pulmonalis egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2610": {
        id: "icd|Q2610",
        defaultMessage: "Perzisztáló bal felső vena cava"
    },
    "icd|Q2620": {
        id: "icd|Q2620",
        defaultMessage: "Teljes kóros tüdővéna beömlés"
    },
    "icd|Q2630": {
        id: "icd|Q2630",
        defaultMessage: "Részleges kóros tüdővéna beömlés"
    },
    "icd|Q2640": {
        id: "icd|Q2640",
        defaultMessage: "Kóros tüdővéna beömlés, k.m.n."
    },
    "icd|Q2650": {
        id: "icd|Q2650",
        defaultMessage: "Kóros portális vénás kapcsolat"
    },
    "icd|Q2660": {
        id: "icd|Q2660",
        defaultMessage: "Portális véna májartéria fistula"
    },
    "icd|Q2680": {
        id: "icd|Q2680",
        defaultMessage: "A nagy vénák egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2690": {
        id: "icd|Q2690",
        defaultMessage: "Nagy véna veleszületett fejlődési rendellenessége, k.m.n."
    },
    "icd|Q2700": {
        id: "icd|Q2700",
        defaultMessage: "Köldökartéria veleszületett hiánya és hypoplasia"
    },
    "icd|Q2710": {
        id: "icd|Q2710",
        defaultMessage: "Veleszületett veseartéria stenosis"
    },
    "icd|Q2720": {
        id: "icd|Q2720",
        defaultMessage: "A veseartéria egyéb veleszületett fejlődési rendellenességei"
    },
    "icd|Q2730": {
        id: "icd|Q2730",
        defaultMessage: "Perifériás arteriovénás malformáció"
    },
    "icd|Q2880": {
        id: "icd|Q2880",
        defaultMessage: "A keringési rendszer egyéb meghatározott veleszületett fejlődési rendellenességei"
    },
    "icd|Q3210": {
        id: "icd|Q3210",
        defaultMessage: "A légcső egyéb veleszületett rendellenességei"
    },
    "icd|Q6760": {
        id: "icd|Q6760",
        defaultMessage: "Pectus excavatum"
    },
    "icd|Q6770": {
        id: "icd|Q6770",
        defaultMessage: "Pectus carinatum"
    },
    "icd|Q8740": {
        id: "icd|Q8740",
        defaultMessage: "Marfan szindróma"
    },
    "icd|Q8930": {
        id: "icd|Q8930",
        defaultMessage: "Situs inversus"
    },
    "icd|Q9090": {
        id: "icd|Q9090",
        defaultMessage: "Down szindróma, k.m.n."
    },
    "icd|Q9130": {
        id: "icd|Q9130",
        defaultMessage: "Edwards szindróma, k.m.n."
    },
    "icd|Q9170": {
        id: "icd|Q9170",
        defaultMessage: "Patau szindróma, k.m.n."
    },
    "icd|Q9690": {
        id: "icd|Q9690",
        defaultMessage: "Turner szindróma, k.m.n."
    },
    "icd|R0740": {
        id: "icd|R0740",
        defaultMessage: "Mellkasi fájdalom, k.m.n"
    },
    "ktx|APD_renal_replacement_therapy": {
        id: "ktx|APD_renal_replacement_therapy",
        defaultMessage: "APD"
    },
    "ktx|CAPD_renal_replacement_therapy": {
        id: "ktx|CAPD_renal_replacement_therapy",
        defaultMessage: "CAPD"
    },
    "ktx|COPD": {
        id: "ktx|COPD",
        defaultMessage: "COPD"
    },
    "ktx|Coronary_artery_disease_non_obstructive": {
        id: "ktx|Coronary_artery_disease_non_obstructive",
        defaultMessage: "Koronária betegség - Non-obstruktív"
    },
    "ktx|Coronary_artery_disease_obstructive_with_intervention": {
        id: "ktx|Coronary_artery_disease_obstructive_with_intervention",
        defaultMessage: "Koronária betegség - Obstruktív intervencióval"
    },
    "ktx|Coronary_artery_disease_obstructive_without_intervention": {
        id: "ktx|Coronary_artery_disease_obstructive_without_intervention",
        defaultMessage: "Koronária betegség - Obstruktív intervenció nélkül"
    },
    "ktx|GERD_ulcus": {
        id: "ktx|GERD_ulcus",
        defaultMessage: "GERD / Ulcus"
    },
    "ktx|HBV_status_PCR_negative": {
        id: "ktx|HBV_status_PCR_negative",
        defaultMessage: "PCR Negatív HBV státusz"
    },
    "ktx|HBV_status_PCR_positive": {
        id: "ktx|HBV_status_PCR_positive",
        defaultMessage: "PCR Pozitív HBV státusz"
    },
    "ktx|HBV_status_unknown": {
        id: "ktx|HBV_status_unknown",
        defaultMessage: "Ismeretlen HBV státusz"
    },
    "ktx|HCV_status_PCR_negative": {
        id: "ktx|HCV_status_PCR_negative",
        defaultMessage: "PCR Negatív HCV státusz"
    },
    "ktx|HCV_status_PCR_positive": {
        id: "ktx|HCV_status_PCR_positive",
        defaultMessage: "PCR Pozitív HCV státusz"
    },
    "ktx|HCV_status_unknown": {
        id: "ktx|HCV_status_unknown",
        defaultMessage: "Ismeretlen HCV státusz"
    },
    "ktx|HD_renal_replacement_therapy": {
        id: "ktx|HD_renal_replacement_therapy",
        defaultMessage: "HD"
    },
    "ktx|HHD_renal_replacement_therapy": {
        id: "ktx|HHD_renal_replacement_therapy",
        defaultMessage: "HHD"
    },
    "ktx|IgA_nephropathy": {
        id: "ktx|IgA_nephropathy",
        defaultMessage: "12 - IgA nefropathia (immunfluoreszcenciával igazolt)"
    },
    "ktx|Lead_induced_nephropathy_interstitial": {
        id: "ktx|Lead_induced_nephropathy_interstitial",
        defaultMessage: "34 - Ólom indukálta interstitialis nephropathia"
    },
    "ktx|Nephropathy_interstitial_due_to_cis-platinum": {
        id: "ktx|Nephropathy_interstitial_due_to_cis-platinum",
        defaultMessage: "32 - Nefropathia cisplatin miatt"
    },
    "ktx|NoRTT_renal_replacement_therapy": {
        id: "ktx|NoRTT_renal_replacement_therapy",
        defaultMessage: "ND"
    },
    "ktx|TIA_ischemic_stroke": {
        id: "ktx|TIA_ischemic_stroke",
        defaultMessage: "TIA/iszkémiás stroke"
    },
    "ktx|ab0": {
        id: "ktx|ab0",
        defaultMessage: "ABO-csoport fenotípusa"
    },
    "ktx|abdominal-pelvis_ultrasound": {
        id: "ktx|abdominal-pelvis_ultrasound",
        defaultMessage: "Has-kismedence ultrahang"
    },
    "ktx|abdominal_CT_MR_angiography": {
        id: "ktx|abdominal_CT_MR_angiography",
        defaultMessage: "Has CT / MR / angiográfia"
    },
    "ktx|access": {
        id: "ktx|access",
        defaultMessage: "Vérnyerés"
    },
    "ktx|access_arteriovenous_fistula": {
        id: "ktx|access_arteriovenous_fistula",
        defaultMessage: "Arteriovenous fistula"
    },
    "ktx|access_other": {
        id: "ktx|access_other",
        defaultMessage: "Egyéb vérnyerés"
    },
    "ktx|access_permanent_catheter": {
        id: "ktx|access_permanent_catheter",
        defaultMessage: "Tartós kanül"
    },
    "ktx|access_statement": {
        id: "ktx|access_statement",
        defaultMessage: "Jelenlegi vérnyerés, vagy egyéb dialízis katéter"
    },
    "ktx|access_temporary_catheter": {
        id: "ktx|access_temporary_catheter",
        defaultMessage: "Átmeneti kanül"
    },
    "ktx|access_tenckhoff_catheter": {
        id: "ktx|access_tenckhoff_catheter",
        defaultMessage: "Tenckhoff katéter"
    },
    "ktx|acute_chronic_liver_failure": {
        id: "ktx|acute_chronic_liver_failure",
        defaultMessage: "Akut / krónikus májelégtelenség"
    },
    "ktx|acute_rejection": {
        id: "ktx|acute_rejection",
        defaultMessage: "Akut rejekció"
    },
    "ktx|adenotomia": {
        id: "ktx|adenotomia",
        defaultMessage: "Adenotomia"
    },
    "ktx|adrenal_disfunction": {
        id: "ktx|adrenal_disfunction",
        defaultMessage: "Mellékvese elégtelenség"
    },
    "ktx|alcohol_statement": {
        id: "ktx|alcohol_statement",
        defaultMessage: "Alkohol fogyasztás"
    },
    "ktx|alcoholic_liver_disease": {
        id: "ktx|alcoholic_liver_disease",
        defaultMessage: "Alkohol okozta májbetegség"
    },
    "ktx|allergy_latex": {
        id: "ktx|allergy_latex",
        defaultMessage: "Latex allergia"
    },
    "ktx|amino_acid_metabolic_disturbances": {
        id: "ktx|amino_acid_metabolic_disturbances",
        defaultMessage: "Aminósav anyagcsere zavar"
    },
    "ktx|amyloid": {
        id: "ktx|amyloid",
        defaultMessage: "83 - Amyloidosis"
    },
    "ktx|amyloidosis_oncology_disease": {
        id: "ktx|amyloidosis_oncology_disease",
        defaultMessage: "Amyloidosis"
    },
    "ktx|anaemia": {
        id: "ktx|anaemia",
        defaultMessage: "Anaemia"
    },
    "ktx|anaemia_type": {
        id: "ktx|anaemia_type",
        defaultMessage: "Anaemia típusa"
    },
    "ktx|antropometrics_examination": {
        id: "ktx|antropometrics_examination",
        defaultMessage: "Antropometria vizsgálat"
    },
    "ktx|aorta_aneurysm": {
        id: "ktx|aorta_aneurysm",
        defaultMessage: "Aorta aneurysma"
    },
    "ktx|aortic_stenosis_or_insufficiency": {
        id: "ktx|aortic_stenosis_or_insufficiency",
        defaultMessage: "Aorta stenosis és vagy elégtelenség"
    },
    "ktx|appendectomia": {
        id: "ktx|appendectomia",
        defaultMessage: "Appendectomia"
    },
    "ktx|asthma_bronchiale": {
        id: "ktx|asthma_bronchiale",
        defaultMessage: "Asthma bronchiale"
    },
    "ktx|atherosclerosis_arteriae_carotideae": {
        id: "ktx|atherosclerosis_arteriae_carotideae",
        defaultMessage: "Arteria carotis atherosclerosis"
    },
    "ktx|atrial_fibrillation_or_other_arrythmia": {
        id: "ktx|atrial_fibrillation_or_other_arrythmia",
        defaultMessage: "Pitvarfibrilláció vagy egyéb ritmuszavar"
    },
    "ktx|autoimmun_baseline_disease": {
        id: "ktx|autoimmun_baseline_disease",
        defaultMessage: "Autoimmun alapbetegség"
    },
    "ktx|balkan_nephropathy": {
        id: "ktx|balkan_nephropathy",
        defaultMessage: "94 - Balkan nephritis"
    },
    "ktx|blood_group": {
        id: "ktx|blood_group",
        defaultMessage: "Vércsoport"
    },
    "ktx|blood_pressure": {
        id: "ktx|blood_pressure",
        defaultMessage: "Vérnyomás"
    },
    "ktx|bmi": {
        id: "ktx|bmi",
        defaultMessage: "BMI"
    },
    "ktx|bsa": {
        id: "ktx|bsa",
        defaultMessage: "Testfelület (testszerkezet)"
    },
    "ktx|bsa_dubois": {
        id: "ktx|bsa_dubois",
        defaultMessage: "Body Surface Area (BSA) Dubois algoritmussal számolva"
    },
    "ktx|bsa_monsteller": {
        id: "ktx|bsa_monsteller",
        defaultMessage: "Body Surface Area (BSA) Monsteller algoritmussal számolva"
    },
    "ktx|cardiology": {
        id: "ktx|cardiology",
        defaultMessage: "Kardiológia"
    },
    "ktx|cardiology_bike_ergometry": {
        id: "ktx|cardiology_bike_ergometry",
        defaultMessage: "Kerékpár ergometria"
    },
    "ktx|cardiology_coronarography": {
        id: "ktx|cardiology_coronarography",
        defaultMessage: "Coronarográfia"
    },
    "ktx|cardiology_coronary_ct": {
        id: "ktx|cardiology_coronary_ct",
        defaultMessage: "Coronaria CT"
    },
    "ktx|cardiology_dse": {
        id: "ktx|cardiology_dse",
        defaultMessage: "DSE (Dobutamin Stress ECHO)"
    },
    "ktx|cardiology_ekg": {
        id: "ktx|cardiology_ekg",
        defaultMessage: "EKG"
    },
    "ktx|cardiology_hearth_mri": {
        id: "ktx|cardiology_hearth_mri",
        defaultMessage: "Szív MRI"
    },
    "ktx|cardiology_opinion": {
        id: "ktx|cardiology_opinion",
        defaultMessage: "Kardiológiai vélemény"
    },
    "ktx|cardiology_spect": {
        id: "ktx|cardiology_spect",
        defaultMessage: "SPECT"
    },
    "ktx|cardiology_transtorachalis_echo": {
        id: "ktx|cardiology_transtorachalis_echo",
        defaultMessage: "Transtorachalis ECHO"
    },
    "ktx|cardiovascular_disease": {
        id: "ktx|cardiovascular_disease",
        defaultMessage: "Kardiovaszkuláris betegség"
    },
    "ktx|cardiovascular_disease_type": {
        id: "ktx|cardiovascular_disease_type",
        defaultMessage: "Kardiovaszkuláris betegség típusa"
    },
    "ktx|cardiovascular_no_disease": {
        id: "ktx|cardiovascular_no_disease",
        defaultMessage: "Nincs kardiovaszkuláris betegség"
    },
    "ktx|carotis_doppler": {
        id: "ktx|carotis_doppler",
        defaultMessage: "Nyaki ultrahang (Carotis Doppler)"
    },
    "ktx|cause_of_graftloss": {
        id: "ktx|cause_of_graftloss",
        defaultMessage: "Graftvesztés oka"
    },
    "ktx|cerebral_sinus_thrombosis": {
        id: "ktx|cerebral_sinus_thrombosis",
        defaultMessage: "Agyi sinus thrombosis"
    },
    "ktx|cerebrum_oncology_disease": {
        id: "ktx|cerebrum_oncology_disease",
        defaultMessage: "Agy onkológiai betegsége"
    },
    "ktx|cervix_uteri_oncology_disease": {
        id: "ktx|cervix_uteri_oncology_disease",
        defaultMessage: "Cervix uteri"
    },
    "ktx|chest_ct": {
        id: "ktx|chest_ct",
        defaultMessage: "Mellkas CT / MR / angiográfia"
    },
    "ktx|chest_x_ray": {
        id: "ktx|chest_x_ray",
        defaultMessage: "Mellkas röntgen"
    },
    "ktx|cholecysta_pancreas_oncology_disease": {
        id: "ktx|cholecysta_pancreas_oncology_disease",
        defaultMessage: "Epehólyag onkológiai betegsége"
    },
    "ktx|cholecystectomia_LC": {
        id: "ktx|cholecystectomia_LC",
        defaultMessage: "Cholecystectomia / LC"
    },
    "ktx|chronic_rejection": {
        id: "ktx|chronic_rejection",
        defaultMessage: "Krónikus rejekció"
    },
    "ktx|chronic_renal_failure": {
        id: "ktx|chronic_renal_failure",
        defaultMessage: "00 - Krónikus vese károsodás - ismeretlen etiológia"
    },
    "ktx|coid_vaccination_COVAX-19": {
        id: "ktx|coid_vaccination_COVAX-19",
        defaultMessage: "COVAX-19"
    },
    "ktx|colonoscopy": {
        id: "ktx|colonoscopy",
        defaultMessage: "Colonoscopia"
    },
    "ktx|combined_organ_transplantation": {
        id: "ktx|combined_organ_transplantation",
        defaultMessage: "Kombinált szervtranszplantáció"
    },
    "ktx|combined_transplant": {
        id: "ktx|combined_transplant",
        defaultMessage: "combined_transplant"
    },
    "ktx|comment_for_blood_group": {
        id: "ktx|comment_for_blood_group",
        defaultMessage: "comment for blood group"
    },
    "ktx|committee_opinion_statement": {
        id: "ktx|committee_opinion_statement",
        defaultMessage: "Bizottsági vélemény"
    },
    "ktx|congenital_renal_dysplasia": {
        id: "ktx|congenital_renal_dysplasia",
        defaultMessage: "63 - Congenitalis vese dysplasia vizeletelvezető traktus malformációval vagy anélkül"
    },
    "ktx|connective_tissue_oncology_disease": {
        id: "ktx|connective_tissue_oncology_disease",
        defaultMessage: "Kötőszöveti és más lágyszövet onkológiai betegsége"
    },
    "ktx|consultation procedure": {
        id: "ktx|consultation procedure",
        defaultMessage: "Konzílium"
    },
    "ktx|coronary_disease": {
        id: "ktx|coronary_disease",
        defaultMessage: "Koronáriabetegség"
    },
    "ktx|corpus_uteri_oncology_disease": {
        id: "ktx|corpus_uteri_oncology_disease",
        defaultMessage: "Corpus uteri"
    },
    "ktx|covid_disease": {
        id: "ktx|covid_disease",
        defaultMessage: "COVID betegség"
    },
    "ktx|covid_vaccination": {
        id: "ktx|covid_vaccination",
        defaultMessage: "COVID vakcináció"
    },
    "ktx|covid_vaccination_Abdala": {
        id: "ktx|covid_vaccination_Abdala",
        defaultMessage: "Abdala"
    },
    "ktx|covid_vaccination_COVIran_Barekat": {
        id: "ktx|covid_vaccination_COVIran_Barekat",
        defaultMessage: "COVIran Barekat"
    },
    "ktx|covid_vaccination_Chinese_Academy_of_Medical_Sciences": {
        id: "ktx|covid_vaccination_Chinese_Academy_of_Medical_Sciences",
        defaultMessage: "Chinese Academy of Medical Sciences"
    },
    "ktx|covid_vaccination_CoVLP": {
        id: "ktx|covid_vaccination_CoVLP",
        defaultMessage: "CoVLP"
    },
    "ktx|covid_vaccination_Convidecia": {
        id: "ktx|covid_vaccination_Convidecia",
        defaultMessage: "Convidecia"
    },
    "ktx|covid_vaccination_Corbevax": {
        id: "ktx|covid_vaccination_Corbevax",
        defaultMessage: "Corbevax"
    },
    "ktx|covid_vaccination_CoronaVac": {
        id: "ktx|covid_vaccination_CoronaVac",
        defaultMessage: "CoronaVac"
    },
    "ktx|covid_vaccination_Covaxin": {
        id: "ktx|covid_vaccination_Covaxin",
        defaultMessage: "Covaxin"
    },
    "ktx|covid_vaccination_CoviVac": {
        id: "ktx|covid_vaccination_CoviVac",
        defaultMessage: "CoviVac"
    },
    "ktx|covid_vaccination_EpiVacCorona": {
        id: "ktx|covid_vaccination_EpiVacCorona",
        defaultMessage: "EpiVacCorona"
    },
    "ktx|covid_vaccination_Evusheld": {
        id: "ktx|covid_vaccination_Evusheld",
        defaultMessage: "Evusheld"
    },
    "ktx|covid_vaccination_FAKHRAVAC": {
        id: "ktx|covid_vaccination_FAKHRAVAC",
        defaultMessage: "FAKHRAVAC"
    },
    "ktx|covid_vaccination_Janssen": {
        id: "ktx|covid_vaccination_Janssen",
        defaultMessage: "Janssen"
    },
    "ktx|covid_vaccination_Medigen": {
        id: "ktx|covid_vaccination_Medigen",
        defaultMessage: "Medigen"
    },
    "ktx|covid_vaccination_Minhai": {
        id: "ktx|covid_vaccination_Minhai",
        defaultMessage: "Minhai"
    },
    "ktx|covid_vaccination_Moderna": {
        id: "ktx|covid_vaccination_Moderna",
        defaultMessage: "Moderna"
    },
    "ktx|covid_vaccination_Noora": {
        id: "ktx|covid_vaccination_Noora",
        defaultMessage: "Noora"
    },
    "ktx|covid_vaccination_Novavax": {
        id: "ktx|covid_vaccination_Novavax",
        defaultMessage: "Novavax"
    },
    "ktx|covid_vaccination_Oxford–AstraZeneca": {
        id: "ktx|covid_vaccination_Oxford–AstraZeneca",
        defaultMessage: "Oxford–AstraZeneca"
    },
    "ktx|covid_vaccination_Pfizer–BioNTech": {
        id: "ktx|covid_vaccination_Pfizer–BioNTech",
        defaultMessage: "Pfizer–BioNTech"
    },
    "ktx|covid_vaccination_QazCovid-in": {
        id: "ktx|covid_vaccination_QazCovid-in",
        defaultMessage: "QazCovid-in"
    },
    "ktx|covid_vaccination_Razi_Cov_Pars": {
        id: "ktx|covid_vaccination_Razi_Cov_Pars",
        defaultMessage: "Razi Cov Pars"
    },
    "ktx|covid_vaccination_SKYCovione": {
        id: "ktx|covid_vaccination_SKYCovione",
        defaultMessage: "SKYCovione"
    },
    "ktx|covid_vaccination_Sinopharm": {
        id: "ktx|covid_vaccination_Sinopharm",
        defaultMessage: "Sinopharm"
    },
    "ktx|covid_vaccination_Sinopharm_NVSI": {
        id: "ktx|covid_vaccination_Sinopharm_NVSI",
        defaultMessage: "Sinopharm NVSI"
    },
    "ktx|covid_vaccination_Sinopharm_WIBP": {
        id: "ktx|covid_vaccination_Sinopharm_WIBP",
        defaultMessage: "Sinopharm WIBP"
    },
    "ktx|covid_vaccination_Soberana_02": {
        id: "ktx|covid_vaccination_Soberana_02",
        defaultMessage: "Soberana 02"
    },
    "ktx|covid_vaccination_Soberana_Plus": {
        id: "ktx|covid_vaccination_Soberana_Plus",
        defaultMessage: "Soberana Plus"
    },
    "ktx|covid_vaccination_Sputnik": {
        id: "ktx|covid_vaccination_Sputnik",
        defaultMessage: "Sputnik"
    },
    "ktx|covid_vaccination_Sputnik_Light": {
        id: "ktx|covid_vaccination_Sputnik_Light",
        defaultMessage: "Sputnik Light"
    },
    "ktx|covid_vaccination_Turkovac": {
        id: "ktx|covid_vaccination_Turkovac",
        defaultMessage: "Turkovac"
    },
    "ktx|covid_vaccination_VLA2001": {
        id: "ktx|covid_vaccination_VLA2001",
        defaultMessage: "VLA2001"
    },
    "ktx|covid_vaccination_Zifivax": {
        id: "ktx|covid_vaccination_Zifivax",
        defaultMessage: "Zifivax"
    },
    "ktx|covid_vaccination_ZyCoV-D6": {
        id: "ktx|covid_vaccination_ZyCoV-D6",
        defaultMessage: "ZyCoV-D6"
    },
    "ktx|covid_vaccination_no": {
        id: "ktx|covid_vaccination_no",
        defaultMessage: "Nincs COVID oltás"
    },
    "ktx|covid_vaccination_type": {
        id: "ktx|covid_vaccination_type",
        defaultMessage: "COVID oltás típusa"
    },
    "ktx|covid_vaccination_unknown": {
        id: "ktx|covid_vaccination_unknown",
        defaultMessage: "Ismeretlen COVID oltás"
    },
    "ktx|cranium_CT_MR_angiography": {
        id: "ktx|cranium_CT_MR_angiography",
        defaultMessage: "Koponya CT / MR / angiográfia"
    },
    "ktx|crescentic": {
        id: "ktx|crescentic",
        defaultMessage: "16 - Rapidan progresszív glomerulonephritis szisztémás betegség nélkül"
    },
    "ktx|cryoglobulinaemic_glomerulonephritis": {
        id: "ktx|cryoglobulinaemic_glomerulonephritis",
        defaultMessage: "78 - Kryoglobulinaemias glomerulonephritis"
    },
    "ktx|cystic_kidney_disease_other_specified": {
        id: "ktx|cystic_kidney_disease_other_specified",
        defaultMessage: "49 - Cystas vesebetegség - Egyéb specifikus típus"
    },
    "ktx|cystic_kidney_disease_unspecified": {
        id: "ktx|cystic_kidney_disease_unspecified",
        defaultMessage: "40 - Cystas vesebetegség - nem azonosított típus"
    },
    "ktx|cystinosis": {
        id: "ktx|cystinosis",
        defaultMessage: "52 - Cystinosis"
    },
    "ktx|de_novo_kidney_disease": {
        id: "ktx|de_novo_kidney_disease",
        defaultMessage: "Újonnan kialakult vesebetegség"
    },
    "ktx|death_with_functioning_graft": {
        id: "ktx|death_with_functioning_graft",
        defaultMessage: "Működő vesével meghalt"
    },
    "ktx|dementia": {
        id: "ktx|dementia",
        defaultMessage: "Dementia"
    },
    "ktx|dense_deposit_disease": {
        id: "ktx|dense_deposit_disease",
        defaultMessage: "13 - Dens depozit betegség MPGN - II típus"
    },
    "ktx|dental_screening": {
        id: "ktx|dental_screening",
        defaultMessage: "Fogászat"
    },
    "ktx|dermatology": {
        id: "ktx|dermatology",
        defaultMessage: "Bőrgyógyászat"
    },
    "ktx|description_of_patient_condition": {
        id: "ktx|description_of_patient_condition",
        defaultMessage: "Bozottsági megjegyzés"
    },
    "ktx|diabetes": {
        id: "ktx|diabetes",
        defaultMessage: "Diabetes"
    },
    "ktx|diabetes_type_I": {
        id: "ktx|diabetes_type_I",
        defaultMessage: "80 - Diabetes - I típus"
    },
    "ktx|diabetes_type_II": {
        id: "ktx|diabetes_type_II",
        defaultMessage: "81 - Diabetes - II típus"
    },
    "ktx|diabetology": {
        id: "ktx|diabetology",
        defaultMessage: "Diabetológia"
    },
    "ktx|diagnosis_baseline_disease": {
        id: "ktx|diagnosis_baseline_disease",
        defaultMessage: "Vese alapbetegség diagnózis (EDTA)"
    },
    "ktx|dialatative_cardiomyopathy": {
        id: "ktx|dialatative_cardiomyopathy",
        defaultMessage: "Dilatativ cardiomyopathia"
    },
    "ktx|drug_induced_nephropathy": {
        id: "ktx|drug_induced_nephropathy",
        defaultMessage: "39 - Egyéb specifikus szer okozta nephropathia"
    },
    "ktx|drug_type": {
        id: "ktx|drug_type",
        defaultMessage: "Gyógyszer csoport"
    },
    "ktx|drug_type_OAC_NOAC": {
        id: "ktx|drug_type_OAC_NOAC",
        defaultMessage: "OAC/NOAC (orális antikoagulánsok / új orális antikoagulánsok)"
    },
    "ktx|drug_type_acei": {
        id: "ktx|drug_type_acei",
        defaultMessage: "ACEI"
    },
    "ktx|drug_type_acethylsalicilate": {
        id: "ktx|drug_type_acethylsalicilate",
        defaultMessage: "Acethylsalicilate"
    },
    "ktx|drug_type_amiodarone": {
        id: "ktx|drug_type_amiodarone",
        defaultMessage: "Amiodarone"
    },
    "ktx|drug_type_amlodipine_dhp": {
        id: "ktx|drug_type_amlodipine_dhp",
        defaultMessage: "Amlodipine - DHP"
    },
    "ktx|drug_type_arb": {
        id: "ktx|drug_type_arb",
        defaultMessage: "ARB"
    },
    "ktx|drug_type_beta_receptor inhibitor": {
        id: "ktx|drug_type_beta_receptor inhibitor",
        defaultMessage: "ß blokkoló"
    },
    "ktx|drug_type_calcium_contain_phospphate_binders": {
        id: "ktx|drug_type_calcium_contain_phospphate_binders",
        defaultMessage: "Calcium tartalmú P kötő"
    },
    "ktx|drug_type_clopidogrel": {
        id: "ktx|drug_type_clopidogrel",
        defaultMessage: "Clopidogrel"
    },
    "ktx|drug_type_diuretics": {
        id: "ktx|drug_type_diuretics",
        defaultMessage: "Diuretikum"
    },
    "ktx|drug_type_erythropoetin_product": {
        id: "ktx|drug_type_erythropoetin_product",
        defaultMessage: "Erythropoietin készítmény"
    },
    "ktx|drug_type_nonDHP": {
        id: "ktx|drug_type_nonDHP",
        defaultMessage: "Verapamil diltiazem"
    },
    "ktx|drug_type_other": {
        id: "ktx|drug_type_other",
        defaultMessage: "Egyéb gyógyszer csoport"
    },
    "ktx|drug_type_other_TAGs_thrombocyte_aggregation_inhibitors": {
        id: "ktx|drug_type_other_TAGs_thrombocyte_aggregation_inhibitors",
        defaultMessage: "Egyéb TAG"
    },
    "ktx|drug_type_vitamine_D_product": {
        id: "ktx|drug_type_vitamine_D_product",
        defaultMessage: "D vitamin anyagcserére ható készítmények"
    },
    "ktx|ear_nose_throat": {
        id: "ktx|ear_nose_throat",
        defaultMessage: "Fül-Orr-Gégészet"
    },
    "ktx|endocrinology": {
        id: "ktx|endocrinology",
        defaultMessage: "Endokrinológia"
    },
    "ktx|eyes_oncology_disease": {
        id: "ktx|eyes_oncology_disease",
        defaultMessage: "Szem onkológiai betegsége"
    },
    "ktx|fabrys_disease": {
        id: "ktx|fabrys_disease",
        defaultMessage: "54 - Fabry-kór"
    },
    "ktx|focal_segmental_glomerulosclerosis_in_adults": {
        id: "ktx|focal_segmental_glomerulosclerosis_in_adults",
        defaultMessage: "17 - Fokális szegmentális glomerulosclerosis nefrózis szindrómával felnőttkorban"
    },
    "ktx|focal_segmental_glomerulosclerosis_in_children": {
        id: "ktx|focal_segmental_glomerulosclerosis_in_children",
        defaultMessage: "11 - Fokális szegmentális glomerulosclerosis nefrózis szindromával gyermekkorban"
    },
    "ktx|food_allergy": {
        id: "ktx|food_allergy",
        defaultMessage: "Ételallergia"
    },
    "ktx|food_allergy_gluten": {
        id: "ktx|food_allergy_gluten",
        defaultMessage: "Glutén"
    },
    "ktx|food_allergy_lactose": {
        id: "ktx|food_allergy_lactose",
        defaultMessage: "Laktóz"
    },
    "ktx|food_allergy_no": {
        id: "ktx|food_allergy_no",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|food_allergy_other": {
        id: "ktx|food_allergy_other",
        defaultMessage: "Egyéb étel allergia"
    },
    "ktx|gastroenterology": {
        id: "ktx|gastroenterology",
        defaultMessage: "Gasztroenterológia"
    },
    "ktx|genetics": {
        id: "ktx|genetics",
        defaultMessage: "Genetika"
    },
    "ktx|glandula_salivaris_oncology_disease": {
        id: "ktx|glandula_salivaris_oncology_disease",
        defaultMessage: "Nyálmirigy onkológiai betegsége"
    },
    "ktx|glandula_thyroida_oncology_disease": {
        id: "ktx|glandula_thyroida_oncology_disease",
        defaultMessage: "Pajzsmirigy onkológiai betegsége"
    },
    "ktx|glomerulonephritis_histologically_examined": {
        id: "ktx|glomerulonephritis_histologically_examined",
        defaultMessage: "19 - Glomerulonephritis - szövettanilag vizsgált"
    },
    "ktx|glomerulonephritis_histologically_not_examined": {
        id: "ktx|glomerulonephritis_histologically_not_examined",
        defaultMessage: "10 - Glomerulonephritis - szövettanilag nem vizsgált"
    },
    "ktx|glomerulonephritis_related_to_liver_cirrhosis": {
        id: "ktx|glomerulonephritis_related_to_liver_cirrhosis",
        defaultMessage: "76 - Glomerulonephritis - máj cirrhosishoz társuló"
    },
    "ktx|goodpastures_syndrome": {
        id: "ktx|goodpastures_syndrome",
        defaultMessage: "86 - Goodpasture szindróma"
    },
    "ktx|gout": {
        id: "ktx|gout",
        defaultMessage: "92 - Urát nephropathia (köszvény)"
    },
    "ktx|graft_infection": {
        id: "ktx|graft_infection",
        defaultMessage: "Graft infekció"
    },
    "ktx|graftectomy": {
        id: "ktx|graftectomy",
        defaultMessage: "Graftectomia"
    },
    "ktx|graftectomy_ld": {
        id: "ktx|graftectomy_ld",
        defaultMessage: "Graftectomia ld"
    },
    "ktx|graftectomy_ls": {
        id: "ktx|graftectomy_ls",
        defaultMessage: "Graftectomia ls"
    },
    "ktx|graftectomy_nephrectomy_no": {
        id: "ktx|graftectomy_nephrectomy_no",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|graftloss_statement": {
        id: "ktx|graftloss_statement",
        defaultMessage: "Graftvesztés"
    },
    "ktx|gynecology": {
        id: "ktx|gynecology",
        defaultMessage: "Nőgyógyászat"
    },
    "ktx|haemolytic_uraemic_syndrome": {
        id: "ktx|haemolytic_uraemic_syndrome",
        defaultMessage: "88 - Hemolitikus Uraemias Szindróma beleértve a Moskowitz szindromát"
    },
    "ktx|haemorrhagic_stroke": {
        id: "ktx|haemorrhagic_stroke",
        defaultMessage: "Hemorrhágiás stroke"
    },
    "ktx|haemostaseology": {
        id: "ktx|haemostaseology",
        defaultMessage: "Thromboembolia"
    },
    "ktx|haemostaseology_type": {
        id: "ktx|haemostaseology_type",
        defaultMessage: "Thromboembolia típusa"
    },
    "ktx|haemostaseology_type_no": {
        id: "ktx|haemostaseology_type_no",
        defaultMessage: "Nincs thromboembolia"
    },
    "ktx|haemostaseology_type_other": {
        id: "ktx|haemostaseology_type_other",
        defaultMessage: "Egyéb thromboembolia"
    },
    "ktx|has_cardiovascular_disease": {
        id: "ktx|has_cardiovascular_disease",
        defaultMessage: "Diagnosztizált kardiovaszkuláris betegség"
    },
    "ktx|has_cardiovascular_disease_choice": {
        id: "ktx|has_cardiovascular_disease_choice",
        defaultMessage: "Kardiovaszkuláris betegség választás"
    },
    "ktx|has_combined_organ_transplantation": {
        id: "ktx|has_combined_organ_transplantation",
        defaultMessage: "Javasolt kombinált szervtranszplantáció"
    },
    "ktx|has_graftloss": {
        id: "ktx|has_graftloss",
        defaultMessage: "Történt graftvesztés"
    },
    "ktx|has_graftloss_choice": {
        id: "ktx|has_graftloss_choice",
        defaultMessage: "Graftvesztés választás"
    },
    "ktx|has_haemostaseology_disease": {
        id: "ktx|has_haemostaseology_disease",
        defaultMessage: "Diagnosztizált Thromboembolia"
    },
    "ktx|has_haemostaseology_disease_choice": {
        id: "ktx|has_haemostaseology_disease_choice",
        defaultMessage: "Thromboembolia választás"
    },
    "ktx|has_metabolic_disease": {
        id: "ktx|has_metabolic_disease",
        defaultMessage: "Diagnosztizált anyagcsere betegség"
    },
    "ktx|has_metabolic_disease_choice": {
        id: "ktx|has_metabolic_disease_choice",
        defaultMessage: "Anyagcsere betegség választás"
    },
    "ktx|has_nephrectomy_graftectomy_disease": {
        id: "ktx|has_nephrectomy_graftectomy_disease",
        defaultMessage: "Diagnosztizált Nephrectomia / Graftectomia betegség"
    },
    "ktx|has_nephrectomy_graftectomy_disease_choice": {
        id: "ktx|has_nephrectomy_graftectomy_disease_choice",
        defaultMessage: "Nephrectomia / Graftectomia betegség választás"
    },
    "ktx|has_oncology_disease": {
        id: "ktx|has_oncology_disease",
        defaultMessage: "Diagnosztizált onkológiai betegség"
    },
    "ktx|has_oncology_disease_choice": {
        id: "ktx|has_oncology_disease_choice",
        defaultMessage: "Onkológiai betegség választás"
    },
    "ktx|has_other_disorder_disease": {
        id: "ktx|has_other_disorder_disease",
        defaultMessage: "Diagnosztizált egyéb belgyógyászati betegség"
    },
    "ktx|has_other_disorder_disease_choice": {
        id: "ktx|has_other_disorder_disease_choice",
        defaultMessage: "Egyéb belgyógyászati betegség választás"
    },
    "ktx|has_other_surgical_intervention": {
        id: "ktx|has_other_surgical_intervention",
        defaultMessage: "Diagnosztizált egyéb sebészeti beavatkozás"
    },
    "ktx|has_other_surgical_intervention_choice": {
        id: "ktx|has_other_surgical_intervention_choice",
        defaultMessage: "Egyéb sebészeti beavatkozás választás"
    },
    "ktx|has_previous_other_organ_transplantation": {
        id: "ktx|has_previous_other_organ_transplantation",
        defaultMessage: "Történt korábbi transzplantáció"
    },
    "ktx|has_previous_other_organ_transplantation_choice": {
        id: "ktx|has_previous_other_organ_transplantation_choice",
        defaultMessage: "Egyéb korábbi szerv transzplantáció választás"
    },
    "ktx|has_renal_anaemia_hepatology_disease": {
        id: "ktx|has_renal_anaemia_hepatology_disease",
        defaultMessage: "Diagnosztizált renális anaemia - hematológia"
    },
    "ktx|has_renal_anaemia_hepatology_disease_choice": {
        id: "ktx|has_renal_anaemia_hepatology_disease_choice",
        defaultMessage: "Renális anaemia - hematológia választás"
    },
    "ktx|hbv_chronic_liver_failure_statement": {
        id: "ktx|hbv_chronic_liver_failure_statement",
        defaultMessage: "Krónikus májelégtelenség - HBV"
    },
    "ktx|hcv_chronic_liver_failure_statement": {
        id: "ktx|hcv_chronic_liver_failure_statement",
        defaultMessage: "Krónikus májelégtelenség - HCV"
    },
    "ktx|height": {
        id: "ktx|height",
        defaultMessage: "Magasság"
    },
    "ktx|hematology": {
        id: "ktx|hematology",
        defaultMessage: "Haematológia"
    },
    "ktx|henoch_Schoenlein_purpura": {
        id: "ktx|henoch_Schoenlein_purpura",
        defaultMessage: "85 - Henoch-Schönlein Purpura"
    },
    "ktx|hepatology": {
        id: "ktx|hepatology",
        defaultMessage: "Hepatológia"
    },
    "ktx|hepatology_disease": {
        id: "ktx|hepatology_disease",
        defaultMessage: "Hepatológiai betegség"
    },
    "ktx|hepatology_no_disease": {
        id: "ktx|hepatology_no_disease",
        defaultMessage: "Nincs hepatológiai betegség"
    },
    "ktx|hereditary_Familial_nephropathy": {
        id: "ktx|hereditary_Familial_nephropathy",
        defaultMessage: "50 - Herediter/Familiaris nephropathia - nem azonosított típus"
    },
    "ktx|hereditary_nephritis_with_nerve_deafness": {
        id: "ktx|hereditary_nephritis_with_nerve_deafness",
        defaultMessage: "51 - Herediter nephritis idegi hallásvesztéssel (Alport-szindróma)"
    },
    "ktx|hereditary_nephropathy": {
        id: "ktx|hereditary_nephropathy",
        defaultMessage: "59 - Herediter nephropathia - Egyéb"
    },
    "ktx|hernioplastica_inguinalis_ld": {
        id: "ktx|hernioplastica_inguinalis_ld",
        defaultMessage: "Hernioplastica inguinalis ld"
    },
    "ktx|hernioplastica_inguinalis_ls": {
        id: "ktx|hernioplastica_inguinalis_ls",
        defaultMessage: "Hernioplastica inguinalis ls"
    },
    "ktx|hernoplastica_par_abdominalis": {
        id: "ktx|hernoplastica_par_abdominalis",
        defaultMessage: "Hernioplastica par abdominalis"
    },
    "ktx|hodgkin_disease": {
        id: "ktx|hodgkin_disease",
        defaultMessage: "Hodgkin betegség"
    },
    "ktx|hyper_immunised": {
        id: "ktx|hyper_immunised",
        defaultMessage: "hyper_immunised"
    },
    "ktx|hyperthrophic_cardiomyopathy": {
        id: "ktx|hyperthrophic_cardiomyopathy",
        defaultMessage: "Hyperthrophiás cardiomyopathia"
    },
    "ktx|hyperthyreosis": {
        id: "ktx|hyperthyreosis",
        defaultMessage: "Pajzsmirigy túlműködés"
    },
    "ktx|hypothyreosis": {
        id: "ktx|hypothyreosis",
        defaultMessage: "Pajzsmirigy alulműködés"
    },
    "ktx|imaging_procedure": {
        id: "ktx|imaging_procedure",
        defaultMessage: "Képalkotó vizsgálat"
    },
    "ktx|immunology": {
        id: "ktx|immunology",
        defaultMessage: "Immunológia"
    },
    "ktx|interstitial_nephritis_not_pyelonephritis": {
        id: "ktx|interstitial_nephritis_not_pyelonephritis",
        defaultMessage: "30 - Tubulo-interstitialis nephritis (nem pyelonephritis)"
    },
    "ktx|ischaemic_renal_disease": {
        id: "ktx|ischaemic_renal_disease",
        defaultMessage: "75 - Ischemias vesebetegség / cholesterol embolisatio"
    },
    "ktx|kaposi_sarcoma_oncology_disease": {
        id: "ktx|kaposi_sarcoma_oncology_disease",
        defaultMessage: "Kaposi sarcoma"
    },
    "ktx|kidney_biopsy": {
        id: "ktx|kidney_biopsy",
        defaultMessage: "Vesebiopszia"
    },
    "ktx|kidney_disease_ethiology": {
        id: "ktx|kidney_disease_ethiology",
        defaultMessage: "Vesebetegség diagnózisa"
    },
    "ktx|kidney_disease_ethiology_statement": {
        id: "ktx|kidney_disease_ethiology_statement",
        defaultMessage: "Veseelégtelenség etiológiája"
    },
    "ktx|kidney_transplant": {
        id: "ktx|kidney_transplant",
        defaultMessage: "Vesetranszplantáció"
    },
    "ktx|kidney_tumour": {
        id: "ktx|kidney_tumour",
        defaultMessage: "95 - Vese tumor"
    },
    "ktx|lab_CRP": {
        id: "ktx|lab_CRP",
        defaultMessage: "hsCRP"
    },
    "ktx|lab_HbA1c_calculated": {
        id: "ktx|lab_HbA1c_calculated",
        defaultMessage: "HbA1c (visszaszámolt)"
    },
    "ktx|lab_HgbA1C": {
        id: "ktx|lab_HgbA1C",
        defaultMessage: "HgbA1c (IFCC)"
    },
    "ktx|lab_LDL_cholesterol": {
        id: "ktx|lab_LDL_cholesterol",
        defaultMessage: "LDL Koleszterin"
    },
    "ktx|lab_PSA": {
        id: "ktx|lab_PSA",
        defaultMessage: "PSA"
    },
    "ktx|lab_T3": {
        id: "ktx|lab_T3",
        defaultMessage: "T3"
    },
    "ktx|lab_T4": {
        id: "ktx|lab_T4",
        defaultMessage: "T4"
    },
    "ktx|lab_TSH": {
        id: "ktx|lab_TSH",
        defaultMessage: "TSH"
    },
    "ktx|lab_albumin": {
        id: "ktx|lab_albumin",
        defaultMessage: "Albumin"
    },
    "ktx|lab_alkaline_phosphatase": {
        id: "ktx|lab_alkaline_phosphatase",
        defaultMessage: "Alkalikus foszfatáz"
    },
    "ktx|lab_bilirubin_direct": {
        id: "ktx|lab_bilirubin_direct",
        defaultMessage: "Bilirubin (direkt)"
    },
    "ktx|lab_bilirubin_total": {
        id: "ktx|lab_bilirubin_total",
        defaultMessage: "Bilirubin (total)"
    },
    "ktx|lab_calcium": {
        id: "ktx|lab_calcium",
        defaultMessage: "Kálcium"
    },
    "ktx|lab_combined_kidney_pancreas": {
        id: "ktx|lab_combined_kidney_pancreas",
        defaultMessage: "Kombinált Vese-Hasnyálmirigy"
    },
    "ktx|lab_creatinine": {
        id: "ktx|lab_creatinine",
        defaultMessage: "Kreatinin"
    },
    "ktx|lab_eGFR": {
        id: "ktx|lab_eGFR",
        defaultMessage: "eGFR"
    },
    "ktx|lab_fasting_glucose": {
        id: "ktx|lab_fasting_glucose",
        defaultMessage: "Glükóz (éhomi)"
    },
    "ktx|lab_ferritine": {
        id: "ktx|lab_ferritine",
        defaultMessage: "Ferritin"
    },
    "ktx|lab_ggt": {
        id: "ktx|lab_ggt",
        defaultMessage: "GGT (gamma GT)"
    },
    "ktx|lab_got": {
        id: "ktx|lab_got",
        defaultMessage: "SGOT (ASAT) "
    },
    "ktx|lab_gpt": {
        id: "ktx|lab_gpt",
        defaultMessage: "SGPT (ALAT)"
    },
    "ktx|lab_haemoglobin": {
        id: "ktx|lab_haemoglobin",
        defaultMessage: "Hemoglobin"
    },
    "ktx|lab_iPTH": {
        id: "ktx|lab_iPTH",
        defaultMessage: "iPTH"
    },
    "ktx|lab_inr": {
        id: "ktx|lab_inr",
        defaultMessage: "INR"
    },
    "ktx|lab_other_procedure": {
        id: "ktx|lab_other_procedure",
        defaultMessage: "Egyéb laborvizsgálat"
    },
    "ktx|lab_phosphate": {
        id: "ktx|lab_phosphate",
        defaultMessage: "Foszfát"
    },
    "ktx|lab_potassium": {
        id: "ktx|lab_potassium",
        defaultMessage: "Kálium"
    },
    "ktx|lab_procedure": {
        id: "ktx|lab_procedure",
        defaultMessage: "Laborvizsgálat"
    },
    "ktx|lab_rest_diuresis": {
        id: "ktx|lab_rest_diuresis",
        defaultMessage: "Maradék vizelet mennyiség"
    },
    "ktx|lab_serum_glucose": {
        id: "ktx|lab_serum_glucose",
        defaultMessage: "Vércukor"
    },
    "ktx|lab_serum_iron": {
        id: "ktx|lab_serum_iron",
        defaultMessage: "Fe"
    },
    "ktx|lab_sodium": {
        id: "ktx|lab_sodium",
        defaultMessage: "Nátrium"
    },
    "ktx|lab_stool_blood": {
        id: "ktx|lab_stool_blood",
        defaultMessage: "Széklet vér vizsgálat (3X)"
    },
    "ktx|lab_stool_culture": {
        id: "ktx|lab_stool_culture",
        defaultMessage: "Széklettenyésztés"
    },
    "ktx|lab_thrombocyte": {
        id: "ktx|lab_thrombocyte",
        defaultMessage: "Trombocyta"
    },
    "ktx|lab_total_cholesterol": {
        id: "ktx|lab_total_cholesterol",
        defaultMessage: "Össz. Koleszterin"
    },
    "ktx|lab_total_iron_binding_capacity": {
        id: "ktx|lab_total_iron_binding_capacity",
        defaultMessage: "TVK"
    },
    "ktx|lab_total_protein": {
        id: "ktx|lab_total_protein",
        defaultMessage: "Összfehérje"
    },
    "ktx|lab_total_urine_analysis": {
        id: "ktx|lab_total_urine_analysis",
        defaultMessage: "Teljes vizelet"
    },
    "ktx|lab_transferrin_saturation": {
        id: "ktx|lab_transferrin_saturation",
        defaultMessage: "TFS"
    },
    "ktx|lab_triglyceride": {
        id: "ktx|lab_triglyceride",
        defaultMessage: "Triglicerid"
    },
    "ktx|lab_urate": {
        id: "ktx|lab_urate",
        defaultMessage: "Húgysav"
    },
    "ktx|lab_urea_nitrogen": {
        id: "ktx|lab_urea_nitrogen",
        defaultMessage: "Karbamid"
    },
    "ktx|lab_urine_culture": {
        id: "ktx|lab_urine_culture",
        defaultMessage: "Vizelettenyésztés"
    },
    "ktx|lab_urine_protein_creatinine_ratio": {
        id: "ktx|lab_urine_protein_creatinine_ratio",
        defaultMessage: "Vizelet Fehérje / Kreatinin hányados"
    },
    "ktx|lab_white_blood_cell_count": {
        id: "ktx|lab_white_blood_cell_count",
        defaultMessage: "Fehérvérsejt szám"
    },
    "ktx|lactose_intolerance": {
        id: "ktx|lactose_intolerance",
        defaultMessage: "Laktóz intolerancia"
    },
    "ktx|larynx_oncology_disease": {
        id: "ktx|larynx_oncology_disease",
        defaultMessage: "Gége onkológiai betegsége"
    },
    "ktx|leukaemia_oncology_disease": {
        id: "ktx|leukaemia_oncology_disease",
        defaultMessage: "Leukaemia"
    },
    "ktx|leukopaenia": {
        id: "ktx|leukopaenia",
        defaultMessage: "Leukopaenia"
    },
    "ktx|lipoprotein_disturbances": {
        id: "ktx|lipoprotein_disturbances",
        defaultMessage: "Lipoprotein anyagcsere zavar"
    },
    "ktx|lips_oncology_disease": {
        id: "ktx|lips_oncology_disease",
        defaultMessage: "Ajak onkológiai betegsége"
    },
    "ktx|live_donor_screening": {
        id: "ktx|live_donor_screening",
        defaultMessage: "Élődonor kivizsgálás"
    },
    "ktx|liver_failure": {
        id: "ktx|liver_failure",
        defaultMessage: "Májelégtelenség"
    },
    "ktx|lower_limb_CT_MR_angiography": {
        id: "ktx|lower_limb_CT_MR_angiography",
        defaultMessage: "Alsó végtag CT / MR / angiográfia"
    },
    "ktx|lower_limb_deep_vein_thrombosis": {
        id: "ktx|lower_limb_deep_vein_thrombosis",
        defaultMessage: "Alsó végtagi mélyvénás thrombosis"
    },
    "ktx|lung_oncology_disease": {
        id: "ktx|lung_oncology_disease",
        defaultMessage: "Tüdő onkológiai betegsége"
    },
    "ktx|lupus_erythematosus": {
        id: "ktx|lupus_erythematosus",
        defaultMessage: "84 - Lupus Erythematosus"
    },
    "ktx|macrocyter_anaemia": {
        id: "ktx|macrocyter_anaemia",
        defaultMessage: "Macrocyter anaemia"
    },
    "ktx|macrovascular_consequence": {
        id: "ktx|macrovascular_consequence",
        defaultMessage: "Makrovaszkuláris szövődmény"
    },
    "ktx|malignant_disease_of_the_liver": {
        id: "ktx|malignant_disease_of_the_liver",
        defaultMessage: "Máj malignus betegsége"
    },
    "ktx|mamma_oncology_disease": {
        id: "ktx|mamma_oncology_disease",
        defaultMessage: "Emlő onkológiai betegsége"
    },
    "ktx|mammography": {
        id: "ktx|mammography",
        defaultMessage: "Mammográfia"
    },
    "ktx|medical_treatment_statement": {
        id: "ktx|medical_treatment_statement",
        defaultMessage: "Gyógyszeres kezelés"
    },
    "ktx|medicine_active_ingredient": {
        id: "ktx|medicine_active_ingredient",
        defaultMessage: "Gyógyszer hatóanyag"
    },
    "ktx|medicine_diagnosis": {
        id: "ktx|medicine_diagnosis",
        defaultMessage: "Belgyógyászati betegség"
    },
    "ktx|medicine_diagnosis_none_unknown": {
        id: "ktx|medicine_diagnosis_none_unknown",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|medicine_sensitivity": {
        id: "ktx|medicine_sensitivity",
        defaultMessage: "Gyógyszerérzékenység"
    },
    "ktx|medicine_sensitivity_NSAID": {
        id: "ktx|medicine_sensitivity_NSAID",
        defaultMessage: "NSAID"
    },
    "ktx|medicine_sensitivity_RASI": {
        id: "ktx|medicine_sensitivity_RASI",
        defaultMessage: "RASI"
    },
    "ktx|medicine_sensitivity_acethylsalicilate": {
        id: "ktx|medicine_sensitivity_acethylsalicilate",
        defaultMessage: "Acethylsalicilate"
    },
    "ktx|medicine_sensitivity_amlodipine": {
        id: "ktx|medicine_sensitivity_amlodipine",
        defaultMessage: "Amlodipine"
    },
    "ktx|medicine_sensitivity_beta_receptor_antagonists": {
        id: "ktx|medicine_sensitivity_beta_receptor_antagonists",
        defaultMessage: "ß blokkoló"
    },
    "ktx|medicine_sensitivity_cephalosporine": {
        id: "ktx|medicine_sensitivity_cephalosporine",
        defaultMessage: "Cephalosporin"
    },
    "ktx|medicine_sensitivity_digitalis": {
        id: "ktx|medicine_sensitivity_digitalis",
        defaultMessage: "Digitalis"
    },
    "ktx|medicine_sensitivity_fluorocinolone": {
        id: "ktx|medicine_sensitivity_fluorocinolone",
        defaultMessage: "Fluorokinolon"
    },
    "ktx|medicine_sensitivity_no": {
        id: "ktx|medicine_sensitivity_no",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|medicine_sensitivity_other": {
        id: "ktx|medicine_sensitivity_other",
        defaultMessage: "Egyéb gyógyszerérzékenység"
    },
    "ktx|medicine_sensitivity_penicillin": {
        id: "ktx|medicine_sensitivity_penicillin",
        defaultMessage: "Penicillin"
    },
    "ktx|medicine_sensitivity_sulfametaxasole_thrometoprim": {
        id: "ktx|medicine_sensitivity_sulfametaxasole_thrometoprim",
        defaultMessage: "Sulfametaxasole / Thrometoprim"
    },
    "ktx|medicine_sensitivity_vancomycin": {
        id: "ktx|medicine_sensitivity_vancomycin",
        defaultMessage: "Vancomycin"
    },
    "ktx|medullary_cystic_disease": {
        id: "ktx|medullary_cystic_disease",
        defaultMessage: "43 - Medullaris cystas betegség - nephronophtisis"
    },
    "ktx|melanoma_oncology_disease": {
        id: "ktx|melanoma_oncology_disease",
        defaultMessage: "Melanoma"
    },
    "ktx|membrano_proliferative": {
        id: "ktx|membrano_proliferative",
        defaultMessage: "15 - Membranoproliferatív glomerulonephritis - I típus"
    },
    "ktx|membranous_nephropathy": {
        id: "ktx|membranous_nephropathy",
        defaultMessage: "14 - Membranozus nefropathia"
    },
    "ktx|mesothelioma_oncology_disease": {
        id: "ktx|mesothelioma_oncology_disease",
        defaultMessage: "Mesothelioma"
    },
    "ktx|metabolic_disease": {
        id: "ktx|metabolic_disease",
        defaultMessage: "Anyagcsere betegség"
    },
    "ktx|metabolic_disease_type": {
        id: "ktx|metabolic_disease_type",
        defaultMessage: "Anyagcsere betegség"
    },
    "ktx|metabolic_liver_disease": {
        id: "ktx|metabolic_liver_disease",
        defaultMessage: "Metabolikus májbetegség"
    },
    "ktx|metabolic_no_disease": {
        id: "ktx|metabolic_no_disease",
        defaultMessage: "Nincs anyagcsere betegség"
    },
    "ktx|microbiological_cmv": {
        id: "ktx|microbiological_cmv",
        defaultMessage: "CMV (Citomegalovírus)"
    },
    "ktx|microbiological_ebv": {
        id: "ktx|microbiological_ebv",
        defaultMessage: "EBV (Epstein–Barr-vírus)"
    },
    "ktx|microbiological_hbv_status": {
        id: "ktx|microbiological_hbv_status",
        defaultMessage: "HBV státusz"
    },
    "ktx|microbiological_hcv": {
        id: "ktx|microbiological_hcv",
        defaultMessage: "HCV"
    },
    "ktx|microbiological_hiv": {
        id: "ktx|microbiological_hiv",
        defaultMessage: "HIV"
    },
    "ktx|microbiological_hsv1": {
        id: "ktx|microbiological_hsv1",
        defaultMessage: "HSV1"
    },
    "ktx|microbiological_hsv2": {
        id: "ktx|microbiological_hsv2",
        defaultMessage: "HSV2"
    },
    "ktx|microbiological_procedure": {
        id: "ktx|microbiological_procedure",
        defaultMessage: "Mikrobiológiai vizsgálat"
    },
    "ktx|microbiological_toxoplasma": {
        id: "ktx|microbiological_toxoplasma",
        defaultMessage: "Toxoplazma"
    },
    "ktx|microbiological_treponema_pallidum": {
        id: "ktx|microbiological_treponema_pallidum",
        defaultMessage: "Treponema pallidum (szifilisz)"
    },
    "ktx|microbiological_varicella": {
        id: "ktx|microbiological_varicella",
        defaultMessage: "Varicella"
    },
    "ktx|microcyter_anaemia": {
        id: "ktx|microcyter_anaemia",
        defaultMessage: "Microcyter anaemia"
    },
    "ktx|microvascular_consequence": {
        id: "ktx|microvascular_consequence",
        defaultMessage: "Microvaszkuláris szövődmény"
    },
    "ktx|miscellaneous": {
        id: "ktx|miscellaneous",
        defaultMessage: "Egyéb"
    },
    "ktx|mitral_stenosis_or_insufficiency": {
        id: "ktx|mitral_stenosis_or_insufficiency",
        defaultMessage: "Mitrális billentyű stenosis és vagy elégtelenség"
    },
    "ktx|mouth_oncology_disease": {
        id: "ktx|mouth_oncology_disease",
        defaultMessage: "Száj onkológiai betegsége"
    },
    "ktx|multi_system_disease_other": {
        id: "ktx|multi_system_disease_other",
        defaultMessage: "89 - Multiszisztema betegség - egyéb specifikus típus"
    },
    "ktx|multiple_myeloma_oncology_disease": {
        id: "ktx|multiple_myeloma_oncology_disease",
        defaultMessage: "Myeloma multiplex"
    },
    "ktx|myelomatosis": {
        id: "ktx|myelomatosis",
        defaultMessage: "82 - Myelomatosis - könnyűlánc deposit betegség"
    },
    "ktx|native_abdominal_x-ray": {
        id: "ktx|native_abdominal_x-ray",
        defaultMessage: "Natív hasi röntgen"
    },
    "ktx|neck_CT_MR_angiography": {
        id: "ktx|neck_CT_MR_angiography",
        defaultMessage: "Nyak CT / MR / angiográfia"
    },
    "ktx|neoplasms_of_bone_marrow_oncology_disease": {
        id: "ktx|neoplasms_of_bone_marrow_oncology_disease",
        defaultMessage: "Csontvelő egyéb rosszindulatú daganata"
    },
    "ktx|nephrectomy": {
        id: "ktx|nephrectomy",
        defaultMessage: "Nephrectomia"
    },
    "ktx|nephrectomy_graftectomy": {
        id: "ktx|nephrectomy_graftectomy",
        defaultMessage: "Nephrectomia vagy Graftectomia"
    },
    "ktx|nephrectomy_ld": {
        id: "ktx|nephrectomy_ld",
        defaultMessage: "Nephrectomia ld"
    },
    "ktx|nephrectomy_ls": {
        id: "ktx|nephrectomy_ls",
        defaultMessage: "Nephrectomia ls"
    },
    "ktx|nephrectomy_lu": {
        id: "ktx|nephrectomy_lu",
        defaultMessage: "Nephrectomia lu"
    },
    "ktx|nephrocalcinosis_hypercalcaemic_nephropathy": {
        id: "ktx|nephrocalcinosis_hypercalcaemic_nephropathy",
        defaultMessage: "93 - Nephrocalcinosis és hypercalcaemias nephropathia"
    },
    "ktx|nephropathy_interstitial_due_to_analgesic_drugs": {
        id: "ktx|nephropathy_interstitial_due_to_analgesic_drugs",
        defaultMessage: "31 - Nefropathia analgetikus szer miatt"
    },
    "ktx|nephropathy_interstitial_due_to_cyclosporin_A": {
        id: "ktx|nephropathy_interstitial_due_to_cyclosporin_A",
        defaultMessage: "33 - Nefropathia Cyclosporin A miatt"
    },
    "ktx|neurology": {
        id: "ktx|neurology",
        defaultMessage: "Neurológia"
    },
    "ktx|no_anaemia": {
        id: "ktx|no_anaemia",
        defaultMessage: "Ismeretlen Anaemia"
    },
    "ktx|no_combined_organ_transplantation": {
        id: "ktx|no_combined_organ_transplantation",
        defaultMessage: "Nem javasolt kombinált szervtranszplantáció"
    },
    "ktx|no_unknown_cardiovascular_disease": {
        id: "ktx|no_unknown_cardiovascular_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_graftloss": {
        id: "ktx|no_unknown_graftloss",
        defaultMessage: "Nem történt vagy nem ismert"
    },
    "ktx|no_unknown_haemostaseology_disease": {
        id: "ktx|no_unknown_haemostaseology_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_metabolic_disease": {
        id: "ktx|no_unknown_metabolic_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_nephrectomy_graftectomy_disease": {
        id: "ktx|no_unknown_nephrectomy_graftectomy_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_oncology_disease": {
        id: "ktx|no_unknown_oncology_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_other_disorder_disease": {
        id: "ktx|no_unknown_other_disorder_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_other_surgical_intervention": {
        id: "ktx|no_unknown_other_surgical_intervention",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|no_unknown_previous_other_organ_transplantation": {
        id: "ktx|no_unknown_previous_other_organ_transplantation",
        defaultMessage: "Nem történt korábbi transzplantáció"
    },
    "ktx|no_unknown_renal_anaemia_hepatology_disease": {
        id: "ktx|no_unknown_renal_anaemia_hepatology_disease",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|non-complience": {
        id: "ktx|non-complience",
        defaultMessage: "Non-complience"
    },
    "ktx|non_hodgkin_disease": {
        id: "ktx|non_hodgkin_disease",
        defaultMessage: "Non Hodgkin lymphoma"
    },
    "ktx|non_specific_graft_failure": {
        id: "ktx|non_specific_graft_failure",
        defaultMessage: "Nem specifikus graftelégtelenség"
    },
    "ktx|nonalcoholic_fatty_liver_disease": {
        id: "ktx|nonalcoholic_fatty_liver_disease",
        defaultMessage: "Nem alkoholos zsírmáj"
    },
    "ktx|normocyter_anaemia": {
        id: "ktx|normocyter_anaemia",
        defaultMessage: "Normocyter anaemia"
    },
    "ktx|oesophagus_oncology_disease": {
        id: "ktx|oesophagus_oncology_disease",
        defaultMessage: "Nyelőcső onkológiai betegsége"
    },
    "ktx|oligomeganephronic_hypoplasia": {
        id: "ktx|oligomeganephronic_hypoplasia",
        defaultMessage: "61 - Oligomeganephronos hypoplasia"
    },
    "ktx|oncology": {
        id: "ktx|oncology",
        defaultMessage: "Onkológia"
    },
    "ktx|oncology_disease": {
        id: "ktx|oncology_disease",
        defaultMessage: "Onkológiai betegség"
    },
    "ktx|oncology_disease_type": {
        id: "ktx|oncology_disease_type",
        defaultMessage: "Onkológiai betegség"
    },
    "ktx|oncology_no_disease": {
        id: "ktx|oncology_no_disease",
        defaultMessage: "Nincs onkológiai betegség"
    },
    "ktx|ophthalmology": {
        id: "ktx|ophthalmology",
        defaultMessage: "Szemészet"
    },
    "ktx|other_allergy": {
        id: "ktx|other_allergy",
        defaultMessage: "Egyéb allergia"
    },
    "ktx|other_cardiovascular_disease": {
        id: "ktx|other_cardiovascular_disease",
        defaultMessage: "Egyéb kardiovaszkuláris betegség"
    },
    "ktx|other_cause": {
        id: "ktx|other_cause",
        defaultMessage: "Egyéb ok"
    },
    "ktx|other_disorder": {
        id: "ktx|other_disorder",
        defaultMessage: "Egyéb belgyógyászati betegség"
    },
    "ktx|other_identified_renal_disorders": {
        id: "ktx|other_identified_renal_disorders",
        defaultMessage: "99 - Egyéb azonosított veserendellenesség - specifikus"
    },
    "ktx|other_imaging_procedure": {
        id: "ktx|other_imaging_procedure",
        defaultMessage: "Egyéb képalkotó vizsgálat"
    },
    "ktx|other_renal_replacement_therapy": {
        id: "ktx|other_renal_replacement_therapy",
        defaultMessage: "Egyéb vesepótló kezelés"
    },
    "ktx|other_surgical_intervention": {
        id: "ktx|other_surgical_intervention",
        defaultMessage: "Egyéb sebészeti beavatkozás"
    },
    "ktx|other_surgical_intervention_none_unknown": {
        id: "ktx|other_surgical_intervention_none_unknown",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|other_surgical_intervention_other": {
        id: "ktx|other_surgical_intervention_other",
        defaultMessage: "Egyéb sebészeti beavatkozás"
    },
    "ktx|other_surgical_intervention_type": {
        id: "ktx|other_surgical_intervention_type",
        defaultMessage: "Egyéb sebészeti beavatkozás típusa"
    },
    "ktx|ovarium_oncology_disease": {
        id: "ktx|ovarium_oncology_disease",
        defaultMessage: "Ovarium onkológiai betegsége"
    },
    "ktx|parathyreoidectomia_partialis": {
        id: "ktx|parathyreoidectomia_partialis",
        defaultMessage: "Parathyreoidectomia partialis"
    },
    "ktx|parathyreoidectomia_totalis": {
        id: "ktx|parathyreoidectomia_totalis",
        defaultMessage: "Parathyreoidectomia totalis"
    },
    "ktx|patient_assigned_user": {
        id: "ktx|patient_assigned_user",
        defaultMessage: "Véleményező orvos"
    },
    "ktx|patient_condition_statement": {
        id: "ktx|patient_condition_statement",
        defaultMessage: "Páciens állapotváltozás"
    },
    "ktx|patient_et_id": {
        id: "ktx|patient_et_id",
        defaultMessage: "ET azonosító"
    },
    "ktx|patient_status": {
        id: "ktx|patient_status",
        defaultMessage: "Páciens státusz"
    },
    "ktx|patient_status_by_nephrologist": {
        id: "ktx|patient_status_by_nephrologist",
        defaultMessage: "Páciens státusza Nefrológus szerint"
    },
    "ktx|penis_oncology_disease": {
        id: "ktx|penis_oncology_disease",
        defaultMessage: "Penis onkológiai betegsége"
    },
    "ktx|peripheral_artery_diesease": {
        id: "ktx|peripheral_artery_diesease",
        defaultMessage: "Perifériás verőérbetegség"
    },
    "ktx|pituitary_malfunction": {
        id: "ktx|pituitary_malfunction",
        defaultMessage: "Hipofízis elégtelenség"
    },
    "ktx|polycystic_kidneys_adult_type": {
        id: "ktx|polycystic_kidneys_adult_type",
        defaultMessage: "41 - Polycystas vese - Felnőttkori (domináns)"
    },
    "ktx|polycystic_kidneys_infantile": {
        id: "ktx|polycystic_kidneys_infantile",
        defaultMessage: "42 - Polycystas vese - Gyermekkori (recesszív)"
    },
    "ktx|polyneuropathy": {
        id: "ktx|polyneuropathy",
        defaultMessage: "Polyneuropthia"
    },
    "ktx|porphyrin_and_bilirubin_metabolic_disturbances": {
        id: "ktx|porphyrin_and_bilirubin_metabolic_disturbances",
        defaultMessage: "Porphyrin és bilirubin anyagcsere zavar"
    },
    "ktx|postrenal_causes": {
        id: "ktx|postrenal_causes",
        defaultMessage: "Postrenalis problémák"
    },
    "ktx|pregnancies_and_children_statement": {
        id: "ktx|pregnancies_and_children_statement",
        defaultMessage: "Terhességek, Gyermekek (Nők esetében) "
    },
    "ktx|previous_other_organ_transplantation": {
        id: "ktx|previous_other_organ_transplantation",
        defaultMessage: "Korábbi egyéb szervtranszplantáció"
    },
    "ktx|previous_other_organ_transplantation_statement": {
        id: "ktx|previous_other_organ_transplantation_statement",
        defaultMessage: "Korábbi egyéb szervtranszplantáció"
    },
    "ktx|previous_transplantation_bone_marrow": {
        id: "ktx|previous_transplantation_bone_marrow",
        defaultMessage: "Csontvelő transzplantáció"
    },
    "ktx|previous_transplantation_heart": {
        id: "ktx|previous_transplantation_heart",
        defaultMessage: "Szív transzplantáció"
    },
    "ktx|previous_transplantation_kidney": {
        id: "ktx|previous_transplantation_kidney",
        defaultMessage: "Vese transzplantáció"
    },
    "ktx|previous_transplantation_liver": {
        id: "ktx|previous_transplantation_liver",
        defaultMessage: "Máj transzplantáció"
    },
    "ktx|previous_transplantation_lung": {
        id: "ktx|previous_transplantation_lung",
        defaultMessage: "Tüdő transzplantáció"
    },
    "ktx|previous_transplantation_other": {
        id: "ktx|previous_transplantation_other",
        defaultMessage: "Egyéb szerv transzplantáció"
    },
    "ktx|previous_transplantation_pancreas": {
        id: "ktx|previous_transplantation_pancreas",
        defaultMessage: "Pancreas transzplantáció"
    },
    "ktx|primary_hypertension": {
        id: "ktx|primary_hypertension",
        defaultMessage: "Primer Hypertonia"
    },
    "ktx|primary_non_function": {
        id: "ktx|primary_non_function",
        defaultMessage: "Elsődleges működésképtelenség"
    },
    "ktx|primary_oxalosis": {
        id: "ktx|primary_oxalosis",
        defaultMessage: "53 - Primer oxalosis"
    },
    "ktx|primary_renal_disease": {
        id: "ktx|primary_renal_disease",
        defaultMessage: "Elsődleges vesebetegség visszatérése"
    },
    "ktx|prostata_oncology_disease": {
        id: "ktx|prostata_oncology_disease",
        defaultMessage: "Prostata onkológiai betegsége"
    },
    "ktx|psychiatry": {
        id: "ktx|psychiatry",
        defaultMessage: "Pszichiátria"
    },
    "ktx|pulmonary_embolism": {
        id: "ktx|pulmonary_embolism",
        defaultMessage: "Pulmonális embolia"
    },
    "ktx|pulmonology": {
        id: "ktx|pulmonology",
        defaultMessage: "Pulmonológia"
    },
    "ktx|purine_and_pirimidine_metabolic_disturbances": {
        id: "ktx|purine_and_pirimidine_metabolic_disturbances",
        defaultMessage: "Purin és pirimidin anyagcsere zavara"
    },
    "ktx|pyelonephritis_associated_with_neurogenic_bladder": {
        id: "ktx|pyelonephritis_associated_with_neurogenic_bladder",
        defaultMessage: "21 - Pyelonephritis/Interstitialis nephritis - neurogén hólyag"
    },
    "ktx|pyelonephritis_cause_not_specified": {
        id: "ktx|pyelonephritis_cause_not_specified",
        defaultMessage: "20 - Pyelonephritis/Interstitialis nephritis - ok nem tisztázott"
    },
    "ktx|pyelonephritis_due_to_acquired_obstructive_uropathy": {
        id: "ktx|pyelonephritis_due_to_acquired_obstructive_uropathy",
        defaultMessage: "23 - Pyelonephritis/Interstitial nephritis -  szerzett obstruktiv uropathia"
    },
    "ktx|pyelonephritis_due_to_congenital_obstructive_uropathy": {
        id: "ktx|pyelonephritis_due_to_congenital_obstructive_uropathy",
        defaultMessage: "22 - Pyelonephritis/Interstitialis nephritis - kongenitalis obstruktiv uropathia"
    },
    "ktx|pyelonephritis_due_to_other_cause": {
        id: "ktx|pyelonephritis_due_to_other_cause",
        defaultMessage: "29 - Pyelonephritis/Interstitialis nephritis - egyéb ok"
    },
    "ktx|pyelonephritis_due_to_urolithiasis": {
        id: "ktx|pyelonephritis_due_to_urolithiasis",
        defaultMessage: "25 - Pyelonephritis/Interstitialis nephritis - urolithiasis"
    },
    "ktx|pyelonephritis_due_to_vesico-ureteric_reflux_without_obstruction": {
        id: "ktx|pyelonephritis_due_to_vesico-ureteric_reflux_without_obstruction",
        defaultMessage: "24 - Pyelonephritis/Interstitialis nephritis - VU reflux obstrukció nélkül"
    },
    "ktx|renal_anaemia_hematology_no": {
        id: "ktx|renal_anaemia_hematology_no",
        defaultMessage: "Nincs vagy nem ismert"
    },
    "ktx|renal_anaemia_hematology_statement": {
        id: "ktx|renal_anaemia_hematology_statement",
        defaultMessage: "Renális anaemia - Hematológia"
    },
    "ktx|renal_anaemia_hematology_type": {
        id: "ktx|renal_anaemia_hematology_type",
        defaultMessage: "Renális anaemia - Hematológia típus"
    },
    "ktx|renal_hypoplasia_congenital": {
        id: "ktx|renal_hypoplasia_congenital",
        defaultMessage: "60 - Congenitalis vese hypoplasia - nem azonosított típus"
    },
    "ktx|renal_malignancy_oncology_disease": {
        id: "ktx|renal_malignancy_oncology_disease",
        defaultMessage: "Vese rosszindulatú daganata"
    },
    "ktx|renal_replacement_therapy": {
        id: "ktx|renal_replacement_therapy",
        defaultMessage: "Vesepótló kezelés"
    },
    "ktx|renal_replacement_therapy_statement": {
        id: "ktx|renal_replacement_therapy_statement",
        defaultMessage: "Jelenlegi vesepótló kezelés"
    },
    "ktx|renal_vascular_disease_due_to_hypertension": {
        id: "ktx|renal_vascular_disease_due_to_hypertension",
        defaultMessage: "72 - Renalis vaszkularis betegség - hypertonia miatt"
    },
    "ktx|renal_vascular_disease_due_to_malignant_hypertension": {
        id: "ktx|renal_vascular_disease_due_to_malignant_hypertension",
        defaultMessage: "71 - Renalis vaszkularis betegség - malignus hypertonia miatt"
    },
    "ktx|renal_vascular_disease_due_to_other_cause": {
        id: "ktx|renal_vascular_disease_due_to_other_cause",
        defaultMessage: "79 - Renalis vaszkularis betegség - azonosított"
    },
    "ktx|renal_vascular_disease_due_to_polyarteritis": {
        id: "ktx|renal_vascular_disease_due_to_polyarteritis",
        defaultMessage: "73 - Renalis vaszkularis betegség - polyarteritis miatt"
    },
    "ktx|renal_vascular_disease_type_unspecified": {
        id: "ktx|renal_vascular_disease_type_unspecified",
        defaultMessage: "70 - Renalis vaszkularis betegség - nem azonosított típus"
    },
    "ktx|rh": {
        id: "ktx|rh",
        defaultMessage: "Rh vércsoport"
    },
    "ktx|secondary_hypertension": {
        id: "ktx|secondary_hypertension",
        defaultMessage: "Secunder Hypertonia"
    },
    "ktx|sensitivities_and_allergies_statement": {
        id: "ktx|sensitivities_and_allergies_statement",
        defaultMessage: "Érzékenység és Allergiák"
    },
    "ktx|signed_statement_of_consent_fyrms": {
        id: "ktx|signed_statement_of_consent_fyrms",
        defaultMessage: "Páciens beleegyező nyilatkozat - TIMM"
    },
    "ktx|signed_statement_of_consent_ovsz": {
        id: "ktx|signed_statement_of_consent_ovsz",
        defaultMessage: "Páciens beleegyező nyilatkozat - OVSZ"
    },
    "ktx|skin_tumour_oncology_disease": {
        id: "ktx|skin_tumour_oncology_disease",
        defaultMessage: "Bőr egyéb rosszindulatú daganata"
    },
    "ktx|small_intestine_oncology_disease": {
        id: "ktx|small_intestine_oncology_disease",
        defaultMessage: "Vékonybél onkológiai betegsége (ileum, jejunum, colon, rectum, anus)"
    },
    "ktx|smoking_cigarettes_pack_years": {
        id: "ktx|smoking_cigarettes_pack_years",
        defaultMessage: "Csomagév"
    },
    "ktx|smoking_statement": {
        id: "ktx|smoking_statement",
        defaultMessage: "Dohányzás"
    },
    "ktx|sphyngolipid_and_glucosaminoglycane": {
        id: "ktx|sphyngolipid_and_glucosaminoglycane",
        defaultMessage: "Sphyngolipid és glucoseaminoglicane rendellenesség"
    },
    "ktx|stenosis_arteriae_conorariae": {
        id: "ktx|stenosis_arteriae_conorariae",
        defaultMessage: "Arteria carotis stenosis"
    },
    "ktx|stenosis_arteriae_renalis": {
        id: "ktx|stenosis_arteriae_renalis",
        defaultMessage: "Arteria renalis szűkület"
    },
    "ktx|superficial_vein_thrombosis": {
        id: "ktx|superficial_vein_thrombosis",
        defaultMessage: "Felületes véna thrombosis"
    },
    "ktx|syndrome_of_agenesis_of_abdominal_muscles": {
        id: "ktx|syndrome_of_agenesis_of_abdominal_muscles",
        defaultMessage: "66 - Hasi izomzat agenesia szindróma (Prune Belly szindróma)"
    },
    "ktx|systemic_sclerosis": {
        id: "ktx|systemic_sclerosis",
        defaultMessage: "87 - Szisztemas sclerosis"
    },
    "ktx|testis_oncology_disease": {
        id: "ktx|testis_oncology_disease",
        defaultMessage: "Testis onkológiai betegsége"
    },
    "ktx|thrombopaenia": {
        id: "ktx|thrombopaenia",
        defaultMessage: "Thrombopaenia"
    },
    "ktx|thrombosis_neck_region": {
        id: "ktx|thrombosis_neck_region",
        defaultMessage: "Thrombosis nyaki régióban"
    },
    "ktx|thymus_disorder": {
        id: "ktx|thymus_disorder",
        defaultMessage: "Thymus rendellenesség"
    },
    "ktx|thyreoidectomia_partialis": {
        id: "ktx|thyreoidectomia_partialis",
        defaultMessage: "Thyreoidectomia partialis"
    },
    "ktx|thyreoidectomia_totalis": {
        id: "ktx|thyreoidectomia_totalis",
        defaultMessage: "Thyreoidectomia totalis"
    },
    "ktx|tonsillectomia": {
        id: "ktx|tonsillectomia",
        defaultMessage: "Tonsillectomia"
    },
    "ktx|toung_oncology_disease": {
        id: "ktx|toung_oncology_disease",
        defaultMessage: "Nyelv onkológiai betegsége"
    },
    "ktx|trachea_bronchus_bronchii_oncology_disease": {
        id: "ktx|trachea_bronchus_bronchii_oncology_disease",
        defaultMessage: "Trachea / Bronchus / Bronchii"
    },
    "ktx|transfusion": {
        id: "ktx|transfusion",
        defaultMessage: "Transzfúzió"
    },
    "ktx|transplant_anesthesiology": {
        id: "ktx|transplant_anesthesiology",
        defaultMessage: "Transzplantációs aneszteziológia"
    },
    "ktx|transplant_nephrology": {
        id: "ktx|transplant_nephrology",
        defaultMessage: "Transzplantációs Nefrológia"
    },
    "ktx|transplant_surgery": {
        id: "ktx|transplant_surgery",
        defaultMessage: "Transzplantációs sebészet"
    },
    "ktx|traumatic_or_surgical_loss_of_kidney": {
        id: "ktx|traumatic_or_surgical_loss_of_kidney",
        defaultMessage: "96 - Traumás vagy sebészeti vese vesztés"
    },
    "ktx|tuberculosis": {
        id: "ktx|tuberculosis",
        defaultMessage: "91 - Tuberkulózis"
    },
    "ktx|tubular_necrosis_irreversible": {
        id: "ktx|tubular_necrosis_irreversible",
        defaultMessage: "90 - Kortikalis vagy tubuláris nekrózis"
    },
    "ktx|tumour_research": {
        id: "ktx|tumour_research",
        defaultMessage: "Góc és Tumorkutatás"
    },
    "ktx|turp": {
        id: "ktx|turp",
        defaultMessage: "TURP"
    },
    "ktx|unknown_cause": {
        id: "ktx|unknown_cause",
        defaultMessage: "Ismeretlen ok"
    },
    "ktx|upper_limb_CT_MR_angiography": {
        id: "ktx|upper_limb_CT_MR_angiography",
        defaultMessage: "Felső végtag CT / MR / angiográfia"
    },
    "ktx|upper_limb_deep_vein_thrombosis": {
        id: "ktx|upper_limb_deep_vein_thrombosis",
        defaultMessage: "Felső végtagi mélyvénás thromobosis"
    },
    "ktx|upper_limb_doppler": {
        id: "ktx|upper_limb_doppler",
        defaultMessage: "Felső végtagi doppler"
    },
    "ktx|ureteral_malignancy_oncology_disease": {
        id: "ktx|ureteral_malignancy_oncology_disease",
        defaultMessage: "Ureter daganat"
    },
    "ktx|urethra_malignancy_oncology_disease": {
        id: "ktx|urethra_malignancy_oncology_disease",
        defaultMessage: "Húgyhólyag / Húgycső daganat"
    },
    "ktx|urgency": {
        id: "ktx|urgency",
        defaultMessage: "urgency"
    },
    "ktx|urology": {
        id: "ktx|urology",
        defaultMessage: "Urológia"
    },
    "ktx|vascular_diseases_of_the_liver": {
        id: "ktx|vascular_diseases_of_the_liver",
        defaultMessage: "Vaszkuláris eredet"
    },
    "ktx|vascular_problems": {
        id: "ktx|vascular_problems",
        defaultMessage: "Vascularis problémák"
    },
    "ktx|vascular_surgery": {
        id: "ktx|vascular_surgery",
        defaultMessage: "Érsebészet"
    },
    "ktx|ventriculus_oncology_disease": {
        id: "ktx|ventriculus_oncology_disease",
        defaultMessage: "Gyomor onkológiai betegsége"
    },
    "ktx|vulva_oncology_disease": {
        id: "ktx|vulva_oncology_disease",
        defaultMessage: "Vulva onkológiai betegsége"
    },
    "ktx|waiting_list_start_date": {
        id: "ktx|waiting_list_start_date",
        defaultMessage: "Várólistára kerülés dátuma"
    },
    "ktx|wegeners_granulomatosis": {
        id: "ktx|wegeners_granulomatosis",
        defaultMessage: "74 - Granulomatosis polyangiitissel (Wegener granulomatosis)"
    },
    "ktx|weight": {
        id: "ktx|weight",
        defaultMessage: "Testsúly"
    },
    "loinc|10230-1": {
        id: "loinc|10230-1",
        defaultMessage: "Bal kamrai ejekciós frakció"
    },
    "loinc|10331-7": {
        id: "loinc|10331-7",
        defaultMessage: "Rh [Típus] vérben"
    },
    "loinc|11154-2": {
        id: "loinc|11154-2",
        defaultMessage: "Kolineszteráz [Enzim aktivitás/térfogat] vérben"
    },
    "loinc|11524-6": {
        id: "loinc|11524-6",
        defaultMessage: "EKG vizsgálat"
    },
    "loinc|13946-9": {
        id: "loinc|13946-9",
        defaultMessage: "Komplement+Immunglobulin [Jelenlét] vörösvértestekben"
    },
    "loinc|14338-8": {
        id: "loinc|14338-8",
        defaultMessage: "Prealbumin [Tömeg/térfogat] szérumban vagy plazmában"
    },
    "loinc|14631-6": {
        id: "loinc|14631-6",
        defaultMessage: "Bilirubin teljes [Mól/térfogat] szérumban vagy plazmában"
    },
    "loinc|14920-3": {
        id: "loinc|14920-3",
        defaultMessage: "Tiroxin (T4) szabad [Mól/térfogat] szérumban vagy plazmában"
    },
    "loinc|14928-6": {
        id: "loinc|14928-6",
        defaultMessage: "Trijódtironin (T3) szabad [Mól/térfogat] szérumban vagy plazmában"
    },
    "loinc|14937-7": {
        id: "loinc|14937-7",
        defaultMessage: "Karbamid nitrogén [Mól/térfogat] szérumban vagy plazmában"
    },
    "loinc|16954-0": {
        id: "loinc|16954-0",
        defaultMessage: "Herpes simplex vírus 2 ellenanyag [Jelenlét] szérumban"
    },
    "loinc|1742-6": {
        id: "loinc|1742-6",
        defaultMessage: "Alanin aminotranszferáz [Enzim aktivitás/térfogat] szérumban vagy plazmában"
    },
    "loinc|1751-7": {
        id: "loinc|1751-7",
        defaultMessage: "Albumin [Tömeg/térfogat] szérumban vagy plazmában"
    },
    "loinc|18066-1": {
        id: "loinc|18066-1",
        defaultMessage: "Aorta billentyű átlagos szisztolés nyomásgradiens US.doppler teljes Bernoulli módszerrel"
    },
    "loinc|18112-3": {
        id: "loinc|18112-3",
        defaultMessage: "Aorta billentyű regurgitáció foka US.doppler módszerrel"
    },
    "loinc|18113-1": {
        id: "loinc|18113-1",
        defaultMessage: "Mitralis billentyű regurgitáció foka US.doppler módszerrel"
    },
    "loinc|18115-6": {
        id: "loinc|18115-6",
        defaultMessage: "Tricuspidalis billentyű regurgitáció foka US.doppler módszerrel"
    },
    "loinc|18746-8": {
        id: "loinc|18746-8",
        defaultMessage: "Colonoscopia vizsgálat"
    },
    "loinc|19162-7": {
        id: "loinc|19162-7",
        defaultMessage: "Varicella zoster vírus IgG ellenanyag [Jelenlét] szérumban"
    },
    "loinc|1920-8": {
        id: "loinc|1920-8",
        defaultMessage: "Aszpartát aminotranszferáz [Enzim aktivitás/térfogat] szérumban vagy plazmában"
    },
    "loinc|1988-5": {
        id: "loinc|1988-5",
        defaultMessage: "C reaktív fehérje [Tömeg/térfogat] szérumban vagy plazmában"
    },
    "loinc|20464-4": {
        id: "loinc|20464-4",
        defaultMessage: "Toxoplasma gondii ellenanyag [Értelmezés] szérumban"
    },
    "loinc|2160-0": {
        id: "loinc|2160-0",
        defaultMessage: "Kreatinin [Tömeg/térfogat] szérumban vagy plazmában"
    },
    "loinc|22244-8": {
        id: "loinc|22244-8",
        defaultMessage: "Cytomegalovírus IgG ellenanyag [Jelenlét] szérumban vagy plazmában"
    },
    "loinc|22322-2": {
        id: "loinc|22322-2",
        defaultMessage: "Hepatitis B vírus felszíni ellenanyag [Jelenlét] szérumban"
    },
    "loinc|22580-5": {
        id: "loinc|22580-5",
        defaultMessage: "Toxoplasma gondii IgG ellenanyag [Jelenlét] szérumban"
    },
    "loinc|2324-2": {
        id: "loinc|2324-2",
        defaultMessage: "Gamma glutamil transzferáz [Enzim aktivitás/térfogat] szérumban vagy plazmában"
    },
    "loinc|24325-3": {
        id: "loinc|24325-3",
        defaultMessage: "Májfunkció 2000 panel - szérum vagy plazma"
    },
    "loinc|24362-6": {
        id: "loinc|24362-6",
        defaultMessage: "Vesefunkció 2000 panel - szérum vagy plazma"
    },
    "loinc|24616-5": {
        id: "loinc|24616-5",
        defaultMessage: "US nyaki artériák"
    },
    "loinc|24748-6": {
        id: "loinc|24748-6",
        defaultMessage: "MR szív"
    },
    "loinc|25020": {
        id: "loinc|25020",
        defaultMessage: "Bilirubin direkt [Tömeg/térfogat] szérumban vagy plazmában"
    },
    "loinc|2532-0": {
        id: "loinc|2532-0",
        defaultMessage: "Laktát dehidrogenáz [Enzim aktivitás/térfogat] szérumban vagy plazmában"
    },
    "loinc|26515-7": {
        id: "loinc|26515-7",
        defaultMessage: "Thrombocyták [szám/térfogat] vérben"
    },
    "loinc|2711-0": {
        id: "loinc|2711-0",
        defaultMessage: "Oxigénszaturáció vénás vérben"
    },
    "loinc|29463-7": {
        id: "loinc|29463-7",
        defaultMessage: "Testsúly"
    },
    "loinc|2947-0": {
        id: "loinc|2947-0",
        defaultMessage: "Nátrium [Mól/térfogat] vérben"
    },
    "loinc|31204-1": {
        id: "loinc|31204-1",
        defaultMessage: "Hepatitis B vírus core IgM ellenanyag [Jelenlét] szérumban"
    },
    "loinc|3140-1": {
        id: "loinc|3140-1",
        defaultMessage: "Testfelszín képletből származtatva"
    },
    "loinc|32685-0": {
        id: "loinc|32685-0",
        defaultMessage: "Hepatitis B vírus core IgG ellenanyag [Jelenlét] szérumban"
    },
    "loinc|33762-6": {
        id: "loinc|33762-6",
        defaultMessage: "Natriuretikus peptid B prohormon N-terminális [Tömeg/térfogat] szérumban vagy plazmában"
    },
    "loinc|33914-3": {
        id: "loinc|33914-3",
        defaultMessage: "Glomeruláris filtrációs ráta/1,73 m² előrejelzett [Térfogat ráta/terület] szérumban vagy plazmában kreatinin alapú képlettel (MDRD)"
    },
    "loinc|34530-6": {
        id: "loinc|34530-6",
        defaultMessage: "ABO és Rh csoport panel - vér"
    },
    "loinc|34714-6": {
        id: "loinc|34714-6",
        defaultMessage: "INR vérben koagulációs vizsgálattal"
    },
    "loinc|34851-6": {
        id: "loinc|34851-6",
        defaultMessage: "Urológiai konzílium jegyzet"
    },
    "loinc|36572-6": {
        id: "loinc|36572-6",
        defaultMessage: "Röntgen mellkas AP"
    },
    "loinc|39156-5": {
        id: "loinc|39156-5",
        defaultMessage: "Testtömegindex (BMI) [Arány]"
    },
    "loinc|39480-9": {
        id: "loinc|39480-9",
        defaultMessage: "Glükóz [Mól/térfogat] vénás vérben"
    },
    "loinc|407367": {
        id: "loinc|407367",
        defaultMessage: "Tirotropin [Egység/térfogat] vérben"
    },
    "loinc|42148-7": {
        id: "loinc|42148-7",
        defaultMessage: "US szív"
    },
    "loinc|43111-4": {
        id: "loinc|43111-4",
        defaultMessage: "Herpes simplex vírus 1 ellenanyag [Jelenlét] szérumban"
    },
    "loinc|44137-8": {
        id: "loinc|44137-8",
        defaultMessage: "PT szív"
    },
    "loinc|49178-7": {
        id: "loinc|49178-7",
        defaultMessage: "Epstein Barr vírus ellenanyag [Jelenlét] szérumban"
    },
    "loinc|50196-5": {
        id: "loinc|50196-5",
        defaultMessage: "Rejtett vér panel - széklet"
    },
    "loinc|5195-3": {
        id: "loinc|5195-3",
        defaultMessage: "Hepatitis B vírus felszíni antigén [Jelenlét] szérumban"
    },
    "loinc|53764-7": {
        id: "loinc|53764-7",
        defaultMessage: "Prosztata specifikus antigén panel - szérum vagy plazma"
    },
    "loinc|5418-8": {
        id: "loinc|5418-8",
        defaultMessage: "Súly és magasság követési panel"
    },
    "loinc|55112-7": {
        id: "loinc|55112-7",
        defaultMessage: "Dokumentum összefoglaló"
    },
    "loinc|55429-5": {
        id: "loinc|55429-5",
        defaultMessage: "Rövid vérkép panel - vér"
    },
    "loinc|58271-8": {
        id: "loinc|58271-8",
        defaultMessage: "Állandó pacemaker beültetés"
    },
    "loinc|58744-4": {
        id: "loinc|58744-4",
        defaultMessage: "CT szív"
    },
    "loinc|60842-2": {
        id: "loinc|60842-2",
        defaultMessage: "Oxigénfogyasztás (VO2)"
    },
    "loinc|60985-9": {
        id: "loinc|60985-9",
        defaultMessage: "Központi vénás nyomás (CVP)"
    },
    "loinc|6298-4": {
        id: "loinc|6298-4",
        defaultMessage: "Kálium [Mól/térfogat] vérben"
    },
    "loinc|64098-7": {
        id: "loinc|64098-7",
        defaultMessage: "Gyaloglási távolság 6 perc"
    },
    "loinc|64663-8": {
        id: "loinc|64663-8",
        defaultMessage: "Kapott már valaha HPV oltást"
    },
    "loinc|6690-2": {
        id: "loinc|6690-2",
        defaultMessage: "Leukocyták [szám/térfogat] vérben automatikus számlálással"
    },
    "loinc|6768-6": {
        id: "loinc|6768-6",
        defaultMessage: "Alkalikus foszfatáz [Enzim aktivitás/térfogat] szérumban vagy plazmában"
    },
    "loinc|718-7": {
        id: "loinc|718-7",
        defaultMessage: "Hemoglobin [Tömeg/térfogat] vérben"
    },
    "loinc|72056-5": {
        id: "loinc|72056-5",
        defaultMessage: "Hepatitis B oltás megkapva"
    },
    "loinc|72057-3": {
        id: "loinc|72057-3",
        defaultMessage: "Pneumococcus oltás megkapva"
    },
    "loinc|72058-1": {
        id: "loinc|72058-1",
        defaultMessage: "Influenza vírus oltás megkapva"
    },
    "loinc|75919-1": {
        id: "loinc|75919-1",
        defaultMessage: "Bal kamrai szívindex"
    },
    "loinc|76269-0": {
        id: "loinc|76269-0",
        defaultMessage: "Respirációs hányados légzőrendszer"
    },
    "loinc|77194-9": {
        id: "loinc|77194-9",
        defaultMessage: "Boka-kar index"
    },
    "loinc|78930-5": {
        id: "loinc|78930-5",
        defaultMessage: "Jobbszívfél katéterezés elvégezve"
    },
    "loinc|80737-0": {
        id: "loinc|80737-0",
        defaultMessage: "Számított panel reaktív ellenanyag - szérum"
    },
    "loinc|80994-7": {
        id: "loinc|80994-7",
        defaultMessage: "Coronária angiográfia elvégezve"
    },
    "loinc|82593-5": {
        id: "loinc|82593-5",
        defaultMessage: "Immunizációs összefoglaló jelentés"
    },
    "loinc|82654-5": {
        id: "loinc|82654-5",
        defaultMessage: "Nukleáris szívképalkotó panel SPECT"
    },
    "loinc|8302-2": {
        id: "loinc|8302-2",
        defaultMessage: "Testmagasság"
    },
    "loinc|8377-4": {
        id: "loinc|8377-4",
        defaultMessage: "Jobb kamrai kamrán belüli diasztolés nyomás"
    },
    "loinc|8385-7": {
        id: "loinc|8385-7",
        defaultMessage: "Arteria pulmonalis diasztolés vérnyomás"
    },
    "loinc|8406-1": {
        id: "loinc|8406-1",
        defaultMessage: "Jobb kamrai kamrán belüli átlagnyomás"
    },
    "loinc|8414-5": {
        id: "loinc|8414-5",
        defaultMessage: "Arteria pulmonalis átlagos vérnyomás"
    },
    "loinc|8432-7": {
        id: "loinc|8432-7",
        defaultMessage: "Jobb kamrai kamrán belüli szisztolés nyomás"
    },
    "loinc|8440-0": {
        id: "loinc|8440-0",
        defaultMessage: "Arteria pulmonalis szisztolés vérnyomás"
    },
    "loinc|8462-4": {
        id: "loinc|8462-4",
        defaultMessage: "Diasztolés vérnyomás"
    },
    "loinc|8480-6": {
        id: "loinc|8480-6",
        defaultMessage: "Szisztolés vérnyomás"
    },
    "loinc|8587-8": {
        id: "loinc|8587-8",
        defaultMessage: "Arteria pulmonalis ék átlagos vérnyomás"
    },
    "loinc|86910-7": {
        id: "loinc|86910-7",
        defaultMessage: "Hemoglobin A1c/Hemoglobin teljes cél vér"
    },
    "loinc|8741-1": {
        id: "loinc|8741-1",
        defaultMessage: "Bal kamrai szívkidobás"
    },
    "loinc|88020-3": {
        id: "loinc|88020-3",
        defaultMessage: "Funkcionális kapacitás NYHA"
    },
    "loinc|8828-6": {
        id: "loinc|8828-6",
        defaultMessage: "Pulmonális vascularis rezisztencia"
    },
    "loinc|883-9": {
        id: "loinc|883-9",
        defaultMessage: "ABO csoport [Típus] vérben"
    },
    "loinc|8867-4": {
        id: "loinc|8867-4",
        defaultMessage: "Szívfrekvencia"
    },
    "loinc|94141-9": {
        id: "loinc|94141-9",
        defaultMessage: "HEDIS 2020 értékkészlet - Mammográfia"
    },
    "ltx|BNP": {
        id: "ltx|BNP",
        defaultMessage: "BNP"
    },
    "ltx|CT_angiography_result": {
        id: "ltx|CT_angiography_result",
        defaultMessage: "CT angiographia"
    },
    "ltx|CT_angiography_result_comment": {
        id: "ltx|CT_angiography_result_comment",
        defaultMessage: "CT angiographia megjegyzés"
    },
    "ltx|NT-proBNP": {
        id: "ltx|NT-proBNP",
        defaultMessage: "NT-proBNP"
    },
    "ltx|ab0": {
        id: "ltx|ab0",
        defaultMessage: "ABO-csoport fenotípusa"
    },
    "ltx|abdominal_circumference": {
        id: "ltx|abdominal_circumference",
        defaultMessage: "Haskörfogat"
    },
    "ltx|abdominal_ct_result": {
        id: "ltx|abdominal_ct_result",
        defaultMessage: "Hasi CT"
    },
    "ltx|abdominal_ct_result_comment": {
        id: "ltx|abdominal_ct_result_comment",
        defaultMessage: "Hasi CT megjegyzés"
    },
    "ltx|abdominal_doppler_ultrasound_result": {
        id: "ltx|abdominal_doppler_ultrasound_result",
        defaultMessage: "Hasi Doppler ultrahang"
    },
    "ltx|abdominal_doppler_ultrasound_result_comment": {
        id: "ltx|abdominal_doppler_ultrasound_result_comment",
        defaultMessage: "Hasi Doppler ultrahang megjegyzés"
    },
    "ltx|abdominal_mri_result": {
        id: "ltx|abdominal_mri_result",
        defaultMessage: "Hasi MRI"
    },
    "ltx|abdominal_mri_result_comment": {
        id: "ltx|abdominal_mri_result_comment",
        defaultMessage: "Hasi MRI megjegyzés"
    },
    "ltx|abdominal_ultrasound_result": {
        id: "ltx|abdominal_ultrasound_result",
        defaultMessage: "Hasi ultrahang"
    },
    "ltx|abdominal_ultrasound_result_comment": {
        id: "ltx|abdominal_ultrasound_result_comment",
        defaultMessage: "Hasi ultrahang megjegyzés"
    },
    "ltx|addiction_assessment": {
        id: "ltx|addiction_assessment",
        defaultMessage: "Addiktológiai vélemény"
    },
    "ltx|alkaline_phosphatase": {
        id: "ltx|alkaline_phosphatase",
        defaultMessage: "Alkalikus foszfatáz"
    },
    "ltx|allergies": {
        id: "ltx|allergies",
        defaultMessage: "Allergiák"
    },
    "ltx|allergies_and_sensitivities_form": {
        id: "ltx|allergies_and_sensitivities_form",
        defaultMessage: "Allergiák és Érzékenység"
    },
    "ltx|ama": {
        id: "ltx|ama",
        defaultMessage: "AMA"
    },
    "ltx|ana": {
        id: "ltx|ana",
        defaultMessage: "ANA"
    },
    "ltx|anesthesiology_result": {
        id: "ltx|anesthesiology_result",
        defaultMessage: "Aneszteziológiai konzílium"
    },
    "ltx|angiography_indirect_portography_result": {
        id: "ltx|angiography_indirect_portography_result",
        defaultMessage: "Angiographia / Indirekt portographia"
    },
    "ltx|angiography_indirect_portography_result_comment": {
        id: "ltx|angiography_indirect_portography_result_comment",
        defaultMessage: "Angiographia / Indirekt portographia megjegyzés"
    },
    "ltx|anti_cardiolipin_at": {
        id: "ltx|anti_cardiolipin_at",
        defaultMessage: "Anti-cardiolipin AT"
    },
    "ltx|anti_cardiolipin_at_iga": {
        id: "ltx|anti_cardiolipin_at_iga",
        defaultMessage: "Anti-cardiolipin AT IgA"
    },
    "ltx|anti_cardiolipin_at_igg": {
        id: "ltx|anti_cardiolipin_at_igg",
        defaultMessage: "Anti-cardiolipin AT IgG"
    },
    "ltx|anti_cardiolipin_at_igm": {
        id: "ltx|anti_cardiolipin_at_igm",
        defaultMessage: "Anti-cardiolipin AT IgM"
    },
    "ltx|arterial_conduit_planned": {
        id: "ltx|arterial_conduit_planned",
        defaultMessage: "Arteria conduit (tervezetten)"
    },
    "ltx|arterial_pressure_monitoring_planned": {
        id: "ltx|arterial_pressure_monitoring_planned",
        defaultMessage: "Artériás nyomásmérés (tervezetten)"
    },
    "ltx|arterial_supply": {
        id: "ltx|arterial_supply",
        defaultMessage: "Arteriás vérellátás"
    },
    "ltx|ascites_child_pugh": {
        id: "ltx|ascites_child_pugh",
        defaultMessage: "Aszitesz (Child-Pugh)"
    },
    "ltx|ascitic_fluid_culture_result": {
        id: "ltx|ascitic_fluid_culture_result",
        defaultMessage: "Ascitestenyésztés"
    },
    "ltx|ascitic_fluid_culture_result_comment": {
        id: "ltx|ascitic_fluid_culture_result_comment",
        defaultMessage: "Ascitestenyésztés megjegyzés"
    },
    "ltx|backup_recipient": {
        id: "ltx|backup_recipient",
        defaultMessage: "Tartalék recipiens"
    },
    "ltx|bilirubin_direct": {
        id: "ltx|bilirubin_direct",
        defaultMessage: "Direct bilirubin"
    },
    "ltx|bilirubin_total": {
        id: "ltx|bilirubin_total",
        defaultMessage: "Bilirubin (össz)"
    },
    "ltx|blood_group": {
        id: "ltx|blood_group",
        defaultMessage: "Vércsoport"
    },
    "ltx|bmi": {
        id: "ltx|bmi",
        defaultMessage: "Body mass index (BMI)"
    },
    "ltx|bone_scan": {
        id: "ltx|bone_scan",
        defaultMessage: "Csontizotóp"
    },
    "ltx|bone_scan_comment": {
        id: "ltx|bone_scan_comment",
        defaultMessage: "Csontizotóp megjegyzés"
    },
    "ltx|bsa_dubois": {
        id: "ltx|bsa_dubois",
        defaultMessage: "Body Surface Area (BSA) Dubois algoritmussal számolva"
    },
    "ltx|bsa_monsteller": {
        id: "ltx|bsa_monsteller",
        defaultMessage: "Body Surface Area (BSA) Monsteller algoritmussal számolva"
    },
    "ltx|calculated_child_pugh_classification": {
        id: "ltx|calculated_child_pugh_classification",
        defaultMessage: "Számított Child-Pugh osztályozás"
    },
    "ltx|cardiovascular_disease": {
        id: "ltx|cardiovascular_disease",
        defaultMessage: "Kardiovaszkuláris betegség"
    },
    "ltx|cardiovascular_disease_comment": {
        id: "ltx|cardiovascular_disease_comment",
        defaultMessage: "Kardiovaszkuláris betegség megjegyzés"
    },
    "ltx|cardiovascular_disease_form": {
        id: "ltx|cardiovascular_disease_form",
        defaultMessage: "Kardiovaszkuláris betegség űrlap"
    },
    "ltx|caudate_lobe": {
        id: "ltx|caudate_lobe",
        defaultMessage: "Lobus caudatus"
    },
    "ltx|cell_saver_use_planned": {
        id: "ltx|cell_saver_use_planned",
        defaultMessage: "CellSaver (tervezetten)"
    },
    "ltx|chest_circumference": {
        id: "ltx|chest_circumference",
        defaultMessage: "Mellkaskörfogat"
    },
    "ltx|chest_ct_result": {
        id: "ltx|chest_ct_result",
        defaultMessage: "Mellkas CT"
    },
    "ltx|chest_ct_result_comment": {
        id: "ltx|chest_ct_result_comment",
        defaultMessage: "Mellkas CT megjegyzés"
    },
    "ltx|chest_x_ray_result": {
        id: "ltx|chest_x_ray_result",
        defaultMessage: "2 irányú mellkas RTG"
    },
    "ltx|chest_x_ray_result_comment": {
        id: "ltx|chest_x_ray_result_comment",
        defaultMessage: "2 irányú mellkas RTG megjegyzés"
    },
    "ltx|child_pugh_classification": {
        id: "ltx|child_pugh_classification",
        defaultMessage: "CHILD-PUGH osztályozás"
    },
    "ltx|child_pugh_score": {
        id: "ltx|child_pugh_score",
        defaultMessage: "Child-Pugh pontszám"
    },
    "ltx|cmv": {
        id: "ltx|cmv",
        defaultMessage: "A citomegalovírus (CMV) szerológiai vizsgálata"
    },
    "ltx|cmv_igg": {
        id: "ltx|cmv_igg",
        defaultMessage: "Cytomegalovírus immunglobulin G antitest (CMV - IgG)"
    },
    "ltx|colitis_ulcerosa": {
        id: "ltx|colitis_ulcerosa",
        defaultMessage: "Fekélyes vastagbélgyulladás"
    },
    "ltx|colitis_ulcerosa_activity": {
        id: "ltx|colitis_ulcerosa_activity",
        defaultMessage: "Fekélyes vastagbélgyulladás aktivitása"
    },
    "ltx|colonoscopia": {
        id: "ltx|colonoscopia",
        defaultMessage: "Kolonoszkópia"
    },
    "ltx|colonoscopia_comment": {
        id: "ltx|colonoscopia_comment",
        defaultMessage: "Kolonoszkópia megjegyzés"
    },
    "ltx|combined_transplant": {
        id: "ltx|combined_transplant",
        defaultMessage: "Kombinált transzplantáció"
    },
    "ltx|comment_for_blood_group": {
        id: "ltx|comment_for_blood_group",
        defaultMessage: "Vércsoport megjegyzése"
    },
    "ltx|coombs_direct": {
        id: "ltx|coombs_direct",
        defaultMessage: "Coombs direkt"
    },
    "ltx|coombs_indirect": {
        id: "ltx|coombs_indirect",
        defaultMessage: "Coombs indirekt"
    },
    "ltx|cranium_ct_result": {
        id: "ltx|cranium_ct_result",
        defaultMessage: "Koponya CT"
    },
    "ltx|cranium_ct_result_comment": {
        id: "ltx|cranium_ct_result_comment",
        defaultMessage: "Koponya CT megjegyzés"
    },
    "ltx|cranium_mr_result": {
        id: "ltx|cranium_mr_result",
        defaultMessage: "Koponya MR"
    },
    "ltx|cranium_mr_result_comment": {
        id: "ltx|cranium_mr_result_comment",
        defaultMessage: "Koponya MR megjegyzés"
    },
    "ltx|creatinine": {
        id: "ltx|creatinine",
        defaultMessage: "Kreatinin"
    },
    "ltx|crohn_disease": {
        id: "ltx|crohn_disease",
        defaultMessage: "Crohn betegség"
    },
    "ltx|crohn_disease_activity": {
        id: "ltx|crohn_disease_activity",
        defaultMessage: "Crohn betegség aktivitás"
    },
    "ltx|crp": {
        id: "ltx|crp",
        defaultMessage: "CRP"
    },
    "ltx|cryoglobulin": {
        id: "ltx|cryoglobulin",
        defaultMessage: "Cryoglobulin"
    },
    "ltx|dental_screening_result": {
        id: "ltx|dental_screening_result",
        defaultMessage: "Fogászat"
    },
    "ltx|description_of_patient_condition": {
        id: "ltx|description_of_patient_condition",
        defaultMessage: "Állapotváltozás leírása"
    },
    "ltx|diabetes_mellitus_type": {
        id: "ltx|diabetes_mellitus_type",
        defaultMessage: "Diabetes mellitus típusa"
    },
    "ltx|dialysis_at_least_twice_per_week": {
        id: "ltx|dialysis_at_least_twice_per_week",
        defaultMessage: "Dialízis legalább heti 2×"
    },
    "ltx|digital_rectal_exam_result": {
        id: "ltx|digital_rectal_exam_result",
        defaultMessage: "Digitális végbélvizsgálat eredménye"
    },
    "ltx|drug_type": {
        id: "ltx|drug_type",
        defaultMessage: "Gyógyszer típusa"
    },
    "ltx|ear_nose_throat": {
        id: "ltx|ear_nose_throat",
        defaultMessage: "Fül-orr-gégészeti szakvizsgálat"
    },
    "ltx|ebv_serology": {
        id: "ltx|ebv_serology",
        defaultMessage: "Epstein-Barr vírus szerológiai teszt (EBV)"
    },
    "ltx|ebv_serology_igg": {
        id: "ltx|ebv_serology_igg",
        defaultMessage: "Epstein-Barr-vírus immunglobulin G (EBV-IgG)"
    },
    "ltx|encephalopathy": {
        id: "ltx|encephalopathy",
        defaultMessage: "Encephalopathia"
    },
    "ltx|encephalopathy_grade": {
        id: "ltx|encephalopathy_grade",
        defaultMessage: "Encephalopathia fokozata"
    },
    "ltx|endocrine_disease": {
        id: "ltx|endocrine_disease",
        defaultMessage: "Endokrin betegség"
    },
    "ltx|endocrine_disease_comment": {
        id: "ltx|endocrine_disease_comment",
        defaultMessage: "Endokrin betegség megjegyzés"
    },
    "ltx|endocrine_disease_form": {
        id: "ltx|endocrine_disease_form",
        defaultMessage: "Endokrin betegségek űrlap"
    },
    "ltx|ercp": {
        id: "ltx|ercp",
        defaultMessage: "ERCP"
    },
    "ltx|ercp_comment": {
        id: "ltx|ercp_comment",
        defaultMessage: "ERCP megjegyzés"
    },
    "ltx|estimated_blood_loss": {
        id: "ltx|estimated_blood_loss",
        defaultMessage: "Várható vérveszteség"
    },
    "ltx|fibrosis_stage": {
        id: "ltx|fibrosis_stage",
        defaultMessage: "Fibrózis stádium"
    },
    "ltx|forced_expiratory_volume_1_second": {
        id: "ltx|forced_expiratory_volume_1_second",
        defaultMessage: "FEV1%"
    },
    "ltx|forced_vital_capacity": {
        id: "ltx|forced_vital_capacity",
        defaultMessage: "FVC"
    },
    "ltx|fvs": {
        id: "ltx|fvs",
        defaultMessage: "Fehérvérsejt szám"
    },
    "ltx|gastrointestinal_disease": {
        id: "ltx|gastrointestinal_disease",
        defaultMessage: "Gyomor- és bélrendszeri betegség"
    },
    "ltx|gastrointestinal_disease_comment": {
        id: "ltx|gastrointestinal_disease_comment",
        defaultMessage: "Gyomor- és bélrendszeri betegség megjegyzés"
    },
    "ltx|gastrointestinal_disease_form": {
        id: "ltx|gastrointestinal_disease_form",
        defaultMessage: "Gyomor- és bélrendszeri betegségek űrlap"
    },
    "ltx|gastroscopia_result": {
        id: "ltx|gastroscopia_result",
        defaultMessage: "Gastroscopia"
    },
    "ltx|gastroscopia_result_comment": {
        id: "ltx|gastroscopia_result_comment",
        defaultMessage: "Gastroscopia megjegyzés"
    },
    "ltx|gfr": {
        id: "ltx|gfr",
        defaultMessage: "GFR"
    },
    "ltx|ggt": {
        id: "ltx|ggt",
        defaultMessage: "GGT"
    },
    "ltx|got": {
        id: "ltx|got",
        defaultMessage: "GOT"
    },
    "ltx|gpt": {
        id: "ltx|gpt",
        defaultMessage: "GPT"
    },
    "ltx|green_light": {
        id: "ltx|green_light",
        defaultMessage: "Zöld fény"
    },
    "ltx|gynecology_result": {
        id: "ltx|gynecology_result",
        defaultMessage: "Nőgyógyászati szakvizsgálat"
    },
    "ltx|haemoglobin": {
        id: "ltx|haemoglobin",
        defaultMessage: "Hemoglobin"
    },
    "ltx|hbc_ab_igg": {
        id: "ltx|hbc_ab_igg",
        defaultMessage: "Hepatitis B core antitest mérés, immunoglobulin G típus"
    },
    "ltx|hbc_ab_igm": {
        id: "ltx|hbc_ab_igm",
        defaultMessage: "Hepatitis B core antitest mérés, immunoglobulin M típus"
    },
    "ltx|hbs_ab": {
        id: "ltx|hbs_ab",
        defaultMessage: "Hepatitis B felszíni antitest mérés"
    },
    "ltx|hbs_ag": {
        id: "ltx|hbs_ag",
        defaultMessage: "Hepatitis B felszíni antigén mérés"
    },
    "ltx|hbv_status": {
        id: "ltx|hbv_status",
        defaultMessage: "Hepatitis B vírus státusz"
    },
    "ltx|height": {
        id: "ltx|height",
        defaultMessage: "Magasság"
    },
    "ltx|helicobacter_pylori": {
        id: "ltx|helicobacter_pylori",
        defaultMessage: "Helicobacter pylori"
    },
    "ltx|hepa_c_virus_screening": {
        id: "ltx|hepa_c_virus_screening",
        defaultMessage: "Hepatitis C vírus (organizmus) / Szűrő eljárás"
    },
    "ltx|hepatic_arterial_anatomy_type": {
        id: "ltx|hepatic_arterial_anatomy_type",
        defaultMessage: "Artériás típusok (Michel/Hiatt klasszifikáció)"
    },
    "ltx|hepatic_arterial_anatomy_type_comment": {
        id: "ltx|hepatic_arterial_anatomy_type_comment",
        defaultMessage: "Artériás típusok (Michel/Hiatt klasszifikáció) megjegyzés"
    },
    "ltx|hepatorenal_syndrome": {
        id: "ltx|hepatorenal_syndrome",
        defaultMessage: "Hepatorenalis syndroma"
    },
    "ltx|hgb_a1_c": {
        id: "ltx|hgb_a1_c",
        defaultMessage: "Hemoglobin A1c"
    },
    "ltx|hiv_screening": {
        id: "ltx|hiv_screening",
        defaultMessage: "Humán immundeficiencia-vírus (HIV)"
    },
    "ltx|hsv1_serology": {
        id: "ltx|hsv1_serology",
        defaultMessage: "Herpes simplex virus-1 antitest (HSV1)"
    },
    "ltx|hsv1_serology_igg": {
        id: "ltx|hsv1_serology_igg",
        defaultMessage: "Herpes simplex immunglobulin G szint (HSV1 - IgG)"
    },
    "ltx|hsv2_serology": {
        id: "ltx|hsv2_serology",
        defaultMessage: "Humán herpeszvírus 2 antitest (HSV2)"
    },
    "ltx|hsv2_serology_igg": {
        id: "ltx|hsv2_serology_igg",
        defaultMessage: "Herpes simplex immunglobulin G szint (HSV2 - IgG)"
    },
    "ltx|hyper_immunised": {
        id: "ltx|hyper_immunised",
        defaultMessage: "Hyperimmunizált"
    },
    "ltx|immun_elfo": {
        id: "ltx|immun_elfo",
        defaultMessage: "ImmunELFO"
    },
    "ltx|immun_elfo_iga": {
        id: "ltx|immun_elfo_iga",
        defaultMessage: "Immun elfo IgA"
    },
    "ltx|immun_elfo_igg": {
        id: "ltx|immun_elfo_igg",
        defaultMessage: "Immun elfo IgG"
    },
    "ltx|immun_elfo_igm": {
        id: "ltx|immun_elfo_igm",
        defaultMessage: "Immun elfo IgM"
    },
    "ltx|immunosuppression": {
        id: "ltx|immunosuppression",
        defaultMessage: "Immunszuppresszió"
    },
    "ltx|immunosuppression_other": {
        id: "ltx|immunosuppression_other",
        defaultMessage: "Egyéb immunszuppresszió"
    },
    "ltx|indication_for_liver_transplantation_comment": {
        id: "ltx|indication_for_liver_transplantation_comment",
        defaultMessage: "Májtranszplantációt indokló diagnózis megjegyzés"
    },
    "ltx|indication_for_liver_transplantation_form": {
        id: "ltx|indication_for_liver_transplantation_form",
        defaultMessage: "Májtranszplantációt indokló diagnózis űrlap"
    },
    "ltx|inr": {
        id: "ltx|inr",
        defaultMessage: "INR"
    },
    "ltx|karbamid": {
        id: "ltx|karbamid",
        defaultMessage: "Karbamid"
    },
    "ltx|ldh": {
        id: "ltx|ldh",
        defaultMessage: "LDH"
    },
    "ltx|liver_biopsy": {
        id: "ltx|liver_biopsy",
        defaultMessage: "Májbiopszia"
    },
    "ltx|liver_biopsy_comment": {
        id: "ltx|liver_biopsy_comment",
        defaultMessage: "Májbiopszia megjegyzés"
    },
    "ltx|liver_elastography": {
        id: "ltx|liver_elastography",
        defaultMessage: "Elasztografia"
    },
    "ltx|liver_elastography_comment": {
        id: "ltx|liver_elastography_comment",
        defaultMessage: "Elasztografia megjegyzés"
    },
    "ltx|liver_size": {
        id: "ltx|liver_size",
        defaultMessage: "Máj mérete"
    },
    "ltx|lkm": {
        id: "ltx|lkm",
        defaultMessage: "LKM"
    },
    "ltx|lumbar_spine_x_ray_result": {
        id: "ltx|lumbar_spine_x_ray_result",
        defaultMessage: "2 irányú lumbalis gerinc RTG"
    },
    "ltx|lumbar_spine_x_ray_result_comment": {
        id: "ltx|lumbar_spine_x_ray_result_comment",
        defaultMessage: "2 irányú lumbalis gerinc RTG megjegyzés"
    },
    "ltx|maximal_expiratory_flow_at_75": {
        id: "ltx|maximal_expiratory_flow_at_75",
        defaultMessage: "MEF75%"
    },
    "ltx|medical_history_summary": {
        id: "ltx|medical_history_summary",
        defaultMessage: "Hepatológiai anamnézis"
    },
    "ltx|medical_treatment": {
        id: "ltx|medical_treatment",
        defaultMessage: "Gyógyszeres kezelés"
    },
    "ltx|meld_na_score": {
        id: "ltx|meld_na_score",
        defaultMessage: "MELD-Na pontszám"
    },
    "ltx|meld_score": {
        id: "ltx|meld_score",
        defaultMessage: "MELD pontszám"
    },
    "ltx|mrcp": {
        id: "ltx|mrcp",
        defaultMessage: "MRCP"
    },
    "ltx|mrcp_comment": {
        id: "ltx|mrcp_comment",
        defaultMessage: "MRCP megjegyzés"
    },
    "ltx|nasal_swab_culture_result": {
        id: "ltx|nasal_swab_culture_result",
        defaultMessage: "Orrtenyésztés"
    },
    "ltx|nasal_swab_culture_result_comment": {
        id: "ltx|nasal_swab_culture_result_comment",
        defaultMessage: "Orrtenyésztés megjegyzés"
    },
    "ltx|natrium": {
        id: "ltx|natrium",
        defaultMessage: "Nátrium (Na)"
    },
    "ltx|nephrological_urological_disease_comment": {
        id: "ltx|nephrological_urological_disease_comment",
        defaultMessage: " Nephrológiai és urológiai betegség megjegyzés"
    },
    "ltx|nephrological_urological_disease_form": {
        id: "ltx|nephrological_urological_disease_form",
        defaultMessage: "Nephrológiai és urológiai betegségek űrlap"
    },
    "ltx|neurology_result": {
        id: "ltx|neurology_result",
        defaultMessage: "Neurológiai konzílium"
    },
    "ltx|oncology": {
        id: "ltx|oncology",
        defaultMessage: "Onkológia"
    },
    "ltx|oncology_comment": {
        id: "ltx|oncology_comment",
        defaultMessage: "Onkológia megjegyzés"
    },
    "ltx|ophthalmologic_examination_result": {
        id: "ltx|ophthalmologic_examination_result",
        defaultMessage: "Szemészeti vizsgálat eredménye"
    },
    "ltx|other_consultation": {
        id: "ltx|other_consultation",
        defaultMessage: "Egyéb konzílium"
    },
    "ltx|other_consultation_comment": {
        id: "ltx|other_consultation_comment",
        defaultMessage: "Egyéb konzílium megjegyzés"
    },
    "ltx|other_technical_difficulties": {
        id: "ltx|other_technical_difficulties",
        defaultMessage: "Egyéb technikai nehézségek (műtétek)"
    },
    "ltx|panca": {
        id: "ltx|panca",
        defaultMessage: "pANKA"
    },
    "ltx|papanicolaou": {
        id: "ltx|papanicolaou",
        defaultMessage: "Méhnyakrák szűrés"
    },
    "ltx|patient_condition": {
        id: "ltx|patient_condition",
        defaultMessage: "Bizottsági vélemény"
    },
    "ltx|patient_condition_report": {
        id: "ltx|patient_condition_report",
        defaultMessage: "Állapotváltozás jelentés"
    },
    "ltx|patient_et_id": {
        id: "ltx|patient_et_id",
        defaultMessage: "Páciens ET azonosító"
    },
    "ltx|patient_status": {
        id: "ltx|patient_status",
        defaultMessage: "Páciens státusz"
    },
    "ltx|peak_expiratory_flow": {
        id: "ltx|peak_expiratory_flow",
        defaultMessage: "PEF"
    },
    "ltx|platelet_count": {
        id: "ltx|platelet_count",
        defaultMessage: "Trombocyta szám"
    },
    "ltx|portal_circulation": {
        id: "ltx|portal_circulation",
        defaultMessage: "Portalis keringés"
    },
    "ltx|portal_vein_thrombosis_grade": {
        id: "ltx|portal_vein_thrombosis_grade",
        defaultMessage: "Portális véna trombózis fokozata"
    },
    "ltx|portal_vein_thrombosis_grade_comment": {
        id: "ltx|portal_vein_thrombosis_grade_comment",
        defaultMessage: "Portális véna trombózis fokozata megjegyzés"
    },
    "ltx|potassium": {
        id: "ltx|potassium",
        defaultMessage: "Kálium (K)"
    },
    "ltx|prealbumin": {
        id: "ltx|prealbumin",
        defaultMessage: "Prealbumin"
    },
    "ltx|pregnancies_and_children": {
        id: "ltx|pregnancies_and_children",
        defaultMessage: "Terhességek, Gyermekek (Nők esetében) "
    },
    "ltx|prostate_specific_antigen_result": {
        id: "ltx|prostate_specific_antigen_result",
        defaultMessage: "Prosztata specifikus antigén eredmény"
    },
    "ltx|psa": {
        id: "ltx|psa",
        defaultMessage: "PSA"
    },
    "ltx|pseudocholinesterase": {
        id: "ltx|pseudocholinesterase",
        defaultMessage: "Pseudocholinesterase"
    },
    "ltx|psychiatric_assessment": {
        id: "ltx|psychiatric_assessment",
        defaultMessage: "Pszichiátriai vélemény"
    },
    "ltx|psychological_assessment": {
        id: "ltx|psychological_assessment",
        defaultMessage: "Pszichológiai felmérés"
    },
    "ltx|psychological_assessment_comment": {
        id: "ltx|psychological_assessment_comment",
        defaultMessage: "Pszichológiai felmérés megjegyzés"
    },
    "ltx|pulmonary_function_test": {
        id: "ltx|pulmonary_function_test",
        defaultMessage: "Légzésfunkció vizsgálat"
    },
    "ltx|respiratory_pulmonary_disease": {
        id: "ltx|respiratory_pulmonary_disease",
        defaultMessage: "Légúti és tüdőbetegség"
    },
    "ltx|respiratory_pulmonary_disease_comment": {
        id: "ltx|respiratory_pulmonary_disease_comment",
        defaultMessage: "Légúti és tüdőbetegség megjegyzés"
    },
    "ltx|respiratory_pulmonary_disease_form": {
        id: "ltx|respiratory_pulmonary_disease_form",
        defaultMessage: "Légúti és tüdőbetegségek űrlap"
    },
    "ltx|rh": {
        id: "ltx|rh",
        defaultMessage: "Rh vércsoport"
    },
    "ltx|score_albumin": {
        id: "ltx|score_albumin",
        defaultMessage: "Score számításához használt albumin"
    },
    "ltx|score_bilirubin_total": {
        id: "ltx|score_bilirubin_total",
        defaultMessage: "Score számításához használt összbilirubin"
    },
    "ltx|score_creatinine": {
        id: "ltx|score_creatinine",
        defaultMessage: "Score számításához használt kreatinin"
    },
    "ltx|score_encephalopathy_grade": {
        id: "ltx|score_encephalopathy_grade",
        defaultMessage: "Score számításához használt encephalopathia fokozat"
    },
    "ltx|score_inr": {
        id: "ltx|score_inr",
        defaultMessage: "Score számításához használt INR"
    },
    "ltx|score_natrium": {
        id: "ltx|score_natrium",
        defaultMessage: "Score számításához használt nátrium"
    },
    "ltx|serum_albumin": {
        id: "ltx|serum_albumin",
        defaultMessage: "Albumin"
    },
    "ltx|serum_glucose": {
        id: "ltx|serum_glucose",
        defaultMessage: "Vércukor"
    },
    "ltx|signed_statement_of_consent_timm": {
        id: "ltx|signed_statement_of_consent_timm",
        defaultMessage: "Páciens beleegyező nyilatkozat - TIMM"
    },
    "ltx|sma": {
        id: "ltx|sma",
        defaultMessage: "SMA"
    },
    "ltx|splenic_artery_aneurysm": {
        id: "ltx|splenic_artery_aneurysm",
        defaultMessage: "Arteria lienalis aneurysma"
    },
    "ltx|steatosis_grade": {
        id: "ltx|steatosis_grade",
        defaultMessage: "Steatosis fokozat"
    },
    "ltx|stool_culture_result": {
        id: "ltx|stool_culture_result",
        defaultMessage: "Széklettenyésztés"
    },
    "ltx|stool_culture_result_comment": {
        id: "ltx|stool_culture_result_comment",
        defaultMessage: "Széklettenyésztés megjegyzés"
    },
    "ltx|surgical_procedure_type": {
        id: "ltx|surgical_procedure_type",
        defaultMessage: "Műtét típusa"
    },
    "ltx|surgical_procedures": {
        id: "ltx|surgical_procedures",
        defaultMessage: "Műtétek"
    },
    "ltx|t3": {
        id: "ltx|t3",
        defaultMessage: "T3"
    },
    "ltx|t4": {
        id: "ltx|t4",
        defaultMessage: "T4"
    },
    "ltx|throat_swab_culture_result": {
        id: "ltx|throat_swab_culture_result",
        defaultMessage: "Garattenyésztés"
    },
    "ltx|throat_swab_culture_result_comment": {
        id: "ltx|throat_swab_culture_result_comment",
        defaultMessage: "Garattenyésztés megjegyzés"
    },
    "ltx|thrombophilia_comment": {
        id: "ltx|thrombophilia_comment",
        defaultMessage: "Thrombophilia megjegyzés"
    },
    "ltx|thrombophilia_form": {
        id: "ltx|thrombophilia_form",
        defaultMessage: "Thrombophilia űrlap"
    },
    "ltx|toxoplasma_serology": {
        id: "ltx|toxoplasma_serology",
        defaultMessage: "Toxoplasma ellenanyag"
    },
    "ltx|toxoplasma_serology_igg": {
        id: "ltx|toxoplasma_serology_igg",
        defaultMessage: "Toxoplazma immunglobulin G szint (IgG)"
    },
    "ltx|treponema_pallidum_org_screening_procedure": {
        id: "ltx|treponema_pallidum_org_screening_procedure",
        defaultMessage: "Treponema pallidum (organizmus) / Szűrési eljárás"
    },
    "ltx|tsh": {
        id: "ltx|tsh",
        defaultMessage: "TSH"
    },
    "ltx|urgency": {
        id: "ltx|urgency",
        defaultMessage: "Sürgősség"
    },
    "ltx|urine_culture_result": {
        id: "ltx|urine_culture_result",
        defaultMessage: "Vizelettenyésztés"
    },
    "ltx|urine_culture_result_comment": {
        id: "ltx|urine_culture_result_comment",
        defaultMessage: "Vizelettenyésztés megjegyzés"
    },
    "ltx|urology_result": {
        id: "ltx|urology_result",
        defaultMessage: "Urológiai szakvizsgálat"
    },
    "ltx|vaccination_status": {
        id: "ltx|vaccination_status",
        defaultMessage: "Védőoltások"
    },
    "ltx|vaccine_type": {
        id: "ltx|vaccine_type",
        defaultMessage: "Védőoltás"
    },
    "ltx|variceal_bleeding": {
        id: "ltx|variceal_bleeding",
        defaultMessage: "Varixvérzés"
    },
    "ltx|varicella_serology": {
        id: "ltx|varicella_serology",
        defaultMessage: "Varicella-zoster vírus antitest"
    },
    "ltx|varicella_serology_igg": {
        id: "ltx|varicella_serology_igg",
        defaultMessage: "Varicella-zoster-vírus elleni antitest immunglobulin G"
    },
    "ltx|veno-venous_bypass": {
        id: "ltx|veno-venous_bypass",
        defaultMessage: "Veno-venous bypass"
    },
    "ltx|waiting_list_start_date": {
        id: "ltx|waiting_list_start_date",
        defaultMessage: "ET várólistára kerülés időpontja"
    },
    "ltx|weight": {
        id: "ltx|weight",
        defaultMessage: "Testsúly"
    },
    "snomed|1030791000000100": {
        id: "snomed|1030791000000100",
        defaultMessage: "Prosztata specifikus antigén szint (megfigyelhető entitás)"
    },
    "snomed|103306004": {
        id: "snomed|103306004",
        defaultMessage: "Ellenjavallat (kontextuális minősítő) (minősítő érték)"
    },
    "snomed|104305007": {
        id: "snomed|104305007",
        defaultMessage: "Toxoplasma faj antitest mérése (eljárás)"
    },
    "snomed|104321002": {
        id: "snomed|104321002",
        defaultMessage: "Humán herpesvírus 1 antitest mérése (eljárás)"
    },
    "snomed|104326007": {
        id: "snomed|104326007",
        defaultMessage: "Varicella-zoster vírus antitest mérése (eljárás)"
    },
    "snomed|105011006": {
        id: "snomed|105011006",
        defaultMessage: "Vér karbamid nitrogén mérése (eljárás)"
    },
    "snomed|109428005": {
        id: "snomed|109428005",
        defaultMessage: "Perimembranózus kamrai szeptum defektus betegség"
    },
    "snomed|111287006": {
        id: "snomed|111287006",
        defaultMessage: "Tricuspidalis billentyű regurgitáció (rendellenesség)"
    },
    "snomed|111289009": {
        id: "snomed|111289009",
        defaultMessage: "Tüdőerek arteriovenózus fisztula rendellenessége"
    },
    "snomed|111321007": {
        id: "snomed|111321007",
        defaultMessage: "Jobb oldali aorta ív rendellenesség"
    },
    "snomed|111323005": {
        id: "snomed|111323005",
        defaultMessage: "Teljes anomális pulmonális vénás visszatérés rendellenesség"
    },
    "snomed|1119418001": {
        id: "snomed|1119418001",
        defaultMessage: "Európai Vese Társaság-Európai Dialízis és Transzplantációs Társaság modul (alapvető metaadat koncepció)"
    },
    "snomed|112143006": {
        id: "snomed|112143006",
        defaultMessage: "ABO csoport fenotípus"
    },
    "snomed|113075003": {
        id: "snomed|113075003",
        defaultMessage: "Kreatinin mérés, szérum (eljárás)"
    },
    "snomed|1137687006": {
        id: "snomed|1137687006",
        defaultMessage: "Bal atrioventrikuláris (morfológiailag nem mitrális) billentyű regurgitációja (rendellenesség)"
    },
    "snomed|1141742009": {
        id: "snomed|1141742009",
        defaultMessage: "Jobb atrioventrikuláris (morfológiailag nem tricuspidális) billentyű regurgitációja (rendellenesség)"
    },
    "snomed|1142178009": {
        id: "snomed|1142178009",
        defaultMessage: "Súlyos akut légzőszervi szindróma koronavírus 2 antigént vagy hírvivő ribonukleinsavat tartalmazó vakcina termék (gyógyszer)"
    },
    "snomed|11614003": {
        id: "snomed|11614003",
        defaultMessage: "Tüdővénák veleszületett szűkülete rendellenesség"
    },
    "snomed|117010004": {
        id: "snomed|117010004",
        defaultMessage: "Vizelet tenyésztés (eljárás)"
    },
    "snomed|117028002": {
        id: "snomed|117028002",
        defaultMessage: "Széklet tenyésztés (eljárás)"
    },
    "snomed|117739006": {
        id: "snomed|117739006",
        defaultMessage: "Humán herpesvírus 2 antitest mérése (eljárás)"
    },
    "snomed|118227000": {
        id: "snomed|118227000",
        defaultMessage: "Vitális jelek leletek (lelet)"
    },
    "snomed|118433006": {
        id: "snomed|118433006",
        defaultMessage: "Pulmonális artéria ék nyomás (megfigyelhető entitás)"
    },
    "snomed|128178001": {
        id: "snomed|128178001",
        defaultMessage: "Testfelszín terület (test szerkezet)"
    },
    "snomed|129714008": {
        id: "snomed|129714008",
        defaultMessage: "Mammográfia lelet (lelet)"
    },
    "snomed|14482000": {
        id: "snomed|14482000",
        defaultMessage: "Jobb szubklavikuláris artéria anomális eredete rendellenesség"
    },
    "snomed|15096009": {
        id: "snomed|15096009",
        defaultMessage: "Pulmonális billentyű veleszületett elégtelensége rendellenesség"
    },
    "snomed|15167005": {
        id: "snomed|15167005",
        defaultMessage: "Alkohol visszaélés (rendellenesség)"
    },
    "snomed|15240007": {
        id: "snomed|15240007",
        defaultMessage: "Jelenlegi (minősítő érték)"
    },
    "snomed|16567006": {
        id: "snomed|16567006",
        defaultMessage: "Mesocardia rendellenesség"
    },
    "snomed|165994006": {
        id: "snomed|165994006",
        defaultMessage: "Minta szerológia (eljárás)"
    },
    "snomed|166324000": {
        id: "snomed|166324000",
        defaultMessage: "Szérum T3 mérés (eljárás)"
    },
    "snomed|166329005": {
        id: "snomed|166329005",
        defaultMessage: "Szérum T4 mérés (eljárás)"
    },
    "snomed|166704001": {
        id: "snomed|166704001",
        defaultMessage: "Szérum foszfát szint normális (lelet)"
    },
    "snomed|169069000": {
        id: "snomed|169069000",
        defaultMessage: "Mellkas CT vizsgálat"
    },
    "snomed|16972009": {
        id: "snomed|16972009",
        defaultMessage: "Aorta veleszületett aneurysmája rendellenesség"
    },
    "snomed|17024001": {
        id: "snomed|17024001",
        defaultMessage: "Aortopulmonális ablak rendellenesség"
    },
    "snomed|170337005": {
        id: "snomed|170337005",
        defaultMessage: "Pneumococcus védőoltás beadva (helyzet)"
    },
    "snomed|170865004": {
        id: "snomed|170865004",
        defaultMessage: "Nőgyógyászati rendellenesség monitorozása (kezelési séma/terápia)"
    },
    "snomed|170945005": {
        id: "snomed|170945005",
        defaultMessage: "Szembetegség monitorozása (kezelési séma/terápia)"
    },
    "snomed|171121004": {
        id: "snomed|171121004",
        defaultMessage: "Humán immundeficiencia vírus szűrés (eljárás)"
    },
    "snomed|17718000": {
        id: "snomed|17718000",
        defaultMessage: "Ostium primum defektus rendellenesség"
    },
    "snomed|177765008": {
        id: "snomed|177765008",
        defaultMessage: "Mellkas megnyitása (eljárás)"
    },
    "snomed|185283008": {
        id: "snomed|185283008",
        defaultMessage: "Szociális munkás által látva (lelet)"
    },
    "snomed|18546004": {
        id: "snomed|18546004",
        defaultMessage: "Aorta billentyű veleszületett szűkülete rendellenesség"
    },
    "snomed|187033005": {
        id: "snomed|187033005",
        defaultMessage: "Hepatitis C vírus mérése (eljárás)"
    },
    "snomed|19030005": {
        id: "snomed|19030005",
        defaultMessage: "Humán immundeficiencia vírus (mikroorganizmus)"
    },
    "snomed|19346006": {
        id: "snomed|19346006",
        defaultMessage: ""
    },
    "snomed|1951000175101": {
        id: "snomed|1951000175101",
        defaultMessage: "Nemzetközi normalizált arány (minősítő érték)"
    },
    "snomed|20135006": {
        id: "snomed|20135006",
        defaultMessage: "Szűrési eljárás (eljárás)"
    },
    "snomed|204296002": {
        id: "snomed|204296002",
        defaultMessage: "Diszkordáns ventrikuloarteriális kapcsolat rendellenesség"
    },
    "snomed|204312002": {
        id: "snomed|204312002",
        defaultMessage: "Kamrai szeptum defektus bal kamra és jobb pitvar között rendellenesség"
    },
    "snomed|204315000": {
        id: "snomed|204315000",
        defaultMessage: "Pitvari szeptum defektus ovális fossa-ban rendellenesség"
    },
    "snomed|204317008": {
        id: "snomed|204317008",
        defaultMessage: "Nyitott foramen ovale rendellenesség"
    },
    "snomed|204342004": {
        id: "snomed|204342004",
        defaultMessage: "Pulmonális billentyű veleszületett atresiája rendellenesség"
    },
    "snomed|204343009": {
        id: "snomed|204343009",
        defaultMessage: "Pulmonális billentyű hipopláziája rendellenesség"
    },
    "snomed|204357006": {
        id: "snomed|204357006",
        defaultMessage: "Tricuspidalis billentyű Ebstein-anomáliája rendellenesség"
    },
    "snomed|204370002": {
        id: "snomed|204370002",
        defaultMessage: "Jobb kamra infundibulum szűkülete rendellenesség"
    },
    "snomed|204456001": {
        id: "snomed|204456001",
        defaultMessage: "Szubdiafragmatikus teljes anomális pulmonális vénás visszatérés rendellenesség"
    },
    "snomed|204457005": {
        id: "snomed|204457005",
        defaultMessage: "Szupradiafragmatikus teljes anomális pulmonális vénás visszatérés rendellenesség"
    },
    "snomed|204460003": {
        id: "snomed|204460003",
        defaultMessage: "Anomális portális véna terminatio rendellenesség"
    },
    "snomed|204461004": {
        id: "snomed|204461004",
        defaultMessage: "Portális véna-hepatikus artéria fisztula rendellenesség"
    },
    "snomed|21111006": {
        id: "snomed|21111006",
        defaultMessage: ""
    },
    "snomed|218728005": {
        id: "snomed|218728005",
        defaultMessage: "Megszakított aorta ív rendellenesség"
    },
    "snomed|219006": {
        id: "snomed|219006",
        defaultMessage: "Alkohol jelenlegi fogyasztója (lelet)"
    },
    "snomed|224238005": {
        id: "snomed|224238005",
        defaultMessage: "Lakhatás várólistájának státusza"
    },
    "snomed|23063005": {
        id: "snomed|23063005",
        defaultMessage: "Mitrális billentyű veleszületett atresiája rendellenesség"
    },
    "snomed|233815004": {
        id: "snomed|233815004",
        defaultMessage: "Újszülött perzisztáló pulmonális hipertóniája rendellenesség"
    },
    "snomed|23901000087101": {
        id: "snomed|23901000087101",
        defaultMessage: "Hepatológiai szolgáltatás (minősítő érték)"
    },
    "snomed|241439007": {
        id: "snomed|241439007",
        defaultMessage: "Pozitron emisszós tomográfia szív vizsgálat (eljárás)"
    },
    "snomed|241547009": {
        id: "snomed|241547009",
        defaultMessage: "Számítógépes tomográfia szív (eljárás)"
    },
    "snomed|241620005": {
        id: "snomed|241620005",
        defaultMessage: "Mágneses rezonancia képalkotás szív (eljárás)"
    },
    "snomed|241686001": {
        id: "snomed|241686001",
        defaultMessage: "Kettős energia röntgen foton abszorpciometria (eljárás)"
    },
    "snomed|2425002": {
        id: "snomed|2425002",
        defaultMessage: "Epstein-Barr vírus szerológiai teszt (eljárás)"
    },
    "snomed|243806009": {
        id: "snomed|243806009",
        defaultMessage: "Kardiológiai teszt akció státusz szerint kategorizálva (navigációs koncepció)"
    },
    "snomed|248326004": {
        id: "snomed|248326004",
        defaultMessage: "Testmérés (megfigyelhető entitás)"
    },
    "snomed|250644007": {
        id: "snomed|250644007",
        defaultMessage: "Laktát-dehidrogenáz vér mérés (eljárás)"
    },
    "snomed|250768007": {
        id: "snomed|250768007",
        defaultMessage: "Pulmonális artéria szisztolés nyomás (megfigyelhető entitás)"
    },
    "snomed|250769004": {
        id: "snomed|250769004",
        defaultMessage: "Pulmonális artéria diasztolés nyomás (megfigyelhető entitás)"
    },
    "snomed|250770003": {
        id: "snomed|250770003",
        defaultMessage: "Pulmonális artéria átlagnyomás (megfigyelhető entitás)"
    },
    "snomed|250908004": {
        id: "snomed|250908004",
        defaultMessage: "Bal kamrai ejekciós frakció (megfigyelhető entitás)"
    },
    "snomed|250929008": {
        id: "snomed|250929008",
        defaultMessage: "Bal kamrai üreg mérete (megfigyelhető entitás)"
    },
    "snomed|250964004": {
        id: "snomed|250964004",
        defaultMessage: "Jobb kamrai üreg mérete (megfigyelhető entitás)"
    },
    "snomed|251086009": {
        id: "snomed|251086009",
        defaultMessage: "Pulmonális billentyű ventrikuloarteriális gradiens"
    },
    "snomed|251088005": {
        id: "snomed|251088005",
        defaultMessage: "Aorta billentyű ventrikuloarteriális gradiens (megfigyelhető entitás)"
    },
    "snomed|252407006": {
        id: "snomed|252407006",
        defaultMessage: "Treponema pallidum immobilizációs teszt (eljárás)"
    },
    "snomed|252478000": {
        id: "snomed|252478000",
        defaultMessage: "6 perces séta teszt (eljárás)"
    },
    "snomed|253269002": {
        id: "snomed|253269002",
        defaultMessage: "Keresztezett szív rendellenesség"
    },
    "snomed|253282005": {
        id: "snomed|253282005",
        defaultMessage: "Kettős beömlésű jobb kamra rendellenesség"
    },
    "snomed|253283000": {
        id: "snomed|253283000",
        defaultMessage: "Kettős beömlésű bal kamra rendellenesség"
    },
    "snomed|253285007": {
        id: "snomed|253285007",
        defaultMessage: "Hiányzó jobb oldali atrioventrikuláris kapcsolat rendellenesség"
    },
    "snomed|253290005": {
        id: "snomed|253290005",
        defaultMessage: "Hiányzó bal oldali atrioventrikuláris kapcsolat rendellenesség"
    },
    "snomed|253336000": {
        id: "snomed|253336000",
        defaultMessage: "Jobb pitvari fülcse izomerizmus rendellenesség"
    },
    "snomed|253337009": {
        id: "snomed|253337009",
        defaultMessage: "Bal pitvari fülcse izomerizmus rendellenesség"
    },
    "snomed|253378006": {
        id: "snomed|253378006",
        defaultMessage: "Átnyúló tricuspidális billentyű rendellenesség"
    },
    "snomed|253379003": {
        id: "snomed|253379003",
        defaultMessage: "Keresztező tricuspidális billentyű rendellenesség"
    },
    "snomed|253397006": {
        id: "snomed|253397006",
        defaultMessage: "Átnyúló mitrális billentyű rendellenesség"
    },
    "snomed|253399009": {
        id: "snomed|253399009",
        defaultMessage: "Keresztező mitrális billentyű rendellenesség"
    },
    "snomed|253416000": {
        id: "snomed|253416000",
        defaultMessage: "Atrioventrikuláris szeptum defektus: pitvari és kamrai komponensek rendellenesség"
    },
    "snomed|253536001": {
        id: "snomed|253536001",
        defaultMessage: "Bal kamrai hipoplázia rendellenesség"
    },
    "snomed|253550006": {
        id: "snomed|253550006",
        defaultMessage: "Többszörös kamrai szeptum defektusok rendellenesség"
    },
    "snomed|253638007": {
        id: "snomed|253638007",
        defaultMessage: "Bal pulmonális artéria anomális eredete jobb pulmonális artériából rendellenesség"
    },
    "snomed|253689007": {
        id: "snomed|253689007",
        defaultMessage: "Főbb aortopulmonális kollaterális artéria rendellenesség"
    },
    "snomed|26201005": {
        id: "snomed|26201005",
        defaultMessage: "Aorta bal kamrai alagút rendellenesség"
    },
    "snomed|265550007": {
        id: "snomed|265550007",
        defaultMessage: "Transzplantáció nefrektómia (eljárás)"
    },
    "snomed|26758005": {
        id: "snomed|26758005",
        defaultMessage: "Albumin mérés (eljárás)"
    },
    "snomed|268180007": {
        id: "snomed|268180007",
        defaultMessage: "Jobb hipoplasztikus szív szindróma rendellenesség"
    },
    "snomed|268185002": {
        id: "snomed|268185002",
        defaultMessage: "Szupravalváris aorta stenosis rendellenesség"
    },
    "snomed|268187005": {
        id: "snomed|268187005",
        defaultMessage: "Veleszületett pulmonális artéria aneurysma rendellenesség"
    },
    "snomed|26865008": {
        id: "snomed|26865008",
        defaultMessage: "Felső vena cava veleszületett hiánya rendellenesség"
    },
    "snomed|26958001": {
        id: "snomed|26958001",
        defaultMessage: "Májfunkció panel (eljárás)"
    },
    "snomed|271240001": {
        id: "snomed|271240001",
        defaultMessage: "Szérum kalcium mérés (eljárás)"
    },
    "snomed|271432005": {
        id: "snomed|271432005",
        defaultMessage: "Veleszületett vese artéria stenosis rendellenesség"
    },
    "snomed|271649006": {
        id: "snomed|271649006",
        defaultMessage: "Szisztolés vérnyomás (megfigyelhető entitás)"
    },
    "snomed|271650006": {
        id: "snomed|271650006",
        defaultMessage: "Diasztolés vérnyomás (megfigyelhető entitás)"
    },
    "snomed|27317008": {
        id: "snomed|27317008",
        defaultMessage: "Teljes transzpozíció morfológiai rendellenesség"
    },
    "snomed|27637000": {
        id: "snomed|27637000",
        defaultMessage: "Dextrocardia rendellenesség"
    },
    "snomed|276756009": {
        id: "snomed|276756009",
        defaultMessage: "Jobb kamrai nyomás (megfigyelhető entitás)"
    },
    "snomed|276772001": {
        id: "snomed|276772001",
        defaultMessage: "Jobb kamrai szisztolés nyomás (megfigyelhető entitás)"
    },
    "snomed|276773006": {
        id: "snomed|276773006",
        defaultMessage: "Jobb kamrai diasztolés nyomás (megfigyelhető entitás)"
    },
    "snomed|276901002": {
        id: "snomed|276901002",
        defaultMessage: "Pulmonális vaszkuláris rezisztencia (megfigyelhető entitás)"
    },
    "snomed|281789004": {
        id: "snomed|281789004",
        defaultMessage: "Antibiotikus terápia (eljárás)"
    },
    "snomed|282036005": {
        id: "snomed|282036005",
        defaultMessage: "Veleszületett artériás aneurysma rendellenesség"
    },
    "snomed|28574005": {
        id: "snomed|28574005",
        defaultMessage: "Koszorúér veleszületett anomáliája rendellenesség"
    },
    "snomed|286071000119109": {
        id: "snomed|286071000119109",
        defaultMessage: "Veleszületett perifériás pulmonális artéria stenosis rendellenesség"
    },
    "snomed|28656008": {
        id: "snomed|28656008",
        defaultMessage: "Aorta billentyű veleszületett elégtelensége rendellenesség"
    },
    "snomed|29738008": {
        id: "snomed|29738008",
        defaultMessage: "Proteinuria (lelet)"
    },
    "snomed|29928006": {
        id: "snomed|29928006",
        defaultMessage: "Mitrális billentyű veleszületett elégtelensége rendellenesség"
    },
    "snomed|29934004": {
        id: "snomed|29934004",
        defaultMessage: "Anomális pulmonális vénás drenázs koronária sinusba rendellenesség"
    },
    "snomed|30200007": {
        id: "snomed|30200007",
        defaultMessage: "Citomegalovírus szerológiai teszt (eljárás)"
    },
    "snomed|305634004": {
        id: "snomed|305634004",
        defaultMessage: "Aneszteziológus által látva (lelet)"
    },
    "snomed|305635003": {
        id: "snomed|305635003",
        defaultMessage: "Klinikai onkológus által látva (lelet)"
    },
    "snomed|305657005": {
        id: "snomed|305657005",
        defaultMessage: "Hematológus által látva (lelet)"
    },
    "snomed|305666009": {
        id: "snomed|305666009",
        defaultMessage: "Klinikai immunológus által látva (lelet)"
    },
    "snomed|305671002": {
        id: "snomed|305671002",
        defaultMessage: "Endokrinológus által látva (lelet)"
    },
    "snomed|305672009": {
        id: "snomed|305672009",
        defaultMessage: "Gasztroenterológus által látva (lelet)"
    },
    "snomed|305674005": {
        id: "snomed|305674005",
        defaultMessage: "Genetikus által látva (lelet)"
    },
    "snomed|305683000": {
        id: "snomed|305683000",
        defaultMessage: "Nefrológus által látva (lelet)"
    },
    "snomed|305688009": {
        id: "snomed|305688009",
        defaultMessage: "Reumatológus által látva (lelet)"
    },
    "snomed|305701006": {
        id: "snomed|305701006",
        defaultMessage: "Radiológus által látva (lelet)"
    },
    "snomed|305710003": {
        id: "snomed|305710003",
        defaultMessage: "Fül-orr-gégész sebész által látva (lelet)"
    },
    "snomed|305729009": {
        id: "snomed|305729009",
        defaultMessage: "Urológus által látva (lelet)"
    },
    "snomed|305730004": {
        id: "snomed|305730004",
        defaultMessage: "Érsebész által látva (lelet)"
    },
    "snomed|307280005": {
        id: "snomed|307280005",
        defaultMessage: "Szívritmus-szabályozó beültetése (eljárás)"
    },
    "snomed|308118002": {
        id: "snomed|308118002",
        defaultMessage: "Szívelégtelenség terápia (eljárás)"
    },
    "snomed|312468003": {
        id: "snomed|312468003",
        defaultMessage: "Vér kálium mérés (eljárás)"
    },
    "snomed|312469006": {
        id: "snomed|312469006",
        defaultMessage: "Vér nátrium mérés (eljárás)"
    },
    "snomed|313500004": {
        id: "snomed|313500004",
        defaultMessage: "Vizelet fehérje/kreatinin arány mérés (eljárás)"
    },
    "snomed|313587003": {
        id: "snomed|313587003",
        defaultMessage: "Varicella-zoster vírus antitest immunoglobulin G mérés (eljárás)"
    },
    "snomed|313604004": {
        id: "snomed|313604004",
        defaultMessage: "Citomegalovírus immunoglobulin G antitest mérés (eljárás)"
    },
    "snomed|313954007": {
        id: "snomed|313954007",
        defaultMessage: "Epstein-Barr vírus nukleáris immunoglobulin G mérés (eljárás)"
    },
    "snomed|315053001": {
        id: "snomed|315053001",
        defaultMessage: "Sztatin terápia"
    },
    "snomed|315199001": {
        id: "snomed|315199001",
        defaultMessage: "Toxoplasma immunoglobulin G szint (eljárás)"
    },
    "snomed|33367005": {
        id: "snomed|33367005",
        defaultMessage: "Koronária angiográfia (eljárás)"
    },
    "snomed|33747003": {
        id: "snomed|33747003",
        defaultMessage: "Glükóz mérés, vér (eljárás)"
    },
    "snomed|34043003": {
        id: "snomed|34043003",
        defaultMessage: "Fogászati konzultáció és jelentés (eljárás)"
    },
    "snomed|34608000": {
        id: "snomed|34608000",
        defaultMessage: "Alanin aminotranszferáz mérés (eljárás)"
    },
    "snomed|3545003": {
        id: "snomed|3545003",
        defaultMessage: "Diasztolés diszfunkció (lelet)"
    },
    "snomed|359986008": {
        id: "snomed|359986008",
        defaultMessage: "Bilirubin, teljes mérés (eljárás)"
    },
    "snomed|36233006": {
        id: "snomed|36233006",
        defaultMessage: "Tricuspidalis billentyű veleszületett szűkülete rendellenesség"
    },
    "snomed|363783003": {
        id: "snomed|363783003",
        defaultMessage: "Rh vércsoport tipizálás"
    },
    "snomed|363808001": {
        id: "snomed|363808001",
        defaultMessage: "Mért testsúly (megfigyelhető entitás)"
    },
    "snomed|364075005": {
        id: "snomed|364075005",
        defaultMessage: "Szívfrekvencia (megfigyelhető entitás)"
    },
    "snomed|365636006": {
        id: "snomed|365636006",
        defaultMessage: "Vércsoport lelet"
    },
    "snomed|365809007": {
        id: "snomed|365809007",
        defaultMessage: "Hemoglobin koncentráció"
    },
    "snomed|365981007": {
        id: "snomed|365981007",
        defaultMessage: "Dohányzási viselkedés lelet (lelet)"
    },
    "snomed|371534008": {
        id: "snomed|371534008",
        defaultMessage: "Összefoglaló jelentés (dokumentum artifact)"
    },
    "snomed|372603003": {
        id: "snomed|372603003",
        defaultMessage: "Aldoszteron receptor antagonista hatásmechanizmusú anyag (anyag)"
    },
    "snomed|372695000": {
        id: "snomed|372695000",
        defaultMessage: "Diuretikum (anyag)"
    },
    "snomed|372733002": {
        id: "snomed|372733002",
        defaultMessage: "Angiotenzin-konvertáló enzim gátló hatásmechanizmusú anyag (anyag)"
    },
    "snomed|372813008": {
        id: "snomed|372813008",
        defaultMessage: "Antiaritmiás szer (anyag)"
    },
    "snomed|372862008": {
        id: "snomed|372862008",
        defaultMessage: "Antikoaguláns (anyag)"
    },
    "snomed|372913009": {
        id: "snomed|372913009",
        defaultMessage: "Angiotenzin II receptor antagonista hatásmechanizmusú anyag (anyag)"
    },
    "snomed|373254001": {
        id: "snomed|373254001",
        defaultMessage: "Béta adrenerg receptor antagonista hatásmechanizmusú anyag (anyag)"
    },
    "snomed|386100006": {
        id: "snomed|386100006",
        defaultMessage: "Vizelet üledék (anyag)"
    },
    "snomed|387135004": {
        id: "snomed|387135004",
        defaultMessage: "Allopurinol (anyag)"
    },
    "snomed|387145002": {
        id: "snomed|387145002",
        defaultMessage: "Dobutamin (anyag)"
    },
    "snomed|387521006": {
        id: "snomed|387521006",
        defaultMessage: "Digitálisz (anyag)"
    },
    "snomed|38804009": {
        id: "snomed|38804009",
        defaultMessage: ""
    },
    "snomed|39031000119103": {
        id: "snomed|39031000119103",
        defaultMessage: "Vírusos hepatitis B védőoltás beadva (helyzet)"
    },
    "snomed|390842003": {
        id: "snomed|390842003",
        defaultMessage: "Diabetológus által látva (lelet)"
    },
    "snomed|39361000119108": {
        id: "snomed|39361000119108",
        defaultMessage: "Meningococcus védőoltás beadva (helyzet)"
    },
    "snomed|394719009": {
        id: "snomed|394719009",
        defaultMessage: "Carotis artéria doppler vizsgálat (eljárás)"
    },
    "snomed|395043005": {
        id: "snomed|395043005",
        defaultMessage: "Szérum prealbumin szint (eljárás)"
    },
    "snomed|39589002": {
        id: "snomed|39589002",
        defaultMessage: "Jobb szív hipopláziája rendellenesség"
    },
    "snomed|396550006": {
        id: "snomed|396550006",
        defaultMessage: "Vérvizsgálat (eljárás)"
    },
    "snomed|39748002": {
        id: "snomed|39748002",
        defaultMessage: "Bilirubin, direkt mérés (eljárás)"
    },
    "snomed|399023006": {
        id: "snomed|399023006",
        defaultMessage: "Jobb kamrai csúcs szisztolés nyomás (megfigyelhető entitás)"
    },
    "snomed|399046008": {
        id: "snomed|399046008",
        defaultMessage: "L transzpozíció nagy erek rendellenesség"
    },
    "snomed|399208008": {
        id: "snomed|399208008",
        defaultMessage: "Egyszerű mellkas röntgen (eljárás)"
    },
    "snomed|399216004": {
        id: "snomed|399216004",
        defaultMessage: "D transzpozíció nagy erek rendellenesség"
    },
    "snomed|401061005": {
        id: "snomed|401061005",
        defaultMessage: "Mentálhigiénés vizsgálat (eljárás)"
    },
    "snomed|401221002": {
        id: "snomed|401221002",
        defaultMessage: "Boka-kar nyomás index (eljárás)"
    },
    "snomed|40272001": {
        id: "snomed|40272001",
        defaultMessage: "Koronária sinus veleszületett hiánya rendellenesség"
    },
    "snomed|405752007": {
        id: "snomed|405752007",
        defaultMessage: "Veleszületett pitvari szeptum defektus rendellenesség"
    },
    "snomed|40701008": {
        id: "snomed|40701008",
        defaultMessage: "Echokardiográfia (eljárás)"
    },
    "snomed|408218006": {
        id: "snomed|408218006",
        defaultMessage: "Herpes simplex immunoglobulin G szint mérés (eljárás)"
    },
    "snomed|408864009": {
        id: "snomed|408864009",
        defaultMessage: "Védőoltási státusz (megfigyelhető entitás)"
    },
    "snomed|410006001": {
        id: "snomed|410006001",
        defaultMessage: "Végbél digitális vizsgálata (eljárás)"
    },
    "snomed|41040004": {
        id: "snomed|41040004",
        defaultMessage: ""
    },
    "snomed|410513005": {
        id: "snomed|410513005",
        defaultMessage: "A múltban (minősítő érték)"
    },
    "snomed|412383006": {
        id: "snomed|412383006",
        defaultMessage: "Dopamin (anyag)"
    },
    "snomed|41371000119100": {
        id: "snomed|41371000119100",
        defaultMessage: "Shone komplex rendellenesség"
    },
    "snomed|414285001": {
        id: "snomed|414285001",
        defaultMessage: "Ételre allergia (lelet)"
    },
    "snomed|41514002": {
        id: "snomed|41514002",
        defaultMessage: "Veleszületett szupravalváris mitrális stenosis rendellenesség"
    },
    "snomed|416683003": {
        id: "snomed|416683003",
        defaultMessage: "Sürgősségi kórházi felvétel szívelégtelenség miatt (eljárás)"
    },
    "snomed|421228002": {
        id: "snomed|421228002",
        defaultMessage: "Ivabradin (hatóanyag)"
    },
    "snomed|43396009": {
        id: "snomed|43396009",
        defaultMessage: "Hemoglobin A1c mérés (eljárás)"
    },
    "snomed|43941000119105": {
        id: "snomed|43941000119105",
        defaultMessage: "Vírusos hepatitis A védőoltás beadva (helyzet)"
    },
    "snomed|440614003": {
        id: "snomed|440614003",
        defaultMessage: "Hüvely mintavétel Papanicolaou kenethez (eljárás)"
    },
    "snomed|442349007": {
        id: "snomed|442349007",
        defaultMessage: "Vénás oxigén saturáció (megfigyelhető entitás)"
    },
    "snomed|442516004": {
        id: "snomed|442516004",
        defaultMessage: "Rejtett vér mérése három külön székletmintában (eljárás)"
    },
    "snomed|44277000": {
        id: "snomed|44277000",
        defaultMessage: "Vesefunkció vizsgálat (navigációs koncepció)"
    },
    "snomed|442795003": {
        id: "snomed|442795003",
        defaultMessage: "Levosimendan (anyag)"
    },
    "snomed|444562008": {
        id: "snomed|444562008",
        defaultMessage: "Preoperatív tüdővizsgálat (eljárás)"
    },
    "snomed|445208002": {
        id: "snomed|445208002",
        defaultMessage: "Jobb pulmonális artéria veleszületett hipopláziája rendellenesség"
    },
    "snomed|4452090051": {
        id: "snomed|4452090051",
        defaultMessage: "Bal pulmonális artéria veleszületett hipopláziája rendellenesség"
    },
    "snomed|445928005": {
        id: "snomed|445928005",
        defaultMessage: "Eisenmenger szindróma rendellenesség"
    },
    "snomed|44622003": {
        id: "snomed|44622003",
        defaultMessage: "Köldökartéria veleszületett hipopláziája rendellenesség"
    },
    "snomed|447113005": {
        id: "snomed|447113005",
        defaultMessage: "12 elvezetéses EKG nyugalomban (eljárás)"
    },
    "snomed|447346005": {
        id: "snomed|447346005",
        defaultMessage: "Kardiopulmonális terheléses teszt (eljárás)"
    },
    "snomed|448096002": {
        id: "snomed|448096002",
        defaultMessage: "Bal szubklavikuláris artéria aberráns eredete rendellenesség"
    },
    "snomed|448477005": {
        id: "snomed|448477005",
        defaultMessage: "Felső-alsó kamrai kapcsolat rendellenesség"
    },
    "snomed|448876006": {
        id: "snomed|448876006",
        defaultMessage: "Szubartériás kamrai szeptum defektus rendellenesség"
    },
    "snomed|449135007": {
        id: "snomed|449135007",
        defaultMessage: "Mitrális szubvalváris apparátus veleszületett szűkülete rendellenesség"
    },
    "snomed|45036003": {
        id: "snomed|45036003",
        defaultMessage: "Hasi ultrahang (eljárás)"
    },
    "snomed|45237002": {
        id: "snomed|45237002",
        defaultMessage: "Aorta veleszületett tágulata rendellenesség"
    },
    "snomed|45896001": {
        id: "snomed|45896001",
        defaultMessage: "Aszpartát aminotranszferáz mérés (eljárás)"
    },
    "snomed|47758006": {
        id: "snomed|47758006",
        defaultMessage: "Hepatitis B felszíni antigén mérés (eljárás)"
    },
    "snomed|48724000": {
        id: "snomed|48724000",
        defaultMessage: "Mitrális billentyű regurgitáció (rendellenesség)"
    },
    "snomed|49601007": {
        id: "snomed|49601007",
        defaultMessage: "Kardiovaszkuláris rendszer rendellenessége (rendellenesség)"
    },
    "snomed|50373000": {
        id: "snomed|50373000",
        defaultMessage: "Testmagasság mérés (megfigyelhető entitás)"
    },
    "snomed|50506008": {
        id: "snomed|50506008",
        defaultMessage: "Hepatitis B mag antitest mérés, immunoglobulin M típus (eljárás)"
    },
    "snomed|50684000": {
        id: "snomed|50684000",
        defaultMessage: "Pszeudokolineszteráz mérés"
    },
    "snomed|51442005": {
        id: "snomed|51442005",
        defaultMessage: "Aorta billentyű veleszületett atresiája rendellenesség"
    },
    "snomed|51500006": {
        id: "snomed|51500006",
        defaultMessage: ""
    },
    "snomed|54247002": {
        id: "snomed|54247002",
        defaultMessage: "Felszálló aorta szerkezet (test szerkezet)"
    },
    "snomed|54555005": {
        id: "snomed|54555005",
        defaultMessage: "Hepatitis B mag antitest mérés, immunoglobulin G típus (eljárás)"
    },
    "snomed|54993008": {
        id: "snomed|54993008",
        defaultMessage: "Szívindex (megfigyelhető entitás)"
    },
    "snomed|55235003": {
        id: "snomed|55235003",
        defaultMessage: "C-reaktív fehérje mérés (eljárás)"
    },
    "snomed|55510008": {
        id: "snomed|55510008",
        defaultMessage: "Cor triatriatum rendellenesség"
    },
    "snomed|60234000": {
        id: "snomed|60234000",
        defaultMessage: "Aorta billentyű regurgitáció (rendellenesség)"
    },
    "snomed|60621009": {
        id: "snomed|60621009",
        defaultMessage: "Testtömegindex (megfigyelhető entitás)"
    },
    "snomed|60787001": {
        id: "snomed|60787001",
        defaultMessage: "Aorta ív veleszületett hipopláziája rendellenesség"
    },
    "snomed|61167004": {
        id: "snomed|61167004",
        defaultMessage: "Pajzsmirigy-stimuláló hormon mérés (eljárás)"
    },
    "snomed|61928009": {
        id: "snomed|61928009",
        defaultMessage: "Thrombocyta szám (eljárás)"
    },
    "snomed|61959006": {
        id: "snomed|61959006",
        defaultMessage: "Közös truncus arteriosus rendellenesség"
    },
    "snomed|62067003": {
        id: "snomed|62067003",
        defaultMessage: "Hipoplasztikus bal szív szindróma rendellenesség"
    },
    "snomed|62889000": {
        id: "snomed|62889000",
        defaultMessage: "Hepatitis B vírus mérés (eljárás)"
    },
    "snomed|62944002": {
        id: "snomed|62944002",
        defaultMessage: "Hepatitis C vírus (mikroorganizmus)"
    },
    "snomed|63042009": {
        id: "snomed|63042009",
        defaultMessage: "Tricuspidalis billentyű veleszületett atresiája rendellenesség"
    },
    "snomed|63247009": {
        id: "snomed|63247009",
        defaultMessage: ""
    },
    "snomed|63476009": {
        id: "snomed|63476009",
        defaultMessage: "Prosztata specifikus antigén mérés (eljárás)"
    },
    "snomed|64253000": {
        id: "snomed|64253000",
        defaultMessage: "Szívsegéd rendszer beültetése (eljárás)"
    },
    "snomed|65677008": {
        id: "snomed|65677008",
        defaultMessage: "Pulmonális katéterezés Swan-Ganz katéterrel (eljárás)"
    },
    "snomed|65911000": {
        id: "snomed|65911000",
        defaultMessage: "Hepatitis B felszíni antitest mérés (eljárás)"
    },
    "snomed|66403007": {
        id: "snomed|66403007",
        defaultMessage: "Aorta vaszkuláris gyűrű rendellenesség"
    },
    "snomed|67278007": {
        id: "snomed|67278007",
        defaultMessage: "Pulmonális billentyű veleszületett szűkülete rendellenesség"
    },
    "snomed|68237008": {
        id: "snomed|68237008",
        defaultMessage: "Részleges anomális pulmonális vénás kapcsolat rendellenesség"
    },
    "snomed|69480007": {
        id: "snomed|69480007",
        defaultMessage: "Gamma glutamil transzferáz mérés (eljárás)"
    },
    "snomed|70195006": {
        id: "snomed|70195006",
        defaultMessage: "Felső vena cava veleszületett anomáliája rendellenesség"
    },
    "snomed|703385008": {
        id: "snomed|703385008",
        defaultMessage: "Pulmonális artéria anomális eredete felszálló aortából rendellenesség"
    },
    "snomed|707371002": {
        id: "snomed|707371002",
        defaultMessage: "Bal pulmonális artéria veleszületett szűkülete rendellenesség"
    },
    "snomed|707372009": {
        id: "snomed|707372009",
        defaultMessage: "Jobb pulmonális artéria veleszületett szűkülete rendellenesség"
    },
    "snomed|709549003": {
        id: "snomed|709549003",
        defaultMessage: "Egyfoton emisszós számítógépes tomográfia szív (eljárás)"
    },
    "snomed|711047004": {
        id: "snomed|711047004",
        defaultMessage: "Preoperatív neurológiai státusz értékelése (eljárás)"
    },
    "snomed|712756001": {
        id: "snomed|712756001",
        defaultMessage: "Vazoreaktivitás teszt (eljárás)"
    },
    "snomed|713127001": {
        id: "snomed|713127001",
        defaultMessage: "Alkoholfogyasztás értékelése (eljárás)"
    },
    "snomed|71420008": {
        id: "snomed|71420008",
        defaultMessage: "Centrális vénás nyomás (megfigyelhető entitás)"
    },
    "snomed|716579001": {
        id: "snomed|716579001",
        defaultMessage: "Kiindulási szisztolés vérnyomás (megfigyelhető entitás)"
    },
    "snomed|7169009": {
        id: "snomed|7169009",
        defaultMessage: "Veleszületett szupravalváris aorta stenosis rendellenesség"
    },
    "snomed|723279008": {
        id: "snomed|723279008",
        defaultMessage: "Vazodilatáció után (minősítő érték)"
    },
    "snomed|7246002": {
        id: "snomed|7246002",
        defaultMessage: "Vese biopszia (eljárás)"
    },
    "snomed|72904005": {
        id: "snomed|72904005",
        defaultMessage: "Treponema pallidum (mikroorganizmus)"
    },
    "snomed|7305005": {
        id: "snomed|7305005",
        defaultMessage: "Aorta coarctatio rendellenesség"
    },
    "snomed|73660006": {
        id: "snomed|73660006",
        defaultMessage: "Veleszületett szubaortikus stenosis rendellenesség"
    },
    "snomed|7368005": {
        id: "snomed|7368005",
        defaultMessage: "Kettős kiáramlású bal kamra rendellenesség"
    },
    "snomed|73701000119109": {
        id: "snomed|73701000119109",
        defaultMessage: "Influenza védőoltás beadva (helyzet)"
    },
    "snomed|73761001": {
        id: "snomed|73761001",
        defaultMessage: "Kolonoszkópia (eljárás)"
    },
    "snomed|74427007": {
        id: "snomed|74427007",
        defaultMessage: "Légzési hányados (megfigyelhető entitás)"
    },
    "snomed|74732009": {
        id: "snomed|74732009",
        defaultMessage: "Pszichiátriai rendellenesség"
    },
    "snomed|7484005": {
        id: "snomed|7484005",
        defaultMessage: "Kettős kiáramlású jobb kamra rendellenesség"
    },
    "snomed|75398000": {
        id: "snomed|75398000",
        defaultMessage: "Koronária artéria anomális eredete rendellenesség"
    },
    "snomed|762994006": {
        id: "snomed|762994006",
        defaultMessage: "New York Szív Társaság Osztályozás osztály (megfigyelhető entitás)"
    },
    "snomed|767002": {
        id: "snomed|767002",
        defaultMessage: "Fehérvérsejt szám (eljárás)"
    },
    "snomed|767263007": {
        id: "snomed|767263007",
        defaultMessage: "DiGeorge szindróma"
    },
    "snomed|768552007": {
        id: "snomed|768552007",
        defaultMessage: "Veleszületett kamrai szeptum defektus rendellenesség"
    },
    "snomed|76899008": {
        id: "snomed|76899008",
        defaultMessage: "Fertőző betegségek szakorvosa (foglalkozás)"
    },
    "snomed|771452004": {
        id: "snomed|771452004",
        defaultMessage: "Thrombocyta aggregáció gátló hatásmechanizmusú anyag (anyag)"
    },
    "snomed|77465005": {
        id: "snomed|77465005",
        defaultMessage: "Transzplantáció (eljárás)"
    },
    "snomed|777480008": {
        id: "snomed|777480008",
        defaultMessage: "Csak sakubitril és valsartan tartalmú termék (gyógyszer)"
    },
    "snomed|77978002": {
        id: "snomed|77978002",
        defaultMessage: "Perzisztáló bal felső vena cava rendellenesség"
    },
    "snomed|7928001": {
        id: "snomed|7928001",
        defaultMessage: "Test oxigén fogyasztás (megfigyelhető entitás)"
    },
    "snomed|80274001": {
        id: "snomed|80274001",
        defaultMessage: "Glomeruláris filtrációs ráta (megfigyelhető entitás)"
    },
    "snomed|8128003": {
        id: "snomed|8128003",
        defaultMessage: "Aorta gyök"
    },
    "snomed|81577001": {
        id: "snomed|81577001",
        defaultMessage: "Alsó vena cava veleszületett anomáliája rendellenesség"
    },
    "snomed|82458004": {
        id: "snomed|82458004",
        defaultMessage: "Mitrális billentyű veleszületett szűkülete rendellenesség"
    },
    "snomed|82799009": {
        id: "snomed|82799009",
        defaultMessage: "Szívteljesítmény (megfigyelhető entitás)"
    },
    "snomed|83119008": {
        id: "snomed|83119008",
        defaultMessage: "Tricuspidalis billentyű veleszületett elégtelensége rendellenesség"
    },
    "snomed|83330001": {
        id: "snomed|83330001",
        defaultMessage: "Nyitott ductus arteriosus rendellenesség"
    },
    "snomed|83799000": {
        id: "snomed|83799000",
        defaultMessage: "Nagy erek korrigált transzpozíciója rendellenesség"
    },
    "snomed|838333005": {
        id: "snomed|838333005",
        defaultMessage: "Mitrális billentyű atresia hiányzó atrioventrikuláris kapcsolattal rendellenesség"
    },
    "snomed|86299006": {
        id: "snomed|86299006",
        defaultMessage: "Fallot tetralogia rendellenesség"
    },
    "snomed|871620008": {
        id: "snomed|871620008",
        defaultMessage: "Perimembranózus beáramlási kamrai szeptum defektus rendellenesség"
    },
    "snomed|871625003": {
        id: "snomed|871625003",
        defaultMessage: "Köztes atrioventrikuláris szeptum defektus pitvari és kamrai komponensekkel és külön atrioventrikuláris billentyűkkel rendellenesség"
    },
    "snomed|871655005": {
        id: "snomed|871655005",
        defaultMessage: "Tricuspidalis atresia hiányzó jobb atrioventrikuláris kapcsolattal rendellenesség"
    },
    "snomed|880037003": {
        id: "snomed|880037003",
        defaultMessage: "Bal szívkamra szerzett aneurysmája (rendellenesség)"
    },
    "snomed|88810008": {
        id: "snomed|88810008",
        defaultMessage: "Alkalikus foszfatáz mérés (eljárás)"
    },
    "snomed|89780004": {
        id: "snomed|89780004",
        defaultMessage: "Kombinált (minősítő érték)"
    },
    "snomed|93237004": {
        id: "snomed|93237004",
        defaultMessage: "Aorta billentyű veleszületett hipopláziája rendellenesség"
    },
    "snomed|93271008": {
        id: "snomed|93271008",
        defaultMessage: "Mitrális billentyű veleszületett hipopláziája rendellenesség"
    },
    "snomed|94706008": {
        id: "snomed|94706008",
        defaultMessage: "Izmos kamrai szeptum defektus rendellenesség"
    },
    "snomed|95268002": {
        id: "snomed|95268002",
        defaultMessage: "Sinus venosus pitvari szeptum defektus rendellenesség"
    },
    "snomed|99501000119107": {
        id: "snomed|99501000119107",
        defaultMessage: "Humán papilloma vírus védőoltás beadva (helyzet)"
    },
    "srtr|can_hgt_cm": {
        id: "srtr|can_hgt_cm",
        defaultMessage: "Testmagasság"
    },
    "srtr|can_most_recent_wgt_kg7": {
        id: "srtr|can_most_recent_wgt_kg7",
        defaultMessage: "Testsúly"
    }
};
